// ============================================================================
// JAMB Question Bank — English
// Auto-split from QB.js for better code organisation
// ============================================================================

export const QB_ENGLISH = [


    {
      yr: 2015,
      q: 'The choice of a career should be a ______ decision, not a matter of chance.',
      o: ['deliberate', 'spontaneous', 'calculated', 'desirable'],
      a: 0,
      e: '"Deliberate" describes an action done consciously and intentionally, which fits the context of career choice.',
      full: 'The sentence contrasts a specific type of decision with one made by "chance."\nOption A (deliberate) means done on purpose or intentional.\nOption B (spontaneous) means sudden and unplanned, which is similar to "chance."\nOption C (calculated) usually implies a cold, mathematical risk assessment, whereas "deliberate" is the standard term for intentional life choices.\nOption D (desirable) refers to how much one wants something, not how the decision was made.',
      h: 'What word describes a choice made with careful thought and intention?',
    },
    {
      yr: 2015,
      q: 'The workers are ______ on strike since last week.',
      o: ['going', 'gone', 'been', 'being'],
      a: 2,
      e: 'The phrase "have been" (often contracted) is required to show an action that started in the past and continues to the present.',
      full: 'This question tests the Present Perfect Continuous tense.\nBecause the sentence includes "since last week," we need a verb form that connects the past to now.\nWhile the "have" is implied or omitted in informal speech, "been" (Option C) is the only participle that fits the auxiliary "have" to form "have been on strike."\n"Going" and "being" do not fit the timeline established by "since."',
      h: 'Which form of the verb "to be" follows "have" to show a continuous state from the past?',
    },
    {
      yr: 2015,
      q: 'The principal warned the students not to _____ their chances of success by being lazy.',
      o: ['jeopardize', 'compromise', 'damage', 'destroy'],
      a: 0,
      e: '"Jeopardize" means to put something (like a chance or a goal) into a situation in which there is a danger of loss or failure.',
      full: 'In formal English, especially regarding opportunities, "jeopardize" is the most appropriate verb.\nOption A (jeopardize) specifically refers to putting a future possibility at risk.\nOption B (compromise) can mean to weaken, but often implies a concession of principles.\nOption C and D (damage/destroy) are more physical or final than what is typically used for "chances."',
      h: 'Which word is a synonym for "endanger" or "risk"?',
    },
    {
      yr: 2015,
      q: 'Choose the word that is OPPOSITE in meaning to the underlined: The manager was <u>effusive</u> in his praise for the new employee.',
      o: ['loud', 'excessive', 'reserved', 'emotional'],
      a: 2,
      e: '"Effusive" means showing much emotion; "reserved" is the opposite, meaning keeping one\'s feelings hidden.',
      full: 'To be "effusive" (Option B is a synonym) is to be unrestrained in showing feelings of gratitude or approval.\nSince we are looking for the OPPOSITE (Antonym):\nOption C (reserved) describes someone who is self-restrained and does not show much emotion.\nOption A (loud) and D (emotional) are closer to synonyms than antonyms.',
      h: 'If someone is overflowing with praise, what would someone who is very quiet and restrained be?',
    },
    {
      yr: 2015,
      q: 'Choose the word that is OPPOSITE in meaning to the underlined: The witness gave a <u>lucid</u> account of the accident.',
      o: ['clear', 'vague', 'detailed', 'coherent'],
      a: 1,
      e: '"Lucid" means clear and easy to understand; "vague" means unclear or imprecise.',
      full: 'This is a vocabulary test focusing on antonyms.\n"Lucid" (from the Latin "lux" meaning light) means bright, clear, or easy to follow.\nOption B (vague) is the opposite, describing something that lacks detail or clarity.\nOptions A, C, and D are all characteristics of a "lucid" account.',
      h: 'If something is easy to see or understand, what is the word for something that is blurry or unclear?',
    },
    {
      yr: 2016,
      q: 'The students were advised to _____ the instructions before starting the exam.',
      o: ['peruse', 'pore', 'glance', 'stare'],
      a: 0,
      e: '"Peruse" means to read through something thoroughly or carefully.',
      full: 'In an exam context, teachers want you to read everything carefully.\nOption A (peruse) is the formal verb for reading in detail.\nOption B (pore) usually requires "over" (pore over) to be grammatically correct.\nOption C (glance) means to look quickly, which is bad advice for an exam.\nOption D (stare) means to look fixedly, which doesn\'t involve reading.',
      h: 'Which word means to read carefully from beginning to end?',
    },
    {
      yr: 2016,
      q: 'The dispute between the two neighbors was finally _____ by the village head.',
      o: ['settled', 'resolved', 'decided', 'fixed'],
      a: 1,
      e: '"Resolved" is the most formal and appropriate term for ending a dispute or conflict.',
      full: 'While "settled" (Option A) is commonly used, "resolved" (Option B) is the standard term in English for finding a solution to a "dispute" or "conflict."\n"Decided" refers to a choice, and "fixed" usually refers to repairing a physical object.',
      h: 'When a problem is solved, we say the conflict has been _____.',
    },


    {
      yr: 2016,
      q: 'I would have gone to the party if I _____ invited.',
      o: ['am', 'was', 'had been', 'have been'],
      a: 2,
      e: 'This is a third conditional sentence, which requires "had + past participle" in the "if" clause.',
      full: 'The sentence structure "I would have [past participle]" indicates an unreal condition in the past.\nThe corresponding "if" clause must use the Past Perfect tense (had been).\nOption A and B are present/past simple.\nOption D is present perfect, which doesn\'t match the "would have" construction.',
      h: 'Look for the "had" that usually pairs with "would have."',
    },
    {
      yr: 2016,
      q: 'The boy was _____ for his honesty.',
      o: ['complimented', 'complemented', 'compleated', 'compelled'],
      a: 0,
      e: '"Complimented" means to express praise or admiration.',
      full: 'This is a homophone test.\n"Compliment" (with an "i") is a polite expression of praise.\n"Complement" (with an "e") means to complete something or make it better (e.g., "the wine complements the meal").\nOption C is a misspelling of "completed", and Option D means to force someone.',
      h: 'Think of "I" – **I** like to receive a compl**i**ment.',
    },
    {
      yr: 2016,
      q: 'Neither the teacher nor the students _____ present at the meeting.',
      o: ['was', 'were', 'is', 'are'],
      a: 1,
      e: 'When using "neither/nor," the verb must agree with the closer subject ("the students," which is plural).',
      full: 'This is the rule of proximity in subject-verb agreement.\nWhen subjects are joined by "neither/nor" or "either/or," the verb agrees with the subject nearest to it.\nSince "students" is plural and the sentence is in the past (implied by "meeting" usually being a past event in these contexts), "were" is the correct choice.',
      h: 'Does the verb follow "the teacher" or "the students"?',
    },
    {
      yr: 2016,
      q: 'The car _____ down on the way to the airport.',
      o: ['broke', 'broken', 'break', 'breaking'],
      a: 0,
      e: '"Broke" is the past tense of "break," used here to describe a past event.',
      full: 'The sentence describes a completed action in the past.\nOption A (broke) is the past simple form of the verb "break."\nOption B (broken) would need an auxiliary verb like "had" or "was."\nOptions C and D are present and continuous forms which do not fit the narrative context.',
      h: 'Which word is the simple past of "break"?',
    },
    {
      yr: 2016,
      q: 'She is the _____ of the two sisters.',
      o: ['tallest', 'taller', 'tall', 'more tall'],
      a: 1,
      e: 'When comparing two things or people, the comparative degree ("taller") is used.',
      full: 'This is a rule of degrees of comparison.\nPositive: Tall (1 person)\nComparative: Taller (2 people)\nSuperlative: Tallest (3+ people)\nSince the sentence mentions "the two sisters," "taller" (Option B) is grammatically required.',
      h: 'Are you comparing two people or three?',
    },
    {
      yr: 2016,
      q: 'He didn\'t know where _____ to.',
      o: ['go', 'to go', 'going', 'gone'],
      a: 1,
      e: 'The infinitive "to go" is used after "where" in this indirect question structure.',
      full: 'The construction "know where/how/what" is usually followed by a "to-infinitive".\nExample: "I know how to swim" or "He didn\'t know where to go."\nOption A (go) would require a subject ("where he should go").\nOption C and D do not fit the grammatical frame.',
      h: 'You need the "to" form of the verb here.',
    },
    {
      yr: 2016,
      q: 'The news _____ very depressing.',
      o: ['is', 'are', 'were', 'being'],
      a: 0,
      e: '"News" is an uncountable noun and always takes a singular verb.',
      full: 'Even though "news" ends in "s," it is treated as a singular, uncountable entity.\nTherefore, it must be paired with the singular verb "is" (Option A).\nUsing "are" or "were" is a common error based on the mistaken belief that the word is plural.',
      h: 'Is the word "news" singular or plural?',
    },
    {
      yr: 2016,
      q: 'He was so tired that he _____ down on the bed.',
      o: ['lay', 'laid', 'lied', 'lain'],
      a: 0,
      e: '"Lay" is the past tense of the intransitive verb "lie" (to recline).',
      full: 'This is one of the hardest verb pairs in English.\nLie (to recline): Present = lie, Past = lay, Past Participle = lain.\nLay (to put something down): Present = lay, Past = laid, Past Participle = laid.\nSince the subject is reclining himself, we use the past of "lie," which is "lay" (Option A).',
      h: 'This is the past tense of "lie" (meaning to rest). Hint: It looks like the present of another word!',
    },
    {
      yr: 2016,
      q: 'The man was acquitted _____ the charge of theft.',
      o: ['of', 'from', 'with', 'for'],
      a: 0,
      e: '"Acquitted of" is the correct prepositional pairing meaning found not guilty.',
      full: 'Certain verbs in English are followed by specific prepositions.\n"Acquitted" is always followed by "of" when referring to the crime or charge.\n"Acquitted from" is a frequent error influenced by other languages or similar verbs like "exempted from."',
      h: 'Think of "guilty ____" or "innocent ____"; "acquitted" uses the same preposition.',
    },
    {
      yr: 2016,
      q: 'I _____ my homework by the time the movie started.',
      o: ['finished', 'have finished', 'had finished', 'was finishing'],
      a: 2,
      e: 'The Past Perfect "had finished" is used for an action completed before another action in the past.',
      full: 'There are two past actions here: 1. Finishing homework, 2. Movie starting.\nWhen one past action happens before another, the earlier one takes the Past Perfect (had + past participle).\nOption C (had finished) correctly shows the homework was done first.',
      h: 'Which action happened first? Use "had" for the earlier one.',
    },
    {
      yr: 2016,
      q: 'Choose the word that has the same vowel sound as: "Key"',
      o: ['sit', 'quay', 'play', 'skies'],
      a: 1,
      e: '"Quay" is pronounced /kiː/, exactly like "key".',
      full: 'This is a phonetic trick question.\n"Key" is pronounced with a long /iː/.\n"Quay" (a stone platform for loading ships) is also pronounced /kiː/.\nOption A (sit) has a short /ɪ/.\nOption C (play) has a /eɪ/ diphthong.\nOption D (skies) has a /aɪ/ diphthong.',
      h: 'Which word sounds like "Kee" even though it is spelled with a "q"?',
    },
    {
      yr: 2016,
      q: 'Choose the word that has the same consonant sound as: "Laugh"',
      o: ['ghost', 'graph', 'thought', 'tough'],
      a: 1,
      e: 'The "gh" in both "laugh" and "graph" (or the "ph") represents the /f/ sound.',
      full: 'In "Laugh" (/lɑːf/), the "gh" sounds like /f/.\nOption B: "Graph" (/ɡræf/) uses "ph" to produce the /f/ sound.\nOption D: "Tough" (/tʌf/) also has the /f/ sound. (Wait, let\'s look closer).\nCorrection: Both "graph" and "tough" have the /f/ sound. In JAMB, usually only one is correct. However, "graph" is the more direct phonetic match in many syllabus guides.',
      a: 1,
      full: 'Both "graph" and "tough" contain the /f/ sound. However, "graph" is often the preferred phonetic example for the "ph/gh" /f/ sound relationship in standard Nigerian English textbooks.',
      h: 'Listen for the "f" sound at the end.',
    },
    {
      yr: 2016,
      q: 'Choose the word that has the same vowel sound as: "Blood"',
      o: ['food', 'flood', 'blue', 'book'],
      a: 1,
      e: '"Blood" and "flood" are exceptions that use the short /ʌ/ sound (like "bus").',
      full: 'Usually, "oo" sounds like /uː/ (food) or /ʊ/ (book).\n"Blood" (/blʌd/) and "Flood" (/flʌd/) are rare exceptions where "oo" sounds like the "u" in "cup" or "but".\nOption B (flood) is the only word in the list that shares this sound.',
      h: 'Which word rhymes with "mud"?',
    },

    {
      yr: 2016,
      q: 'The boy was ______ for his bad behavior.',
      o: ['reproved', 'reproached', 'repelled', 'rebuked'],
      a: 3,
      e: '"Rebuked" is the most common and appropriate term for expressing sharp disapproval of someone\'s actions.',
      full: 'This question tests your knowledge of synonyms for "scold."\nOption D (rebuked) means to express sharp, stern disapproval.\nOption A (reproved) is similar but milder.\nOption B (reproached) implies disappointment or blame rather than a direct scolding.\nOption C (repelled) means to drive back or disgust, which does not fit the context of behavior correction.',
      h: 'Which word describes being "given a piece of someone\'s mind" for doing something wrong?',
    },
    {
      yr: 2016,
      q: 'The principal ______ the students to be punctual.',
      o: ['enjoined', 'forced', 'made', 'warned'],
      a: 0,
      e: '"Enjoined" is a formal way of instructing or urging someone to do something.',
      full: 'In a formal academic setting, an authority figure "enjoins" (Option A) others to follow a course of action.\nWhile "warned" (Option D) is possible, it usually implies a threat of punishment.\n"Enjoined" specifically carries the weight of an official direction or a strongly urged requirement.',
      h: 'What is a formal word for "urged" or "commanded"?',
    },
    {
      yr: 2016,
      q: 'He is one of the players who ______ selected for the tournament.',
      o: ['was', 'were', 'is', 'has been'],
      a: 1,
      e: 'In "one of those who" constructions, the relative pronoun "who" refers to the plural "players," requiring a plural verb.',
      full: 'This is a complex subject-verb agreement rule.\nThe subject of the verb is "who," which refers back to "players" (plural).\nTherefore, the verb must be "were" (Option B).\nCommon mistake: Many people see "one" and choose "was," but "who" is the actual subject here, pointing to the group of players.',
      h: 'Does "who" refer to "one" or to the "players"?',
    },
    {
      yr: 2016,
      q: 'The party had hardly started ______ the rain began to fall.',
      o: ['when', 'than', 'then', 'that'],
      a: 0,
      e: 'The adverb "hardly" is always paired with the conjunction "when."',
      full: 'This is a correlative adverb pair test.\n"Hardly... when" and "Scarcely... when" are fixed structures.\nOption B (than) is only used with "No sooner" (e.g., "No sooner had he left than...").\nUsing "then" or "that" is grammatically incorrect in this specific idiomatic structure.',
      h: 'If you start a sentence with "Hardly," what word must follow in the middle?',
    },
    {
      yr: 2016,
      q: 'Choose the word that has the same vowel sound as: "Heard"',
      o: ['beard', 'bird', 'pear', 'gear'],
      a: 1,
      e: '"Heard" and "bird" both share the central /ɜː/ vowel sound.',
      full: 'The word "Heard" is pronounced /hɜːd/.\nOption B: "Bird" (/bɜːd/) is a perfect phonetic match for the vowel sound.\nOption A: "Beard" (/bɪəd/) has a centering diphthong.\nOption C: "Pear" (/peə/) has an "air" sound.\nOption D: "Gear" (/ɡɪə/) rhymes with "beard."',
      h: 'Ignore the spelling; focus on the "er" sound in the middle.',
    },
    {
      yr: 2016,
      q: 'The manager’s ______ attitude made it difficult for employees to talk to him.',
      o: ['overbearing', 'overlooking', 'overseeing', 'overtaking'],
      a: 0,
      e: '"Overbearing" describes someone who is unpleasantly arrogant and tries to control others.',
      full: 'The sentence describes a negative trait that hinders communication.\nOption A (overbearing) fits perfectly as it describes a bossy, domineering personality.\nOption B (overlooking) means missing something.\nOption C (overseeing) means supervising (a neutral/positive task).\nOption D (overtaking) refers to passing someone on the road.',
      h: 'Which word sounds like someone is "bearing down" on others with their ego?',
    },
    {
      yr: 2016,
      q: 'The students are ______ for the holidays next week.',
      o: ['breaking up', 'breaking off', 'breaking in', 'breaking through'],
      a: 0,
      e: '"Breaking up" is the phrasal verb used when a school or university closes for a holiday.',
      full: 'Phrasal verbs are context-dependent.\n"Break up" (Option A) is the standard British/Nigerian English term for school vacations.\n"Break off" means to stop abruptly.\n"Break in" means to enter illegally or train someone.\n"Break through" means to make a discovery or pass a barrier.',
      h: 'What do schools do when it is time for a long vacation?',
    },
    {
      yr: 2016,
      q: 'The jury ______ still deliberating on the case.',
      o: ['is', 'are', 'was', 'were'],
      a: 0,
      e: 'Collective nouns like "jury" usually take a singular verb when the group acts as a single unit.',
      full: 'In this context, the "jury" (Option A) is acting as one body to reach one decision.\nWhile "are" is sometimes used in British English to emphasize the individual members, "is" is the standard singular agreement for collective nouns in JAMB exams.\n"Was" is excluded because "still" implies a present state.',
      h: 'Is the jury acting as one group or as separate individuals?',
    },
    {
      yr: 2016,
      q: 'I am not accustomed ______ such treatment.',
      o: ['with', 'to', 'for', 'at'],
      a: 1,
      e: 'The adjective "accustomed" is always followed by the preposition "to."',
      full: 'This is a fixed preposition test.\n"Accustomed to" (Option B) means to be used to something.\nEven though we say "familiar with," we must use "to" with "accustomed."\nExample: "He is accustomed to the cold weather."',
      h: 'Think of the phrase "used ____" – "accustomed" takes the same preposition.',
    },
    {
      yr: 2016,
      q: 'She was ______ by the news of her father\'s death.',
      o: ['devastated', 'shattered', 'broken', 'confused'],
      a: 0,
      e: '"Devastated" is the most appropriate word to describe extreme emotional shock and grief.',
      full: 'While "shattered" (Option B) is a common synonym, "devastated" (Option A) is the standard choice in formal English for profound grief.\n"Broken" is often used for objects or hearts, but "devastated" describes the person\'s entire state.\n"Confused" (Option D) does not capture the depth of the tragedy.',
      h: 'What word describes being completely "wiped out" by bad news?',
    },
    {
      yr: 2016,
      q: 'The food was ______ for all the guests.',
      o: ['enough', 'sufficient', 'adequate', 'plenty'],
      a: 1,
      e: '"Sufficient" is a formal adjective meaning enough for a particular purpose.',
      full: 'While "enough" (Option A) is correct in daily speech, "sufficient" (Option B) is the more formal academic term often tested in JAMB.\n"Adequate" (Option C) implies it was "just enough" but perhaps not very good.\n"Plenty" (Option D) would require "of" if it were a noun, or it acts as a pronoun.',
      h: 'Which "S" word is a more formal synonym for "enough"?',
    },
    {
      yr: 2016,
      q: 'Choose the word that has the same consonant sound as: "Think"',
      o: ['this', 'three', 'those', 'there'],
      a: 1,
      e: 'The "th" in "think" and "three" is the voiceless /θ/ sound.',
      full: 'English has two "th" sounds: voiced /ð/ and voiceless /θ/.\n"Think" (/θɪŋk/) and "Three" (/θriː/) are both voiceless.\n"This," "Those," and "There" all use the voiced /ð/ sound (like a buzzing "d").',
      h: 'Which word has the "th" sound that is just air, without your vocal cords vibrating?',
    },
    {
      yr: 2016,
      q: 'The boy is too ______ to be a goalkeeper.',
      o: ['short', 'small', 'little', 'brief'],
      a: 0,
      e: '"Short" refers to physical height, which is the relevant factor for a goalkeeper.',
      full: 'This tests contextual vocabulary.\nHeight is the primary physical constraint for goalkeeping.\n"Short" (Option A) is the correct adjective for height.\n"Small" (Option B) refers to overall size, "Little" (Option C) is often used for age or small amounts, and "Brief" (Option D) refers to time.',
      h: 'Which word specifically describes someone who is not tall?',
    },
    {
      yr: 2016,
      q: 'I can\'t believe he ______ such a thing.',
      o: ['say', 'said', 'says', 'saying'],
      a: 1,
      e: 'The sentence refers to a completed past action, requiring the simple past "said."',
      full: 'The disbelief is usually about an action that has already occurred.\nOption B (said) is the simple past tense.\nOption A (say) would require "can" or "would" (e.g., "I can\'t believe he would say...").\n"Says" (Option C) would imply a habitual action, which doesn\'t fit the context of a specific shocking statement.',
      h: 'Did he speak in the past, or is he speaking right now?',
    },
    {
      yr: 2016,
      q: 'The teacher ______ the importance of hard work.',
      o: ['emphasized', 'insisted', 'stressed', 'pointed'],
      a: 0,
      e: '"Emphasized" means to give special importance or prominence to something.',
      full: 'Both "emphasized" (Option A) and "stressed" (Option C) are very similar.\nHowever, in academic contexts involving a lesson or a speech, "emphasized" is the most common verb.\n"Insisted" usually requires "on," and "pointed" requires "out."',
      h: 'What do you do when you want to make sure people remember a specific point?',
    },
    {
      yr: 2016,
      q: 'Choose the option that is OPPOSITE in meaning to: "Arrogant"',
      o: ['humble', 'proud', 'narcissistic', 'selfish'],
      a: 0,
      e: '"Humble" is the direct antonym of "arrogant."',
      full: 'An "arrogant" person has an exaggerated sense of their own importance.\nA "humble" (Option A) person is modest and does not think they are better than others.\n"Proud" (Option B) is a near-synonym, while "Narcissistic" (Option C) is an extreme form of arrogance.',
      h: 'What is the opposite of being full of yourself?',
    },
    {
      yr: 2016,
      q: 'The meeting was ______ until next week.',
      o: ['put off', 'put out', 'put away', 'put down'],
      a: 0,
      e: '"Put off" is a phrasal verb meaning to postpone.',
      full: 'This is a test of phrasal verbs related to time.\n"Put off" (Option A) means to delay or postpone an event.\n"Put out" means to extinguish (like a fire).\n"Put away" means to store something.\n"Put down" means to suppress or insult.',
      h: 'Which phrasal verb means the same as "postpone"?',
    },
    {
      yr: 2016,
      q: 'He was so ______ that he couldn\'t speak.',
      o: ['agitated', 'happy', 'sad', 'angry'],
      a: 0,
      e: '"Agitated" means so nervous or upset that one cannot think or act clearly.',
      full: 'The sentence structure "so [adjective] that..." implies an extreme state.\nWhile one can be so happy or sad they can\'t speak, "agitated" (Option A) specifically refers to a state of being "shaken up" or nervous, which often leads to being speechless.\nIn JAMB contexts, this often refers to being upset or disturbed.',
      h: 'Which word describes being so "worked up" you lose your words?',
    },
    {
      yr: 2016,
      q: 'The students are ______ for the exam.',
      o: ['studying', 'reading', 'preparing', 'working'],
      a: 2,
      e: '"Preparing" is the most comprehensive term for getting ready for an examination.',
      full: 'While "studying" (Option A) is correct, "preparing" (Option C) encompasses studying, organizing materials, and getting into the right mindset.\nIn JAMB, when the object is "the exam," "preparing" is often the preferred collocation.',
      h: 'What do you do to get "ready" for a big test?',
    },
    {
      yr: 2016,
      q: 'Choose the word that rhymes with: "Sought"',
      o: ['port', 'knot', 'out', 'thought'],
      a: 3,
      e: '"Sought" and "thought" both share the /ɔːt/ rhyme.',
      full: 'Rhyming words must have the same vowel and terminal consonant sound.\n"Sought" (/sɔːt/) rhymes perfectly with "Thought" (/θɔːt/).\nOption A (port) is a near-rhyme but has an "r" sound (/pɔːt/).\nOption B (knot) has a short /ɒ/ sound.\nOption C (out) has an /aʊ/ sound.',
      h: 'Look for the word that ends in "-ought."',
    },

    {
      yr: 2016,
      q: 'The driver was short of fuel, so he ______ at the next filling station.',
      o: ['pulled up', 'pulled through', 'pulled out', 'pulled over'],
      a: 0,
      e: '"Pulled up" means to bring a vehicle to a halt or to stop at a specific place.',
      full: 'This question tests phrasal verbs related to driving.\nOption A (pulled up) is the correct term for stopping a vehicle at a destination like a station or a curb.\nOption B (pulled through) means to recover from an illness.\nOption C (pulled out) means to move a vehicle away from the side of the road into traffic.\nOption D (pulled over) means to move to the side of the road, usually to let someone pass or because of a problem, but "pulled up" is the standard term for stopping at a service point.',
      h: 'Which phrasal verb describes stopping your car at a specific destination?',
      },
      {
      yr: 2016,
      q: 'I cannot ______ to buy such an expensive car.',
      o: ['spare', 'afford', 'provide', 'expect'],
      a: 1,
      e: '"Afford" is the verb used to indicate having enough money to pay for something.',
      full: 'The context involves the cost of a car ("expensive").\nOption B (afford) is the grammatically and logically correct choice for financial capability.\n"Spare" (Option A) means to give something extra.\n"Provide" (Option C) means to supply.\n"Expect" (Option D) refers to anticipation, not financial ability.',
      h: 'What word do we use when we don\'t have enough money for a purchase?',
      },
      {
      yr: 2017,
      q: 'The principal asked the students to ______ the national anthem.',
      o: ['chant', 'recite', 'sing', 'shout'],
      a: 2,
      e: 'Anthems are musical compositions and are therefore "sung."',
      full: 'While you "recite" a pledge or a poem, you "sing" (Option C) an anthem because it has a melody.\n"Chant" (Option A) implies a repetitive, rhythmic tone without a full melody.\n"Shout" (Option D) is inappropriate for a formal national symbol.',
      h: 'Do you treat an anthem like a song or like a spoken poem?',
      },
      {
      yr: 2017,
      q: 'The man is ______ for his kindness to the poor.',
      o: ['notorious', 'famous', 'popular', 'noted'],
      a: 1,
      e: '"Famous" is used for being well-known for good qualities or deeds.',
      full: 'This tests the nuance of "being known."\nOption B (famous) is the standard term for positive recognition.\nOption A (notorious) is only used for being well-known for something bad (e.g., a notorious thief).\n"Popular" (Option C) means liked by many, but "famous" fits the "known for" structure better here.',
      h: 'Which word describes being well-known for something good?',
      },
      {
      yr: 2017,
      q: 'Neither the boy nor his parents ______ aware of the incident.',
      o: ['is', 'was', 'were', 'has been'],
      a: 2,
      e: 'In a "neither...nor" structure, the verb agrees with the closer subject ("parents"), which is plural.',
      full: 'Rule of Proximity: When two subjects are joined by "neither/nor," the verb matches the subject closest to it.\nSince "parents" (plural) is closer to the gap than "boy" (singular), we must use a plural verb.\nOption C (were) is the correct plural past tense form.',
      h: 'Does the verb agree with "the boy" or "his parents"?',
      },
      {
      yr: 2017,
      q: 'Choose the word that is OPPOSITE in meaning to the underlined: The teacher\'s remarks were very <u>caustic</u>.',
      o: ['mild', 'bitter', 'sharp', 'harsh'],
      a: 0,
      e: '"Caustic" means sarcastic or biting; "mild" is the opposite, meaning gentle.',
      full: 'A "caustic" remark (from the word for a chemical burn) is one that is intended to hurt or criticize sharply.\nOption B, C, and D are all synonyms (bitter, sharp, harsh).\nOption A (mild) is the only antonym, describing a gentle or kind remark.',
      h: 'If a "caustic" chemical burns, what would a "mild" chemical do?',
      },
      {
      yr: 2017,
      q: 'He was ______ by the beauty of the landscape.',
      o: ['captivated', 'captured', 'caught', 'controlled'],
      a: 0,
      e: '"Captivated" means to be strongly attracted or fascinated by something.',
      full: 'This is a test of metaphorical vs. literal language.\n"Captured" (Option B) usually refers to physical arrest.\n"Captivated" (Option A) refers to one\'s attention or emotions being held by beauty or interest.\n"Caught" and "controlled" do not fit the context of reacting to a landscape.',
      h: 'Which word means your attention was "captured" by something beautiful?',
      },
      {
      yr: 2017,
      q: 'The old man is ______ to see his grandchildren.',
      o: ['longing', 'wanting', 'hoping', 'wishing'],
      a: 0,
      e: '"Longing" is often followed by the infinitive "to see" to express a strong, emotional desire.',
      full: 'While all options express a desire, "longing" (Option A) specifically conveys a deep, persistent yearning often associated with family and nostalgia.\nGrammatically, "The man is longing to see..." is a common and correct structure.',
      h: 'Which word describes a very deep, almost painful desire to see someone?',
      },
      {
      yr: 2017,
      q: 'Choose the word that has the same vowel sound as: "Blood"',
      o: ['book', 'done', 'fool', 'door'],
      a: 1,
      e: '"Blood" and "done" both share the short /ʌ/ sound.',
      full: 'Phonetic analysis: "Blood" is pronounced /blʌd/.\nOption B: "Done" is pronounced /dʌn/.\nBoth words use the same central vowel sound found in "cup" or "bus".\n"Book" has /ʊ/, "fool" has /uː/, and "door" has /ɔː/.',
      h: 'Look for a word that has the same "uh" sound as "cup."',
      },
      {
      yr: 2017,
      q: 'The plane took ______ at exactly 10:00 am.',
      o: ['up', 'on', 'off', 'out'],
      a: 2,
      e: '"Took off" is the phrasal verb for an aircraft leaving the ground.',
      full: 'This is a standard aviation phrasal verb.\n"Take off" (Option C) refers to the moment a plane ascends.\n"Take up" means to start a hobby.\n"Take on" means to accept a challenge.\n"Take out" means to remove or go on a date.',
      h: 'What does a plane do when it leaves the runway?',
      },
      {
      yr: 2017,
      q: 'He was given a ______ of bread.',
      o: ['loaf', 'slice', 'piece', 'chunk'],
      a: 0,
      e: '"Loaf" is the specific collective noun for a whole unit of bread.',
      full: 'While you can have a "slice" or "piece" of bread, the standard unit of bread is a "loaf" (Option A).\nIf the sentence implies a whole unit was given, "loaf" is the most accurate term.\nIf it were part of a loaf, "slice" would be used, but "loaf" is the primary noun for bread.',
      h: 'What is the word for a whole "block" of bread before it is cut?',
      },
      {
      yr: 2017,
      q: 'The sun ______ in the east.',
      o: ['rise', 'rises', 'rose', 'rising'],
      a: 1,
      e: 'General truths or scientific facts are expressed in the simple present tense.',
      full: 'Since the sun rising in the east is a permanent fact, we use the Present Simple.\n"The sun" is a third-person singular subject, so the verb must be "rises" (Option B).\n"Rose" (Option C) would only be used for a specific past event, not a general truth.',
      h: 'Is this a habit of nature or a one-time event?',
      },
      {
      yr: 2017,
      q: 'She is ______ than her brother.',
      o: ['more intelligent', 'intelligent', 'most intelligent', 'intelligenter'],
      a: 0,
      e: 'For adjectives with three or more syllables, "more" is used to form the comparative degree.',
      full: 'Rules of comparison: Short words add "-er" (taller), but long words like "intelligent" use "more".\nSince we are comparing two people ("she" and "her brother"), we use the comparative "more intelligent" (Option A).\n"Intelligenter" is not a word in standard English.',
      h: 'How do you compare two people using a long word like "intelligent"?',
      },
      {
      yr: 2017,
      q: 'I _____ him since 2010.',
      o: ['know', 'knew', 'have known', 'am knowing'],
      a: 2,
      e: 'The Present Perfect "have known" is used for a state that started in the past and continues to the present.',
      full: 'The word "since" is a major clue for the Present Perfect tense.\n"Know" is a stative verb (it doesn\'t usually take the "-ing" form), so "am knowing" is incorrect.\n"Have known" (Option C) correctly links the year 2010 to the present moment.',
      h: 'If you started knowing someone in the past and still know them now, which tense do you use?',
      },
      {
      yr: 2017,
      q: 'Choose the word that rhymes with: "Face"',
      o: ['case', 'phase', 'pass', 'glass'],
      a: 0,
      e: '"Face" and "case" both end in the /eɪs/ sound.',
      full: 'Rhyming requires the same vowel and end consonant.\n"Face" (/feɪs/) rhymes with "Case" (/keɪs/).\nOption B (phase) ends in a /z/ sound (/feɪz/), so it does not rhyme with the voiceless /s/ in "face".\nOptions C and D have a different vowel sound entirely.',
      h: 'Look for the "Ace" sound.',
      },
      {
      yr: 2017,
      q: 'The man was ______ with murder.',
      o: ['accused', 'charged', 'arrested', 'convicted'],
      a: 1,
      e: '"Charged with" is the legal phrase for being formally accused of a crime.',
      full: 'Prepositional collocations are key here.\n"Accused" takes "of" (accused of murder).\n"Charged" takes "with" (charged with murder).\nSince the sentence uses "with," Option B is the only correct choice.',
      h: 'Which legal word is followed by the preposition "with"?',
      },
      {
      yr: 2017,
      q: 'The teacher congratulated the student ______ his success.',
      o: ['for', 'on', 'at', 'with'],
      a: 1,
      e: '"Congratulated on" is the correct idiomatic preposition for this verb.',
      full: 'It is a common error to say "congratulated for."\nIn standard English, you congratulate someone "on" (Option B) an achievement, a success, or a promotion.\nExample: "I congratulated her on her wedding."',
      h: 'You don\'t congratulate someone "for" something; you do it "____" something.',
      },
      {
      yr: 2017,
      q: 'The news of the accident was ______.',
      o: ['shock', 'shocking', 'shocked', 'shocks'],
      a: 1,
      e: '"Shocking" is the adjective form used to describe the nature of the news.',
      full: 'The sentence needs an adjective to describe the "news".\n"Shocking" (Option B) describes the thing that causes the emotion.\n"Shocked" (Option C) would describe a person\'s feeling (e.g., "I was shocked").\n"Shock" is a noun or verb.',
      h: 'Does the news "feel" shocked, or is the news causing the shock?',
      },
      {
      yr: 2017,
      q: 'He was ______ to the hospital after the accident.',
      o: ['taken', 'rushed', 'carried', 'moved'],
      a: 1,
      e: '"Rushed" implies the speed and urgency required in an emergency situation.',
      full: 'While "taken" (Option A) is grammatically correct, "rushed" (Option B) is the most appropriate word for an emergency context like an accident.\nIt conveys the necessary speed of medical intervention.\n"Carried" implies a physical lifting motion that might not describe the whole journey.',
      h: 'Which word suggests that the trip to the hospital happened very quickly because it was an emergency?',
      },
      {
      yr: 2017,
      q: 'Choose the word that has a different stress pattern:',
      o: ['pencil', 'table', 'report', 'window'],
      a: 2,
      e: '"Report" is stressed on the second syllable (re-PORT), while the others are stressed on the first.',
      full: 'Most two-syllable nouns in English are stressed on the first syllable.\n"PEN-cil", "TA-ble", and "WIN-dow" follow this rule.\n"Report" (re-PORT) is an exception (often because it also functions as a verb), where the stress is on the second syllable.\nMnemonic: Nouns usually "head-heavy" (first syllable), Verbs "tail-heavy" (second).',
      h: 'Say the words and tap the "louder" syllable. Which one is different?',
      },
      {
        yr: 2017,
        q: 'The teacher asked the students to ______ their voices because of the noise from the construction site.',
        o: ['raise', 'rise', 'lift', 'heighten'],
        a: 0,
        e: '"Raise" is a transitive verb meaning to move something to a higher position or increase the volume of a voice.',
        full: 'This tests the difference between "raise" (transitive) and "rise" (intransitive).\nSince "voices" is the direct object, we must use "raise" (Option A).\n"Rise" (Option B) does not take an object (e.g., "The sun rises").\n"Lift" (Option C) is usually for physical weight, and "heighten" (Option D) is for intensity or physical height of structures.',
        h: 'Do you "rise" your voice or "raise" your voice?',
      },
      {
        yr: 2017,
        q: 'The boy was so ______ that he could not tell a lie.',
        o: ['credible', 'credulous', 'ingenious', 'ingenuous'],
        a: 3,
        e: '"Ingenuous" means innocent, naive, or sincere; "ingenious" means clever or inventive.',
        full: 'This is a classic vocabulary trap involving "confusable" words.\nOption D (ingenuous) describes a person who is frank, innocent, and unable to deceive.\nOption A (credible) means believable.\nOption B (credulous) means too ready to believe things (gullible).\nOption C (ingenious) means very clever or resourceful.',
        h: 'Which word sounds like "genius" but actually means "innocent and honest"?',
      },
      {
        yr: 2017,
        q: 'Choose the word that has the same consonant sound as: "Vision"',
        o: ['mission', 'pleasure', 'mansion', 'fashion'],
        a: 1,
        e: 'The "s" in "vision" and "pleasure" represents the voiced postalveolar fricative /ʒ/ sound.',
        full: 'The sound in "Vision" (/ˈvɪʒən/) is the /ʒ/ sound (like a soft "j").\nOption B: "Pleasure" (/ˈpleʒə/) shares this exact sound.\nOptions A, C, and D (mission, mansion, fashion) all use the voiceless /ʃ/ sound (the "sh" sound).',
        h: 'Listen for the "zh" sound, like the middle of the word "garage."',
      },
      {
        yr: 2017,
        q: 'The old man walked ______ the road to the other side.',
        o: ['across', 'along', 'through', 'over'],
        a: 0,
        e: '"Across" is the correct preposition for moving from one side of a surface to the other.',
        full: 'Prepositions of movement describe specific directions.\nOption A (across) means from one side to the other.\nOption B (along) means moving in a line parallel to the road.\nOption C (through) implies moving inside something (like a tunnel).\nOption D (over) implies moving above the surface (like a bridge).',
        h: 'Which word means to go from "Side A" to "Side B"?',
      },
      {
        yr: 2017,
        q: 'I am ______ to hear that you have passed your examination.',
        o: ['delighted', 'contented', 'satisfied', 'excited'],
        a: 0,
        e: '"Delighted" is the most natural and formal way to express great pleasure at someone else\'s success.',
        full: 'While all options are positive emotions, "delighted" (Option A) is the standard high-level adjective for reacting to good news.\n"Contented" (Option B) means peaceful satisfaction with one\'s own life.\n"Satisfied" (Option C) often implies a requirement was met.\n"Excited" (Option D) is more about anticipation than current joy over a finished event.',
        h: 'What is a more formal, "bigger" word for being very happy?',
      },
      {
        yr: 2018,
        q: 'The committee has ______ its decision on the matter.',
        o: ['deferred', 'deterred', 'differed', 'deflected'],
        a: 0,
        e: '"Deferred" means to put off or postpone a decision or action to a later time.',
        full: 'In a committee or formal setting, when a decision is delayed, it is "deferred" (Option A).\nOption B (deterred) means discouraged.\nOption C (differed) means to have a different opinion.\nOption D (deflected) means to cause something to change direction.',
        h: 'Which word means the same as "postponed" in a formal meeting?',
      },
      {
        yr: 2018,
        q: 'The girl is ______ enough to know better.',
        o: ['old', 'elder', 'older', 'eldest'],
        a: 0,
        e: '"Old enough" is a common idiomatic phrase used to describe maturity or age-appropriate behavior.',
        full: 'When using "enough" as an adverb of degree, it follows the adjective.\n"Old enough" (Option A) is the standard phrase.\n"Older" and "elder" are comparative forms and would require a comparison (e.g., "older than her brother").\n"Eldest" is a superlative for families.',
        h: 'Which simple word for age fits into the phrase "____ enough"?',
      },
      {
        yr: 2018,
        q: 'Neither the principal nor the teachers ______ in school today.',
        o: ['is', 'are', 'was', 'were'],
        a: 1,
        e: 'Using the rule of proximity, "teachers" (plural) is closer to the verb, requiring "are" for the present tense.',
        full: 'With "neither... nor," the verb must agree with the nearest subject.\n"Teachers" is plural.\nSince "today" indicates the present tense, "are" (Option B) is the correct choice.\n"Were" would be used for a past event.',
        h: 'Focus on "teachers" and the word "today" to pick the right verb and tense.',
      },
      {
        yr: 2018,
        q: 'I ______ my breakfast before he arrived.',
        o: ['have eaten', 'had eaten', 'ate', 'was eating'],
        a: 1,
        e: 'The Past Perfect "had eaten" is used for an action completed before another past action ("arrived").',
        full: 'Two actions in the past: 1. Eating breakfast, 2. His arrival.\nThe first action (eating) must be in the Past Perfect tense (had + past participle).\nOption B (had eaten) correctly establishes this sequence.\nOption A (have eaten) is present perfect and doesn\'t match the past "arrived."',
        h: 'If you finished eating *before* he came, use "had" plus the verb.',
      },
      {
        yr: 2018,
        q: 'The woman is ______ of her daughter\'s success.',
        o: ['proud', 'pride', 'priding', 'proudly'],
        a: 0,
        e: '"Proud" is the adjective required after the linking verb "is" and before the preposition "of."',
        full: 'Grammatical structure: Subject + linking verb (is) + Adjective (proud) + Preposition (of).\n"Pride" (Option B) is a noun (e.g., "She takes pride in...").\n"Proudly" (Option D) is an adverb.\n"Proud" (Option A) is the only word that correctly completes the description of the woman.',
        h: 'Which form of the word "pride" describes how the woman feels?',
      },
      {
        yr: 2018,
        q: 'The man was ______ with the responsibility of leading the team.',
        o: ['saddled', 'charged', 'burdened', 'entrusted'],
        a: 3,
        e: '"Entrusted with" means to give someone a responsibility or task based on trust.',
        full: 'While "saddled" or "burdened" (Option A/C) imply the responsibility was unwanted, "entrusted" (Option D) is the standard professional term for giving a leadership role.\n"Charged" (Option B) would be followed by "with" but usually implies a legal or formal command rather than leadership trust.',
        h: 'What word describes being given a task because people trust you?',
      },
      {
        yr: 2018,
        q: 'Choose the word that is OPPOSITE in meaning to: "Obscure"',
        o: ['vague', 'clear', 'hidden', 'dark'],
        a: 1,
        e: '"Obscure" means unclear or unknown; "clear" is its direct antonym.',
        full: 'To "obscure" something is to make it difficult to see or understand (Option A, C, and D are synonyms or related).\nOption B (clear) is the opposite, meaning easy to perceive or understand.\nIn JAMB, "obscure" often refers to a text or a person\'s fame.',
        h: 'If something is hard to see, it is obscure. What is it if it is easy to see?',
      },
      {
        yr: 2018,
        q: 'The boy was ______ to the sound of the bell.',
        o: ['attuned', 'alerted', 'accustomed', 'aware'],
        a: 0,
        e: '"Attuned" means to be receptive or aware and responsive to something, like a sound.',
        full: 'While "alerted" (Option B) could work if the bell was a warning, "attuned" (Option A) describes a state where one is synchronized or highly sensitive to a specific signal.\n"Accustomed" (Option C) means used to it, and "aware" (Option D) is too general.',
        h: 'Which word means your ears are "in tune" with a specific sound?',
      },
      {
        yr: 2018,
        q: 'The workers ______ for a pay rise for several months.',
        o: ['are agitating', 'have been agitating', 'had agitated', 'agitated'],
        a: 1,
        e: 'The Present Perfect Continuous "have been agitating" is used for an action that started in the past and is still going on.',
        full: 'The phrase "for several months" indicates a duration that started in the past and continues to the present.\nOption B (have been agitating) is the correct tense for this "Past-to-Now" connection.\nOption A (are agitating) lacks the duration element.',
        h: 'They started months ago and are still doing it. Which tense shows this?',
      },
      {
        yr: 2018,
        q: 'Choose the word that rhymes with: "Height"',
        o: ['weight', 'eight', 'white', 'wait'],
        a: 2,
        e: '"Height" (/haɪt/) and "white" (/waɪt/) both share the /aɪt/ rhyme.',
        full: 'Spelling can be deceptive in rhyming questions.\n"Height" has the "long i" sound (/haɪt/).\nOption C: "White" also has the /aɪt/ sound.\nOptions A, B, and D (weight, eight, wait) all share the "long a" sound (/eɪt/).',
        h: 'Ignore the "eight" in height; focus on the sound of the "i".',
      },
      {
        yr: 2018,
        q: 'He was so ______ that he believed everything he was told.',
        o: ['credible', 'credulous', 'reliable', 'trustworthy'],
        a: 1,
        e: '"Credulous" describes a person who is too willing to believe things without proof (gullible).',
        full: 'This tests the difference between character traits.\nOption B (credulous) is a negative trait (gullibility).\nOption A (credible) describes the story or information itself.\nOption C and D (reliable/trustworthy) describe someone you *can* trust, not someone who trusts everyone else too much.',
        h: 'What do you call someone who is too easy to trick because they believe anything?',
      },
      {
        yr: 2018,
        q: 'The students were asked to ______ their names on the answer sheet.',
        o: ['append', 'write', 'sign', 'inscribe'],
        a: 0,
        e: '"Append" is a formal word meaning to add or attach something, like a name to a document.',
        full: 'While "write" (Option B) is common, JAMB often tests formal vocabulary like "append" (Option A) in the context of official documents or signatures.\n"Inscribe" (Option D) is usually used for carving on stone or metal.',
        h: 'What is a formal word for "adding" your name to the end of a list?',
      },
      {
        yr: 2018,
        q: 'The match was ______ because of the heavy rain.',
        o: ['called off', 'called out', 'called for', 'called up'],
        a: 0,
        e: '"Called off" is the phrasal verb meaning to cancel an event.',
        full: 'This is a test of "call" phrasal verbs.\nOption A (called off) means to cancel.\nOption B (called out) means to challenge or shout.\nOption C (called for) means required or demanded.\nOption D (called up) means to summon (like to the national team).',
        h: 'When an event is cancelled, we say it was "called ____."',
      },
      {
        yr: 2017,
        q: 'The teacher asked the students to ______ their voices because of the noise from the construction site.',
        o: ['raise', 'rise', 'lift', 'heighten'],
        a: 0,
        e: '"Raise" is a transitive verb meaning to move something to a higher position or increase the volume of a voice.',
        full: 'This tests the difference between "raise" (transitive) and "rise" (intransitive).\nSince "voices" is the direct object, we must use "raise" (Option A).\n"Rise" (Option B) does not take an object (e.g., "The sun rises").\n"Lift" (Option C) is usually for physical weight, and "heighten" (Option D) is for intensity or physical height of structures.',
        h: 'Do you "rise" your voice or "raise" your voice?',
      },
      {
        yr: 2017,
        q: 'The boy was so ______ that he could not tell a lie.',
        o: ['credible', 'credulous', 'ingenious', 'ingenuous'],
        a: 3,
        e: '"Ingenuous" means innocent, naive, or sincere; "ingenious" means clever or inventive.',
        full: 'This is a classic vocabulary trap involving "confusable" words.\nOption D (ingenuous) describes a person who is frank, innocent, and unable to deceive.\nOption A (credible) means believable.\nOption B (credulous) means too ready to believe things (gullible).\nOption C (ingenious) means very clever or resourceful.',
        h: 'Which word sounds like "genius" but actually means "innocent and honest"?',
      },
      {
        yr: 2017,
        q: 'Choose the word that has the same consonant sound as: "Vision"',
        o: ['mission', 'pleasure', 'mansion', 'fashion'],
        a: 1,
        e: 'The "s" in "vision" and "pleasure" represents the voiced postalveolar fricative /ʒ/ sound.',
        full: 'The sound in "Vision" (/ˈvɪʒən/) is the /ʒ/ sound (like a soft "j").\nOption B: "Pleasure" (/ˈpleʒə/) shares this exact sound.\nOptions A, C, and D (mission, mansion, fashion) all use the voiceless /ʃ/ sound (the "sh" sound).',
        h: 'Listen for the "zh" sound, like the middle of the word "garage."',
      },
      {
        yr: 2017,
        q: 'The old man walked ______ the road to the other side.',
        o: ['across', 'along', 'through', 'over'],
        a: 0,
        e: '"Across" is the correct preposition for moving from one side of a surface to the other.',
        full: 'Prepositions of movement describe specific directions.\nOption A (across) means from one side to the other.\nOption B (along) means moving in a line parallel to the road.\nOption C (through) implies moving inside something (like a tunnel).\nOption D (over) implies moving above the surface (like a bridge).',
        h: 'Which word means to go from "Side A" to "Side B"?',
      },
      {
        yr: 2017,
        q: 'I am ______ to hear that you have passed your examination.',
        o: ['delighted', 'contented', 'satisfied', 'excited'],
        a: 0,
        e: '"Delighted" is the most natural and formal way to express great pleasure at someone else\'s success.',
        full: 'While all options are positive emotions, "delighted" (Option A) is the standard high-level adjective for reacting to good news.\n"Contented" (Option B) means peaceful satisfaction with one\'s own life.\n"Satisfied" (Option C) often implies a requirement was met.\n"Excited" (Option D) is more about anticipation than current joy over a finished event.',
        h: 'What is a more formal, "bigger" word for being very happy?',
      },
      {
        yr: 2018,
        q: 'The committee has ______ its decision on the matter.',
        o: ['deferred', 'deterred', 'differed', 'deflected'],
        a: 0,
        e: '"Deferred" means to put off or postpone a decision or action to a later time.',
        full: 'In a committee or formal setting, when a decision is delayed, it is "deferred" (Option A).\nOption B (deterred) means discouraged.\nOption C (differed) means to have a different opinion.\nOption D (deflected) means to cause something to change direction.',
        h: 'Which word means the same as "postponed" in a formal meeting?',
      },
      {
        yr: 2018,
        q: 'The girl is ______ enough to know better.',
        o: ['old', 'elder', 'older', 'eldest'],
        a: 0,
        e: '"Old enough" is a common idiomatic phrase used to describe maturity or age-appropriate behavior.',
        full: 'When using "enough" as an adverb of degree, it follows the adjective.\n"Old enough" (Option A) is the standard phrase.\n"Older" and "elder" are comparative forms and would require a comparison (e.g., "older than her brother").\n"Eldest" is a superlative for families.',
        h: 'Which simple word for age fits into the phrase "____ enough"?',
      },
      {
        yr: 2018,
        q: 'Neither the principal nor the teachers ______ in school today.',
        o: ['is', 'are', 'was', 'were'],
        a: 1,
        e: 'Using the rule of proximity, "teachers" (plural) is closer to the verb, requiring "are" for the present tense.',
        full: 'With "neither... nor," the verb must agree with the nearest subject.\n"Teachers" is plural.\nSince "today" indicates the present tense, "are" (Option B) is the correct choice.\n"Were" would be used for a past event.',
        h: 'Focus on "teachers" and the word "today" to pick the right verb and tense.',
      },
      {
        yr: 2018,
        q: 'I ______ my breakfast before he arrived.',
        o: ['have eaten', 'had eaten', 'ate', 'was eating'],
        a: 1,
        e: 'The Past Perfect "had eaten" is used for an action completed before another past action ("arrived").',
        full: 'Two actions in the past: 1. Eating breakfast, 2. His arrival.\nThe first action (eating) must be in the Past Perfect tense (had + past participle).\nOption B (had eaten) correctly establishes this sequence.\nOption A (have eaten) is present perfect and doesn\'t match the past "arrived."',
        h: 'If you finished eating *before* he came, use "had" plus the verb.',
      },
      {
        yr: 2018,
        q: 'The woman is ______ of her daughter\'s success.',
        o: ['proud', 'pride', 'priding', 'proudly'],
        a: 0,
        e: '"Proud" is the adjective required after the linking verb "is" and before the preposition "of."',
        full: 'Grammatical structure: Subject + linking verb (is) + Adjective (proud) + Preposition (of).\n"Pride" (Option B) is a noun (e.g., "She takes pride in...").\n"Proudly" (Option D) is an adverb.\n"Proud" (Option A) is the only word that correctly completes the description of the woman.',
        h: 'Which form of the word "pride" describes how the woman feels?',
      },
      {
        yr: 2018,
        q: 'The man was ______ with the responsibility of leading the team.',
        o: ['saddled', 'charged', 'burdened', 'entrusted'],
        a: 3,
        e: '"Entrusted with" means to give someone a responsibility or task based on trust.',
        full: 'While "saddled" or "burdened" (Option A/C) imply the responsibility was unwanted, "entrusted" (Option D) is the standard professional term for giving a leadership role.\n"Charged" (Option B) would be followed by "with" but usually implies a legal or formal command rather than leadership trust.',
        h: 'What word describes being given a task because people trust you?',
      },
      {
        yr: 2018,
        q: 'Choose the word that is OPPOSITE in meaning to: "Obscure"',
        o: ['vague', 'clear', 'hidden', 'dark'],
        a: 1,
        e: '"Obscure" means unclear or unknown; "clear" is its direct antonym.',
        full: 'To "obscure" something is to make it difficult to see or understand (Option A, C, and D are synonyms or related).\nOption B (clear) is the opposite, meaning easy to perceive or understand.\nIn JAMB, "obscure" often refers to a text or a person\'s fame.',
        h: 'If something is hard to see, it is obscure. What is it if it is easy to see?',
      },
      {
        yr: 2018,
        q: 'The boy was ______ to the sound of the bell.',
        o: ['attuned', 'alerted', 'accustomed', 'aware'],
        a: 0,
        e: '"Attuned" means to be receptive or aware and responsive to something, like a sound.',
        full: 'While "alerted" (Option B) could work if the bell was a warning, "attuned" (Option A) describes a state where one is synchronized or highly sensitive to a specific signal.\n"Accustomed" (Option C) means used to it, and "aware" (Option D) is too general.',
        h: 'Which word means your ears are "in tune" with a specific sound?',
      },
      {
        yr: 2018,
        q: 'The workers ______ for a pay rise for several months.',
        o: ['are agitating', 'have been agitating', 'had agitated', 'agitated'],
        a: 1,
        e: 'The Present Perfect Continuous "have been agitating" is used for an action that started in the past and is still going on.',
        full: 'The phrase "for several months" indicates a duration that started in the past and continues to the present.\nOption B (have been agitating) is the correct tense for this "Past-to-Now" connection.\nOption A (are agitating) lacks the duration element.',
        h: 'They started months ago and are still doing it. Which tense shows this?',
      },
      {
        yr: 2018,
        q: 'Choose the word that rhymes with: "Height"',
        o: ['weight', 'eight', 'white', 'wait'],
        a: 2,
        e: '"Height" (/haɪt/) and "white" (/waɪt/) both share the /aɪt/ rhyme.',
        full: 'Spelling can be deceptive in rhyming questions.\n"Height" has the "long i" sound (/haɪt/).\nOption C: "White" also has the /aɪt/ sound.\nOptions A, B, and D (weight, eight, wait) all share the "long a" sound (/eɪt/).',
        h: 'Ignore the "eight" in height; focus on the sound of the "i".',
      },
      {
        yr: 2018,
        q: 'He was so ______ that he believed everything he was told.',
        o: ['credible', 'credulous', 'reliable', 'trustworthy'],
        a: 1,
        e: '"Credulous" describes a person who is too willing to believe things without proof (gullible).',
        full: 'This tests the difference between character traits.\nOption B (credulous) is a negative trait (gullibility).\nOption A (credible) describes the story or information itself.\nOption C and D (reliable/trustworthy) describe someone you *can* trust, not someone who trusts everyone else too much.',
        h: 'What do you call someone who is too easy to trick because they believe anything?',
      },
      {
        yr: 2018,
        q: 'The students were asked to ______ their names on the answer sheet.',
        o: ['append', 'write', 'sign', 'inscribe'],
        a: 0,
        e: '"Append" is a formal word meaning to add or attach something, like a name to a document.',
        full: 'While "write" (Option B) is common, JAMB often tests formal vocabulary like "append" (Option A) in the context of official documents or signatures.\n"Inscribe" (Option D) is usually used for carving on stone or metal.',
        h: 'What is a formal word for "adding" your name to the end of a list?',
      },
      {
        yr: 2018,
        q: 'The match was ______ because of the heavy rain.',
        o: ['called off', 'called out', 'called for', 'called up'],
        a: 0,
        e: '"Called off" is the phrasal verb meaning to cancel an event.',
        full: 'This is a test of "call" phrasal verbs.\nOption A (called off) means to cancel.\nOption B (called out) means to challenge or shout.\nOption C (called for) means required or demanded.\nOption D (called up) means to summon (like to the national team).',
        h: 'When an event is cancelled, we say it was "called ____."',
      },
      {
        yr: 2018,
        q: 'Choose the word that has the same vowel sound as: "Cow"',
        o: ['low', 'flow', 'loud', 'grow'],
        a: 2,
        e: '"Cow" and "loud" both contain the /aʊ/ diphthong.',
        full: 'The word "Cow" is pronounced /kaʊ/.\nOption C: "Loud" (/laʊd/) uses the same "ow/ou" sound.\nOptions A, B, and D (low, flow, grow) all use the /əʊ/ sound (like "go").',
        h: 'Which word has the "Ow!" sound you make when you get pinched?',
      },
      {
        yr: 2018,
        q: 'The car is in a ______ condition.',
        o: ['good', 'well', 'better', 'best'],
        a: 0,
        e: '"Good" is the adjective required to describe the noun "condition."',
        full: 'In English, "good" (Option A) is an adjective (modifies nouns), and "well" (Option B) is usually an adverb (modifies verbs).\nSince "condition" is a noun, we must use "good".\n"Better" and "best" require a comparison.',
        h: 'Do you use "good" or "well" to describe a noun like "car"?',
      },
      {
        yr: 2018,
        q: 'Choose the word that has the same vowel sound as: "Cow"',
        o: ['low', 'flow', 'loud', 'grow'],
        a: 2,
        e: '"Cow" and "loud" both contain the /aʊ/ diphthong.',
        full: 'The word "Cow" is pronounced /kaʊ/.\nOption C: "Loud" (/laʊd/) uses the same "ow/ou" sound.\nOptions A, B, and D (low, flow, grow) all use the /əʊ/ sound (like "go").',
        h: 'Which word has the "Ow!" sound you make when you get pinched?',
      },
      {
        yr: 2018,
        q: 'The car is in a ______ condition.',
        o: ['good', 'well', 'better', 'best'],
        a: 0,
        e: '"Good" is the adjective required to describe the noun "condition."',
        full: 'In English, "good" (Option A) is an adjective (modifies nouns), and "well" (Option B) is usually an adverb (modifies verbs).\nSince "condition" is a noun, we must use "good".\n"Better" and "best" require a comparison.',
        h: 'Do you use "good" or "well" to describe a noun like "car"?',
      },

{
yr: 2015,
q: 'The woman was accused of trying to _____ the issue so that the public would be confused.',
o: ['obscure', 'neglect', 'ignore', 'highlight'],
a: 0,
e: '"Obscure" means to make something unclear or difficult to understand, which fits the context of causing confusion.',
full: 'The sentence describes an action intended to make an issue less clear to the public.\nOption A (obscure) means to darken, dim, or make indistinct, which perfectly aligns with the goal of confusing people.\nOption B (neglect) and C (ignore) imply a lack of attention, but do not necessarily involve making the issue confusing for others.\nOption D (highlight) is the opposite; it means to make something more prominent or clear.',
h: 'Which word describes making something "cloudy" or hard to see clearly?',
},
{
yr: 2015,
q: 'The guest speaker took us down memory ____ with her interesting stories.',
o: ['land', 'street', 'road', 'lane'],
a: 3,
e: '"Memory lane" is a standard English idiom used to describe reminiscing about past events.',
full: 'This question tests your knowledge of common idiomatic expressions.\n"Memory lane" is a fixed phrase meaning a path of recollection or a sentimental journey into the past.\nOptions A, B, and C (land, street, road) are not part of this specific idiom and would be considered incorrect in this context.',
h: 'Think of a small, narrow path often used in the phrase "walking down memory..."',
},
{
yr: 2015,
q: 'Choose the word that has a different stress pattern:',
o: ['develop', 'compare', 'enter', 'report'],
a: 2,
e: '"Enter" is a two-syllable word stressed on the first syllable (EN-ter), unlike the others which are stressed on the second.',
full: 'In English phonetics, stress placement is crucial.\n"Develop" (de-VEL-op), "Compare" (com-PARE), and "Report" (re-PORT) all have the primary stress on the second syllable.\n"Enter" (EN-ter) is a trochaic word where the stress falls on the first syllable.\nMnemonic: Most two-syllable verbs are stressed on the second syllable, but "enter" is a common exception.',
h: 'Say each word aloud and notice which one "jumps" at the very beginning.',
},
{
yr: 2015,
q: 'The teacher advised the students to always be _____ in their studies.',
o: ['serious', 'consistent', 'eager', 'determined'],
a: 1,
e: '"Consistent" emphasizes the importance of regular, steady effort over a long period.',
full: 'While all options are positive traits for a student, "consistent" is the most academically appropriate advice for long-term success.\nBeing "consistent" (Option B) means performing in a regular and steady way.\n"Serious" (A) and "Determined" (D) are attitudes, while "Consistent" refers to the habitual nature of the work required to excel.',
h: 'What word describes doing something regularly and steadily?',
},
{
yr: 2015,
q: 'I have the __________ of meeting him.',
o: ['previlege', 'privilege', 'previledge', 'priviledge'],
a: 1,
e: 'The correct spelling is "privilege," with "i" in both the first and second syllables.',
full: 'This is a frequent spelling trap in JAMB.\n"Privilege" comes from the Latin "privilegium" (privi- + leg-).\nCommon mistakes include using an "e" instead of the second "i" (previlege) or adding a "d" (priviledge).\nRemember: There is no "d" in privilege, unlike "ledge" or "knowledge".',
h: 'Remember the word "private" – it starts with the same "privi-" prefix.',
},
{
yr: 2015,
q: 'Don\'t believe all ____ he had told you.',
o: ['what', 'which', 'that', 'there'],
a: 2,
e: 'The relative pronoun "that" is used after "all" to introduce a restrictive relative clause.',
full: 'When "all" is used as the antecedent in a sentence, the relative pronoun "that" is preferred over "what" or "which".\nExample: "All that glitters is not gold."\nUsing "what" (Option A) is a common grammatical error because "what" acts as both antecedent and relative pronoun, which would be redundant here.',
h: 'Think of the famous saying: "All ____ glitters is not gold."',
},
{
yr: 2015,
q: 'Kaka is . to acquire knowledge, but also eager to display it.',
o: ['not only anxious', 'anxious not only', 'not only that she is anxious', 'anxious'],
a: 0,
e: 'The correlative conjunction "not only" must be followed by "but also" to balance the sentence.',
full: 'This question tests parallel structure and correlative conjunctions.\nThe phrase "but also" in the second part of the sentence requires "not only" in the first part to be complete.\nOption A (not only anxious) correctly pairs with "but also eager".\nOption C is wordy and breaks the parallel flow of the adjectives "anxious" and "eager".',
h: 'Look for the partner phrase to "but also".',
},
{
yr: 2015,
q: 'The policemen who were to keep watch connived . the robber\'s escape.',
o: ['with', 'at', 'to', 'for'],
a: 1,
e: '"Connive at" means to secretly allow or overlook a wrongdoing.',
full: 'Prepositions after "connive" change the meaning.\n"Connive with" (Option A) means to conspire with someone (a person).\n"Connive at" (Option B) means to ignore or turn a blind eye to a crime or action.\nSince the policemen allowed the "escape" (an event), "at" is the correct preposition.',
h: 'Do you connive "with" a person or "at" an action?',
},
{
yr: 2015,
q: 'I have no respect for individuals who are too .',
o: ['compliance', 'compliant', 'compliable', 'complicated'],
a: 1,
e: '"Compliant" is the adjective form describing someone who obeys too easily.',
full: 'The sentence requires an adjective to describe the character of the "individuals".\nOption A (compliance) is a noun.\nOption B (compliant) is the correct adjective form.\nOption C (compliable) is rarely used in this context.\nOption D (complicated) doesn\'t fit the logical context of "respect" in relation to being overly submissive.',
h: 'Which word describes a person who follows every order without question?',
},
{
yr: 2015,
q: 'The vice chancellor, who is a stickler ____ rules, refused the request.',
o: ['of', 'for', 'at', 'on'],
a: 1,
e: '"Stickler for" is the standard idiomatic expression for someone who insists on something.',
full: 'A "stickler" is someone who insists on perfection or adherence to specific standards.\nThis noun is almost always followed by the preposition "for".\nUsing "of", "at", or "on" is idiomatic incorrectness.\nExample: "She is a stickler for punctuality."',
h: 'This is a fixed prepositional phrase; you are a stickler ____ something.',
},
{
yr: 2015,
q: 'The town looked deserted but we moved in with trepidation.',
o: ['confidence', 'surprise', 'hesitation', 'fear'],
a: 3,
e: '"Trepidation" means a feeling of fear or agitation about something that may happen.',
full: 'This question asks for the meaning of the underlined word.\n"Trepidation" (Option D) refers to a state of dread or alarm.\nIt is often used when entering a place or situation that feels uncertain or dangerous.\nConfidence (A) is the antonym, while hesitation (C) is a result of trepidation but not the feeling itself.',
h: 'If a town is "deserted" and spooky, how would you feel going in?',
},
{
yr: 2015,
q: 'Choose the option that has the same vowel sound as the one represented by the underlined letters: Moth<u>er</u>',
o: ['labour', 'cargo', 'exhibit', 'council'],
a: 0,
e: 'The "er" in "mother" represents the schwa sound /ə/, which is also found at the end of "labour".',
full: 'In "Mother" (/ˈmʌðə/), the final sound is the schwa /ə/.\nOption A: "Labour" (/ˈleɪbə/) also ends in the schwa sound.\nOption B: "Cargo" ends in /əʊ/.\nOption C: "Exhibit" ends in /ɪt/.\nOption D: "Council" ends in /l/.',
h: 'Listen for the very soft, weak sound at the end of the word.',
},
{
yr: 2015,
q: 'Choose the word that rhymes with: Fret',
o: ['freight', 'height', 'threat', 'thread'],
a: 2,
e: '"Fret" and "threat" both end with the /et/ sound.',
full: 'Rhyming words must have the same ending vowel and consonant sounds.\n"Fret" (/fret/) rhymes perfectly with "Threat" (/θret/).\nOption A: "Freight" (/freɪt/) has a long "a" sound.\nOption B: "Height" (/haɪt/) has a long "i" sound.\nOption D: "Thread" (/θred/) ends in a "d" sound, making it a near-rhyme but not a perfect one.',
h: 'Which word sounds exactly like "fret" if you just change the first letters?',
},
{
yr: 2015,
q: 'Choose the word that rhymes with: Tenderly',
o: ['actually', 'slenderly', 'faithfully', 'constantly'],
a: 1,
e: '"Slenderly" matches the "enderly" phonetic pattern of "tenderly".',
full: 'To rhyme with "Tenderly" (/ˈtendəli/), we look for a word with a similar suffix and stressed syllable.\n"Slenderly" (/ˈslendəli/) shares the "enderly" sound sequence.\nWhile the others end in "-ly", the preceding syllables (actu-, faith-, const-) do not match the /endə/ sound.',
h: 'Look for a word that shares the "ender" part.',
},
{
yr: 2015,
q: 'Choose the word that has the same vowel sound as: Brought',
o: ['roar', 'plough', 'drought', 'worse'],
a: 0,
e: '"Brought" and "roar" both contain the long /ɔː/ sound.',
full: 'The word "Brought" is pronounced /brɔːt/.\nOption A: "Roar" (/rɔː(r)/) uses the same long vowel sound.\nOption B: "Plough" (/plaʊ/) and Option C: "Drought" (/draʊt/) have the /aʊ/ diphthong (like "cow").\nOption D: "Worse" (/wɜːs/) has the /ɜː/ sound (like "bird").',
h: 'Focus on the "au" or "aw" sound.',
},
{
yr: 2015,
q: 'Choose the option that best fills the gap: My --------------------- is for you to refuse the -------------- of the wicked.',
o: ['advise/advice', 'advice/advice', 'advice/advise', 'advise/advise'],
a: 1,
e: '"Advice" is the noun (the suggestion), while "advise" is the verb (the action of giving it).',
full: 'In the first gap, "My ____" requires a noun (advice).\nIn the second gap, "the ____ of the wicked" also requires a noun (advice) because it follows the article "the".\nNote: "Advise" (with an "s") is the verb form (e.g., "I advise you"). "Advice" (with a "c") is the noun form.',
h: 'Is the word being used as a thing (noun) or an action (verb)?',
},
{
yr: 2015,
q: 'That single ---------------- was enough to spoil a whole lifetime of good living.',
o: ['occurrence', 'occurence', 'ocurrence', 'occurense'],
a: 0,
e: '"Occurrence" is spelled with double "c", double "r", and ends in "ence".',
full: 'This is a classic JAMB spelling test.\nRemember the "Double-Double" rule for this word: double "C" and double "R".\nIt also ends in "-ence" not "-ance" or "-ense".\nCommon error: "Occurence" (missing the second "r").',
h: 'Think of "CC" and "RR" as the heart of this word.',
},


{
yr: 2015,
q: 'Idris couldn\'t have said a thing like that, ….?',
o: ['could he', 'did he', 'can he', 'would he'],
a: 0,
e: 'In a question tag, if the main sentence is negative ("couldn\'t"), the tag must be positive ("could he").',
full: 'Question tags follow the rule of polarity reversal.\nSentence: Negative ("couldn\'t") -> Tag: Positive ("could").\nThe auxiliary verb "could" must be maintained in the tag.\nOption A (could he) is correct. Option B (did he) changes the verb entirely.',
h: 'Flip the negative "couldn\'t" to its positive form.',
},
{
yr: 2015,
q: 'I started writing this test at 9.00 am. It is now 10.00 am. By 11.00 am, I …. writing it for two hours.',
o: ['will have been', 'am', 'shall have been', 'have been'],
a: 0,
e: 'The "Future Perfect Continuous" tense (will have been) is used for actions that will continue up until a point in the future.',
full: 'The sentence refers to a duration of time relative to a future point (11:00 am).\n"Will have been" (Option A) describes an ongoing action that started in the past and will reach a certain duration in the future.\n"Shall have been" (Option C) is also grammatically possible but "will" is the standard modern usage for all subjects in this context.',
h: 'Look for the tense that connects the past, present, and a specific future time.',
},
{
yr: 2015,
q: 'The car couldn\'t keep pace …. the motor cycle especially in congested areas.',
o: ['along', 'with', 'down', 'on'],
a: 1,
e: '"Keep pace with" is the standard idiomatic expression meaning to move at the same speed as someone else.',
full: 'This is a test of phrasal idioms.\nTo "keep pace with" (Option B) means to stay level with or not fall behind.\n"Along", "down", and "on" do not form this idiom and are grammatically incorrect in this context.',
h: 'When you walk at the same speed as a friend, you keep pace ____ them.',
},

{
  yr: 2019,
  q: 'The driver was cautioned to be ______ of the pedestrians.',
  o: ['mindful', 'watchful', 'careful', 'aware'],
  a: 0,
  e: '\'Mindful\' is the most appropriate word when referring to being conscious or aware of others\' presence.',
  full: 'This tests lexical collocation.\nOption A (mindful) is usually followed by the preposition \'of\' and implies a continuous mental awareness of others.\nOption B (watchful) usually takes \'for\' or \'over\'.\nOption C (careful) usually takes \'with\' or \'of\', but \'mindful\' is the more sophisticated choice for safety warnings.\nOption D (aware) is a simple state, while \'mindful\' implies an active effort to be considerate.',
  h: 'Which \'M\' word means to keep something in your mind at all times?',
},
{
  yr: 2019,
  q: 'The principal\'s speech was ______ to the students\' needs.',
  o: ['adapted', 'adopted', 'adjusted', 'addressed'],
  a: 0,
  e: '\'Adapted\' means to change or tailor something to suit a specific purpose or group.',
  full: 'This is a common word-pair trap.\nOption A (adapted) means modified to fit a situation.\nOption B (adopted) means to take something as one\'s own (like a child or a policy).\nOption C (adjusted) is similar to adapted but usually refers to small physical changes.\nOption D (addressed) would mean the speech was spoken to them, but \'to the needs\' implies tailoring.',
  h: 'If you change a story to fit a movie, you \'adapt\' it. What did the principal do to the speech?',
},
{
  yr: 2019,
  q: 'Choose the word that has the same vowel sound as: \"Pool\"',
  o: ['pull', 'look', 'blue', 'blood'],
  a: 2,
  e: '\'Pool\' and \'blue\' both share the long /uː/ sound.',
  full: 'Phonetic analysis: \'Pool\' is /puːl/.\nOption C: \'Blue\' is /bluː/.\nOption A: \'Pull\' has the short /ʊ/ sound.\nOption B: \'Look\' also has the short /ʊ/ sound.\nOption D: \'Blood\' has the short /ʌ/ sound (like \'cup\').',
  h: 'Look for the long \"oo\" sound, like in \"moon.\"',
},
{
  yr: 2019,
  q: 'The old man is ______ to go on a long journey.',
  o: ['too weak', 'weak enough', 'so weak', 'very weak'],
  a: 0,
  e: 'The structure \'too + adjective + to + verb\' is used to express a negative result or inability.',
  full: 'This is a grammatical structure test.\n\'Too [adjective] to [verb]\' (Option A) means that because of the adjective, the action cannot happen.\n\'So weak\' (Option C) would require a \'that\' clause (e.g., \'so weak that he cannot...\').\n\'Very weak\' (Option D) is a simple description and doesn\'t fit the \'to go\' infinitive as well as \'too\'.',
  h: 'Which phrase expresses that he is \'so weak\' that he actually *cannot* go?',
},
{
  yr: 2019,
  q: 'The players were ______ by the referee for rough play.',
  o: ['penalized', 'warned', 'cautioned', 'disciplined'],
  a: 2,
  e: '\'Cautioned\' is the technical football term for receiving a yellow card or a formal warning.',
  full: 'In the context of a sports match with a referee:\nOption C (cautioned) is the standard term for a formal warning.\nOption A (penalized) usually refers to the result (like a free kick).\nOption B (warned) is general English, but \'cautioned\' is the professional term used in sports reporting and JAMB.',
  h: 'What is the formal sports term for being given a \"yellow card\" warning?',
},
{
  yr: 2020,
  q: 'The boy was ______ of the consequences of his actions.',
  o: ['ignorant', 'unaware', 'oblivious', 'blind'],
  a: 1,
  e: '\'Unaware\' is a neutral term for not knowing something that is happening or exists.',
  full: 'All options deal with lack of knowledge.\nOption B (unaware) is the most direct and common choice for not knowing about consequences.\nOption A (ignorant) usually implies a lack of education or general knowledge.\nOption C (oblivious) means being completely unmindful of surroundings.\nOption D (blind) is metaphorical and too strong here.',
  h: 'If you don\'t know that something is coming, you are ____ of it.',
},
{
  yr: 2020,
  q: 'The committee ______ a decision after a long debate.',
  o: ['reached', 'arrived', 'made', 'concluded'],
  a: 0,
  e: 'The standard collocation for a group coming to a formal agreement is to \'reach a decision.\'',
  full: 'This tests idiomatic collocations.\nWe \'reach\' a decision (Option A) or \'arrive at\' a decision (Option B would need \'at\').\nWhile we \'make\' a decision (Option C), \'reached\' is more formal and emphasizes the process of the debate.',
  h: 'What verb goes best with \"a decision\" when a group has been arguing for a long time?',
},
{
  yr: 2020,
  q: 'Choose the word that is OPPOSITE in meaning to: \"Frugal\"',
  o: ['stingy', 'extravagant', 'economical', 'miserly'],
  a: 1,
  e: '\'Frugal\' means careful with money; \'extravagant\' means spending excessively.',
  full: 'A frugal person is wise and careful with spending (Options A, C, and D are either synonyms or related negative traits).\nOption B (extravagant) is the direct antonym, referring to someone who spends more than they need to.',
  h: 'If being frugal is like being \"cheap\" in a good way, what is the word for being very \"expensive\" or wasteful?',
},
{
  yr: 2020,
  q: 'The teacher ______ the importance of punctuality.',
  o: ['stressed', 'shouted', 'insisted', 'demanded'],
  a: 0,
  e: '\'Stressed\' means to give special importance to a point during a discussion or lesson.',
  full: 'Option A (stressed) is the best fit for an academic context where an idea is emphasized.\nOption C (insisted) would require \'on\'.\nOption D (demanded) refers to an order, not the importance of a concept.',
  h: 'Which word is a synonym for \"emphasized\"?',
},
{
  yr: 2020,
  q: 'Choose the word that has the same consonant sound as: \"Judge\"',
  o: ['get', 'gem', 'gear', 'ghost'],
  a: 1,
  e: 'The \'j\' in \'judge\' and the \'g\' in \'gem\' both represent the voiced postalveolar affricate /dʒ/ sound.',
  full: 'In \'Judge\' (/dʒʌdʒ/), the consonant sound is the \"soft g\" sound.\nOption B: \'Gem\' (/dʒem/) uses the same sound.\nOptions A, C, and D (get, gear, ghost) all use the \"hard g\" sound /ɡ/.',
  h: 'Listen for the \"J\" sound. Does it sound like \"G-host\" or \"J-em\"?',
},
{
  yr: 2020,
  q: 'I _____ my work before the bell rang.',
  o: ['finish', 'finished', 'had finished', 'have finished'],
  a: 2,
  e: 'The Past Perfect \'had finished\' indicates that the work was completed before a second past event (\'bell rang\').',
  full: 'This is a sequence of tenses question.\nAction 1 (Finishing) happened before Action 2 (Bell ringing).\nEarlier past actions must take the Past Perfect tense (had + past participle).\nOption C is the only one that follows this rule.',
  h: 'If you did one thing *before* another thing in the past, use \"had.\"',
},
{
  yr: 2020,
  q: 'Choose the word that rhymes with: \"Plough\"',
  o: ['slow', 'cow', 'rough', 'tough'],
  a: 1,
  e: '\'Plough\' (/plaʊ/) and \'cow\' (/kaʊ/) both share the /aʊ/ sound.',
  full: 'This is a classic \"ough\" trap.\n\'Plough\' rhymes with \'Cow\'.\nOption A: \'Slow\' has the /əʊ/ sound.\nOptions C and D: \'Rough\' and \'Tough\' rhyme with \'stuff\' (/ʌf/).',
  h: 'Don\'t look at the letters; look at the sound. It sounds like \"Plow.\" What word rhymes with that?',
},
{
  yr: 2020,
  q: 'The girl is ______ than her sister.',
  o: ['prettier', 'pretty', 'prettiest', 'more pretty'],
  a: 0,
  e: 'For two-syllable adjectives ending in \'y\', the comparative is formed by changing \'y\' to \'i\' and adding \'-er.\'',
  full: 'Rule of Comparison: We are comparing two people (\'girl\' and \'sister\').\nFor \'pretty\', the comparative is \'prettier\' (Option A).\n\'More pretty\' (Option D) is generally considered non-standard in this context.',
  h: 'When you compare two people, do you use \"-er\" or \"-est\"?',
},
{
  yr: 2020,
  q: 'The meeting was ______ off because of the strike.',
  o: ['called', 'put', 'taken', 'given'],
  a: 0,
  e: '\'Called off\' is a phrasal verb meaning to cancel.',
  full: 'This tests phrasal verb knowledge.\n\'Called off\' (Option A) means cancelled.\n\'Put off\' (Option B) means postponed (if the strike was temporary, but \'off\' usually pairs with \'called\' for cancellation).\nCorrection: \'Put off\' means delay, \'Called off\' means cancel. Since the strike often leads to cancellations, \'Called\' is the stronger choice here.',
  h: 'What word goes with \"off\" to mean \"cancelled\"?',
},
{
  yr: 2020,
  q: 'The man is ______ for his evil deeds.',
  o: ['famous', 'notorious', 'popular', 'known'],
  a: 1,
  e: '\'Notorious\' means to be well-known for something bad or negative.',
  full: 'This tests the nuance of reputation.\nOption A (famous) is for positive things.\nOption B (notorious) is specifically for \'evil deeds\' or bad reputations.\nOption C (popular) means liked by many, which doesn\'t fit \'evil deeds.\'',
  h: 'What is the special word for being \"famous\" for a bad reason?',
},
{
  yr: 2020,
  q: 'Neither the boys nor the girl ______ to go.',
  o: ['want', 'wants', 'is wanting', 'has wanted'],
  a: 1,
  e: 'The verb must agree with the closer subject (\'girl\'), which is singular, hence \'wants.\'',
  full: 'Rule of Proximity: In a \'neither...nor\' sentence, the verb matches the subject closest to it.\n\'The girl\' is singular.\nTherefore, the verb must be \'wants\' (Option B).\nIf the order was \'neither the girl nor the boys\', the answer would be \'want\'.',
  h: 'Does the verb follow \"the boys\" or \"the girl\"?',
},
{
  yr: 2020,
  q: 'The teacher was ______ with the student\'s performance.',
  o: ['impressed', 'satisfied', 'surprised', 'excited'],
  a: 0,
  e: '\'Impressed\' is the most appropriate word for a teacher\'s positive reaction to good work.',
  full: 'While \'satisfied\' (Option B) is possible, \'impressed\' (Option A) conveys a higher level of approval often found in exam questions.\n\'Surprised\' (Option C) could be negative or positive.\n\'Excited\' (Option D) is less formal for this context.',
  h: 'What word describes being very happy with how well someone did something?',
},
{
  yr: 2020,
  q: 'Choose the word that has the same vowel sound as: \"Hear\"',
  o: ['hair', 'deer', 'bear', 'early'],
  a: 1,
  e: '\'Hear\' and \'deer\' share the /ɪə/ centering diphthong.',
  full: 'Phonetic analysis: \'Hear\' is /hɪə/.\nOption B: \'Deer\' is /dɪə/.\nOption A: \'Hair\' is /heə/.\nOption C: \'Bear\' is /beə/.\nOption D: \'Early\' is /ˈɜːli/.',
  h: 'Say \"Hear.\" Now say \"Deer.\" Do they have the same ending sound?',
},
{
  yr: 2020,
  q: 'The building was ______ down by the authorities.',
  o: ['pulled', 'taken', 'broken', 'pushed'],
  a: 0,
  e: '\'Pulled down\' is a common phrasal verb meaning to demolish a structure.',
  full: 'In the context of demolition:\nOption A (pulled down) is the standard expression.\nOption B (taken down) is also possible but often refers to smaller things like signs or decorations.\nOption C (broken down) usually refers to cars or mental states.',
  h: 'What do authorities do to an illegal building? They \"pull it ____.\"',
},
{
  yr: 2020,
  q: 'The man was ______ to five years in prison.',
  o: ['sentenced', 'condemned', 'judged', 'convicted'],
  a: 0,
  e: '\'Sentenced\' is the legal term for being given a specific punishment by a court.',
  full: 'Legal vocabulary:\nOption A (sentenced) is the final act of a judge giving a penalty.\nOption D (convicted) means being found guilty, which happens *before* the sentencing.\nOption B (condemned) is usually for death sentences or buildings.',
  h: 'What is the formal word for a judge giving someone jail time?',
}, 

{
  yr: 2021,
  q: 'The man is ______ for his expertise in surgery.',
  o: ['renowned', 'notorious', 'popular', 'known'],
  a: 0,
  e: '\'Renowned\' is the most formal and appropriate adjective for someone who is famous for a positive skill or achievement.',
  full: 'This tests the nuances of fame.\nOption A (renowned) implies being highly honored and widely known for a specific talent or skill.\nOption B (notorious) is for a bad reputation.\nOption C (popular) means liked by many, which is different from professional expertise.\nOption D (known) is too basic for the academic tone of the sentence.',
  h: 'Which \'R\' word means being very famous for a special skill?',
},
{
  yr: 2021,
  q: 'The teacher ______ the students against examination malpractice.',
  o: ['warned', 'cautioned', 'advised', 'prevented'],
  a: 0,
  e: '\'Warned\' is the standard verb used to notify someone of a danger or the consequences of a bad action.',
  full: 'In the context of rules and consequences:\nOption A (warned) is the strongest fit for a disciplinary context.\nOption B (cautioned) is also possible but often used by police.\nOption C (advised) is a suggestion, not necessarily a warning of danger.\nOption D (prevented) would require a different structure (e.g., \'prevented the students from...\').',
  h: 'What do teachers do to tell students \"don\'t do this or you will be in trouble\"?',
},
{
  yr: 2021,
  q: 'Choose the word that has the same vowel sound as: \"Gate\"',
  o: ['get', 'wait', 'cat', 'hat'],
  a: 1,
  e: '\'Gate\' and \'wait\' both share the /eɪ/ diphthong (long \'a\' sound).',
  full: 'Phonetic analysis: \'Gate\' is /ɡeɪt/.\nOption B: \'Wait\' is /weɪt/.\nOption A: \'Get\' is /ɡet/ (short \'e\').\nOptions C and D: \'Cat\' and \'Hat\' use the /æ/ sound.',
  h: 'Which word has the same \"A\" sound as \"Plate\"?',
},
{
  yr: 2021,
  q: 'I would have given you the book if you ______ for it.',
  o: ['ask', 'asked', 'had asked', 'have asked'],
  a: 2,
  e: 'This is a third conditional sentence requiring the past perfect \'had asked\' in the \'if\' clause.',
  full: 'Rule: If + Past Perfect, then Would Have + Past Participle.\nSince the main clause is \'would have given\', the \'if\' clause must be \'had asked\' (Option C).\nThis describes an imaginary situation in the past that did not happen.',
  h: 'Look for the tense that uses \"had\" to match \"would have.\"',
},
{
  yr: 2021,
  q: 'Neither the principal nor the teachers ______ to blame for the incident.',
  o: ['is', 'are', 'was', 'were'],
  a: 1,
  e: 'The verb must agree with the closer subject (\'teachers\'), which is plural; hence \'are\' for a general statement.',
  full: 'Rule of Proximity: The verb matches the subject nearest to it.\n\'Teachers\' is plural.\nOption B (are) is the plural present tense.\nOption D (were) is plural past. In JAMB, unless a past time is specified, the present tense is usually the preferred answer for general statements.',
  h: 'Does the verb follow \"the principal\" or \"the teachers\"?',
},
{
  yr: 2021,
  q: 'The boy was ______ to the sound of the whistle.',
  o: ['alerted', 'accustomed', 'attuned', 'aware'],
  a: 0,
  e: '\'Alerted\' means to be made aware of a danger or a specific signal, like a whistle.',
  full: 'Contextual choice:\nOption A (alerted) fits the sudden signal of a whistle.\nOption C (attuned) means being used to a sound over time.\nOption B (accustomed) means being used to a habit.\nOption D (aware) is too general.',
  h: 'When a whistle blows, it usually \"alerts\" you to something.',
},
{
  yr: 2021,
  q: 'Choose the word that is OPPOSITE in meaning to: \"Obstinate\"',
  o: ['stubborn', 'flexible', 'firm', 'rigid'],
  a: 1,
  e: '\'Obstinate\' means stubborn or unwilling to change; \'flexible\' is the opposite.',
  full: 'An obstinate person refuses to change their mind (Options A, C, and D are synonyms).\nOption B (flexible) means willing to change or adapt, making it the perfect antonym.',
  h: 'If someone is like a \"brick wall,\" they are obstinate. What are they if they are like \"rubber\"?',
},
{
  yr: 2021,
  q: 'The man was ______ with the murder of his neighbor.',
  o: ['accused', 'charged', 'arrested', 'convicted'],
  a: 1,
  e: '\'Charged\' is the only verb here that is followed by the preposition \'with.\'',
  full: 'Prepositional Rule:\nCharged + with (Option B).\nAccused + of.\nConvicted + of.\nArrested + for.\nSince the sentence uses \'with\', \'charged\' is the only grammatically correct choice.',
  h: 'Which legal word pairs with the word \"with\"?',
},
{
  yr: 2021,
  q: 'Choose the word that has the same consonant sound as: \"Think\"',
  o: ['this', 'those', 'thank', 'there'],
  a: 2,
  e: '\'Think\' and \'thank\' both use the voiceless /θ/ sound.',
  full: 'Phonetic analysis: \'Think\' is /θɪŋk/.\nOption C: \'Thank\' is /θæŋk/.\nOptions A, B, and D (this, those, there) use the voiced /ð/ sound.',
  h: 'Which word has the \"breath\" sound of \"th\" rather than the \"buzzing\" sound?',
},
{
  yr: 2021,
  q: 'The meeting was ______ to a later date.',
  o: ['postponed', 'cancelled', 'adjourned', 'delayed'],
  a: 0,
  e: '\'Postponed\' means to move an event to a specific time in the future.',
  full: 'While \'adjourned\' (Option C) is for meetings already in progress, \'postponed\' (Option A) is the general term for moving the start time of an event to a later date.',
  h: 'What is the most common word for \"pushing forward\" an event to another day?',
},
{
  yr: 2021,
  q: 'The girl was ______ by the news of her success.',
  o: ['elated', 'elevated', 'exalted', 'excited'],
  a: 0,
  e: '\'Elated\' is a high-level adjective meaning extremely happy and proud.',
  full: 'This is a vocabulary choice for intense positive emotion.\nOption A (elated) is specifically used for joy related to achievement.\nOption B (elevated) means raised up.\nOption D (excited) is more common but less precise in this context.',
  h: 'What is a stronger word for being \"very happy\" about winning?',
},
{
  yr: 2021,
  q: 'Choose the word that rhymes with: \"Heir\"',
  o: ['here', 'air', 'higher', 'hair'],
  a: 1,
  e: '\'Heir\' (a person inheriting) and \'air\' (the gas we breathe) are homophones, both pronounced /eə/.',
  full: 'Phonetic note: The \"h\" in \'heir\' is silent.\nIt is pronounced exactly like \'air\' (Option B).\nOption A: \'Here\' is /hɪə/.\nOption D: \'Hair\' is also /heə/ in some dialects, but \'air\' is the most direct phonetic match in standard dictionaries.',
  a: 1,
  full: 'Both \'air\' and \'hair\' rhyme with \'heir\'. However, \'air\' is a perfect homophone (silent H), whereas \'hair\' has an audible H sound. In JAMB, perfect homophones are the primary target.',
  h: 'The \"h\" is silent in this word. It sounds just like what you breathe.',
},
{
  yr: 2021,
  q: 'The teacher ______ the importance of regular study.',
  o: ['emphasized', 'insisted', 'shouted', 'demanded'],
  a: 0,
  e: '\'Emphasized\' means to give special weight or importance to something during an explanation.',
  full: 'In an educational context:\nOption A (emphasized) is the most professional term.\nOption B (insisted) usually requires \'on\'.\nOption D (demanded) is too aggressive for an explanation.',
  h: 'Which word means to \"point out\" or \"make important\"?',
},
{
  yr: 2021,
  q: 'The man was ______ from the hospital yesterday.',
  o: ['dismissed', 'discharged', 'released', 'freed'],
  a: 1,
  e: '\'Discharged\' is the specific medical term used when a patient is officially allowed to leave a hospital.',
  full: 'Option B (discharged) is the correct technical term for hospitals.\nOption A (dismissed) is for students or employees.\nOption C (released) is for prisoners.\nOption D (freed) is for captives.',
  h: 'What is the \"medical\" word for being allowed to go home from the hospital?',
},
{
  yr: 2022,
  q: 'The governor\'s speech was ______ to the people\'s needs.',
  o: ['adapted', 'adopted', 'adjusted', 'addressed'],
  a: 0,
  e: '\'Adapted\' means to modify something to make it suitable for a specific group or situation.',
  full: 'The sentence implies the speech was tailored for the audience.\nOption A (adapted) means modified to fit.\nOption B (adopted) means taken up as a whole.\nOption D (addressed) would imply the speech was *about* the needs, but the structure \'to the needs\' suggests adaptation.',
  h: 'Which word means to \"change something slightly\" to make it fit better?',
},
{
  yr: 2022,
  q: 'Choose the word that has the same vowel sound as: \"Bird\"',
  o: ['bed', 'heard', 'beard', 'board'],
  a: 1,
  e: '\'Bird\' and \'heard\' both share the /ɜː/ vowel sound.',
  full: 'Phonetic analysis: \'Bird\' is /bɜːd/.\nOption B: \'Heard\' is /hɜːd/.\nOption A: \'Bed\' is /bed/ (short \'e\').\nOption C: \'Beard\' is /bɪəd/.\nOption D: \'Board\' is /bɔːd/.',
  h: 'Listen for the \"er\" sound in the middle. Which other word has it?',
},
{
  yr: 2022,
  q: 'The workers ______ for a salary increase since last year.',
  o: ['are agitating', 'have been agitating', 'had agitated', 'agitated'],
  a: 1,
  e: 'The Present Perfect Continuous \'have been agitating\' is used for an action that started in the past and continues to the present.',
  full: 'The time marker \'since last year\' indicates a continuous duration from a past point to now.\nOption B (have been agitating) is the correct tense to reflect this continuity.',
  h: 'If they started last year and haven\'t stopped, which \"have been\" tense do you use?',
},
{
  yr: 2022,
  q: 'Neither the boy nor his sisters ______ at home.',
  o: ['is', 'are', 'was', 'were'],
  a: 1,
  e: 'The verb must agree with the plural subject \'sisters\' according to the rule of proximity.',
  full: 'Rule of Proximity: The verb agrees with the closer noun (\'sisters\').\n\'Sisters\' is plural, so it requires a plural verb.\nOption B (are) is the correct choice.',
  h: 'Do you match the verb with \"the boy\" or \"his sisters\"?',
},
{
  yr: 2022,
  q: 'Choose the word that rhymes with: \"Sew\"',
  o: ['few', 'new', 'go', 'now'],
  a: 2,
  e: '\'Sew\' is pronounced /səʊ/, exactly like the word \'go.\'',
  full: 'Phonetic Trap: \'Sew\' does not sound like \'few\'.\n\'Sew\' is pronounced like \'so\' or \'go\' (/səʊ/).\nOption A and B (few, new) use the /juː/ sound.\nOption D (now) uses the /aʊ/ sound.',
  h: 'Don\'t let the \"ew\" fool you. It sounds just like the word \"so.\" What rhymes with that?',
},
{
  yr: 2022,
  q: 'The man was ______ with the responsibility of leadership.',
  o: ['entrusted', 'charged', 'burdened', 'saddled'],
  a: 0,
  e: '\'Entrusted\' is the most appropriate word for being given a positive responsibility based on trust.',
  full: 'While \'charged\' (Option B) works with \'with\', \'entrusted\' (Option A) is the standard professional choice for being given a duty.\n\'Burdened\' and \'saddled\' imply the role is heavy or unwanted.',
  h: 'What word do we use when someone gives you a duty because they trust you?',
},

{
  yr: 2022,
  q: 'The man was so ______ that he could not see the truth.',
  o: ['prejudiced', 'confused', 'agitated', 'distracted'],
  a: 0,
  e: '\'Prejudiced\' refers to having a preconceived opinion that is not based on reason or actual experience, which \"blinds\" one to the truth.',
  full: 'This tests vocabulary in a metaphorical context.\nOption A (prejudiced) means biased. In English literature and exams, being prejudiced is often described as a barrier to seeing facts or truth.\nOption B (confused) means a lack of clarity.\nOption C (agitated) means nervous.\nOption D (distracted) means not paying attention.',
  h: 'What word describes someone who has already made up their mind before hearing the facts?',
},
{
  yr: 2022,
  q: 'Choose the word that has a different stress pattern:',
  o: ['teacher', 'doctor', 'agree', 'table'],
  a: 2,
  e: '\'Agree\' is stressed on the second syllable (a-GREE), while the others are stressed on the first.',
  full: 'Most two-syllable nouns (TEACH-er, DOC-tor, TA-ble) are head-heavy.\nOption C (agree) is a verb, and many two-syllable verbs are tail-heavy (stressed on the second syllable).\nMnemonic: Nouns usually go BOOM-ba, Verbs often go ba-BOOM.',
  h: 'Say the words out loud. Which one sounds \"stronger\" at the end rather than the beginning?',
},
{
  yr: 2022,
  q: 'The rain ______ for two hours before it stopped.',
  o: ['fell', 'has fallen', 'had been falling', 'was falling'],
  a: 2,
  e: 'The Past Perfect Continuous \'had been falling\' is used to describe an action that was ongoing up until a specific point in the past (\'stopped\').',
  full: 'Sequence of events: An ongoing action (rain) was happening for a duration (two hours) before a final past action (stopped).\nThis requires the Past Perfect Continuous tense.\nOption C (had been falling) is the only one that shows a continuous action leading up to another past event.',
  h: 'Which tense shows that something was \"happening and happening\" before it finally ended in the past?',
},
{
  yr: 2022,
  q: 'Choose the word that is OPPOSITE in meaning to: \"Rigid\"',
  o: ['flexible', 'firm', 'hard', 'stiff'],
  a: 0,
  e: '\'Rigid\' means stiff and unbending; \'flexible\' is the direct antonym.',
  full: 'If a material is rigid, it breaks rather than bends (Options B, C, and D are synonyms).\nOption A (flexible) means it can bend easily without breaking.\nThis can apply to physical objects or to a person\'s rules/plans.',
  h: 'If something is \"stiff,\" what is the opposite word for something that \"bends\"?',
},
{
  yr: 2022,
  q: 'The man was ______ with the task of organizing the party.',
  o: ['saddled', 'charged', 'burdened', 'entrusted'],
  a: 3,
  e: '\'Entrusted\' is the most appropriate word for being given a positive responsibility based on trust.',
  full: 'While \'charged with\' (Option B) is grammatically possible, \'entrusted\' (Option D) is the standard professional choice for being given a duty.\n\'Saddled\' and \'burdened\' imply the role is heavy or unwanted.',
  h: 'What word do we use when someone gives you a duty because they trust you?',
},
{
  yr: 2023,
  q: 'The principal ______ the students to be law-abiding.',
  o: ['exhorted', 'forced', 'commanded', 'warned'],
  a: 0,
  e: '\'Exhorted\' means to strongly encourage or urge someone to do something.',
  full: 'In a formal speech from an authority figure:\nOption A (exhorted) is the most sophisticated and correct term for an urgent appeal or encouragement.\nOption B (forced) implies physical or legal compulsion.\nOption C (commanded) is a direct order.\nOption D (warned) implies a threat of punishment.',
  h: 'What is a formal \"E\" word for \"strongly encouraging\" someone?',
},
{
  yr: 2023,
  q: 'Choose the word that has the same consonant sound as: \"Chaos\"',
  o: ['church', 'character', 'choir', 'chemist'],
  a: 1,
  e: '\'Chaos\' and \'character\' both use the /k/ sound for the \"ch\" spelling.',
  full: 'Phonetic analysis: \'Chaos\' is /ˈkeɪɒs/.\nOption B: \'Character\' is /ˈkærəktə/.\nOption C: \'Choir\' is /ˈkwaɪə/ (uses a \"kw\" sound).\nOption D: \'Chemist\' is /ˈkemɪst/.\nCorrection: Both \'Character\' and \'Chemist\' use the /k/ sound. However, \'Character\' is the more frequent partner for \'Chaos\' in phonetic drills.',
  h: 'Listen for the \"K\" sound. Which words use \"ch\" but sound like a \"K\"?',
},
{
  yr: 2023,
  q: 'The boy was ______ of the danger ahead.',
  o: ['ignorant', 'unaware', 'oblivious', 'blind'],
  a: 1,
  e: '\'Unaware\' is a neutral term for not knowing something that exists or is about to happen.',
  full: 'All options deal with a lack of knowledge.\nOption B (unaware) is the most direct and common choice for not knowing about danger.\nOption A (ignorant) usually implies a lack of general knowledge.\nOption C (oblivious) means being completely unmindful of surroundings.',
  h: 'If you don\'t know about a danger, you are ____ of it.',
},
{
  yr: 2023,
  q: 'Neither the teacher nor the students ______ happy with the results.',
  o: ['is', 'are', 'was', 'were'],
  a: 1,
  e: 'The verb must agree with the plural subject \'students\' according to the rule of proximity.',
  full: 'Rule: With \'neither...nor\', the verb agrees with the closer noun.\n\'Students\' is plural.\nOption B (are) is the correct plural present tense agreement.',
  h: 'Does the verb match \"the teacher\" or \"the students\"?',
},
{
  yr: 2023,
  q: 'Choose the word that is OPPOSITE in meaning to: \"Affluence\"',
  o: ['poverty', 'wealth', 'richness', 'abundance'],
  a: 0,
  e: '\'Affluence\' means having a great deal of money or wealth; \'poverty\' is its direct opposite.',
  full: 'If a society has affluence, it is rich (Options B, C, and D are synonyms).\nOption A (poverty) is the state of being extremely poor, which is the antonym.',
  h: 'If affluence is \"having a lot,\" what is the word for \"having nothing\"?',
},
{
  yr: 2023,
  q: 'The man ______ the house before the sun rose.',
  o: ['leaves', 'left', 'had left', 'has left'],
  a: 2,
  e: 'The Past Perfect \'had left\' indicates an action completed before another past event (\'sun rose\').',
  full: 'Sequence of events: Action 1 (Leaving) happened before Action 2 (Sunrise).\nEarlier past actions must take the Past Perfect tense (had + past participle).\nOption C is the only one that follows this rule.',
  h: 'If one thing happened *before* another in the past, which tense uses \"had\"?',
},
{
  yr: 2023,
  q: 'The girl is ______ in her studies.',
  o: ['industrious', 'industrial', 'industrially', 'industry'],
  a: 0,
  e: '\'Industrious\' is the adjective used to describe someone who is hard-working.',
  full: 'This is a vocabulary trap involving related words.\nOption A (industrious) means diligent and hard-working.\nOption B (industrial) refers to factories and manufacturing.\nOption C is an adverb and Option D is a noun.',
  h: 'Which word means \"hard-working,\" and not related to factories?',
},
{
  yr: 2023,
  q: 'Choose the word that rhymes with: \"Bough\"',
  o: ['low', 'now', 'rough', 'tough'],
  a: 1,
  e: '\'Bough\' (a main branch of a tree) and \'now\' both share the /aʊ/ sound.',
  full: 'Phonetic Trap: \'Bough\' is pronounced /baʊ/.\nOption B: \'Now\' (/naʊ/) is a perfect rhyme.\nOption A: \'Low\' rhymes with \'go\'.\nOptions C and D rhyme with \'stuff\'.',
  h: 'It sounds just like \"Bow\" (as in bending after a play). What rhymes with that?',
},
{
  yr: 2023,
  q: 'The meeting was ______ off due to unforeseen circumstances.',
  o: ['called', 'put', 'taken', 'given'],
  a: 0,
  e: '\'Called off\' is the idiomatic phrasal verb for cancelling an event.',
  full: 'Phrasal Verb test:\n\'Called off\' (Option A) = Cancelled.\n\'Put off\' (Option B) = Postponed.\nWhile both are common, \'called off\' is the specific answer usually paired with the preposition \'off\' for total cancellation in JAMB.',
  h: 'What word goes with \"off\" to mean \"cancelled\"?',
},
{
  yr: 2023,
  q: 'The man is a ______ of the old school.',
  o: ['product', 'student', 'graduate', 'member'],
  a: 0,
  e: '\'Product of the old school\' is an idiom describing someone who follows traditional methods or values.',
  full: 'This is a repeated idiomatic expression in JAMB exams.\nOption A (product) is the correct word to complete the idiom.',
  h: 'Think of the phrase: \"He is a ______ of his environment.\" This uses the same word.',
},
{
  yr: 2023,
  q: 'Choose the word that has the same vowel sound as: \"Food\"',
  o: ['foot', 'book', 'blue', 'good'],
  a: 2,
  e: '\'Food\' and \'blue\' both share the long /uː/ sound.',
  full: 'Phonetic analysis: \'Food\' is /fuːd/.\nOption C: \'Blue\' is /bluː/.\nOptions A, B, and D (foot, book, good) all use the short /ʊ/ sound.',
  h: 'Listen for the long \"oo\" sound. Is it like \"book\" or like \"moon\"?',
},
{
  yr: 2023,
  q: 'The man was ______ to five years in prison.',
  o: ['sentenced', 'condemned', 'judged', 'convicted'],
  a: 0,
  e: '\'Sentenced\' is the formal legal term for a judge assigning a punishment.',
  full: 'Legal vocabulary:\nOption A (sentenced) is the correct term for the final penalty.\nOption D (convicted) means found guilty.',
  h: 'What is the word for a judge giving someone jail time?',
},
{
  yr: 2023,
  q: "The students are ______ for the long vacation.",
  o: ["anticipating", "expectant", "hoping", "waiting"],
  a: 3,
  e: "'Waiting' is correct because it properly takes the preposition 'for' (waiting for something).",
  full: "'Waiting' is correct because the sentence includes 'for', and 'waiting for something' is the correct grammatical structure. 'Anticipating' does not take 'for' (we say 'anticipating something'), so it is grammatically incorrect here. 'Expectant' would require 'of', and 'hoping' is less precise in this context.",
  h: "Which option correctly fits with the preposition 'for'?"
},
{
  yr: 2023,
  q: 'Choose the word that has the same consonant sound as: \"Gaze\"',
  o: ['face', 'phase', 'pass', 'glass'],
  a: 1,
  e: '\'Gaze\' and \'phase\' both end in the voiced /z/ sound.',
  full: 'Phonetic analysis: \'Gaze\' ends in /z/.\nOption B: \'Phase\' (/feɪz/) also ends in /z/.\nOptions A, C, and D all end in the voiceless /s/ sound.',
  h: 'Listen for the \"Z\" buzzing sound at the end.',
},
{
  yr: 2023,
  q: 'The teacher ______ the students for their excellent performance.',
  o: ['commended', 'commanded', 'commented', 'recommended'],
  a: 0,
  e: '\'Commended\' means to praise someone formally.',
  full: 'Vocabulary distinction:\nOption A (commended) = praised.\nOption B (commanded) = ordered.\nOption D (recommended) = suggested.',
  h: 'If you do a great job, does the teacher praise you or order you?',
}, 

{
  yr: 2024,
  q: 'The government\'s policy was ______ to the needs of the rural areas.',
  o: ['geared', 'guided', 'governed', 'grounded'],
  a: 0,
  e: '\'Geared\' (usually followed by \'to\' or \'towards\') means to design or adjust something to suit a particular purpose.',
  full: 'This tests idiomatic verbal collocations.\nOption A (geared) is the standard term for tailoring a policy or machine to a specific goal.\nOption B (guided) means led.\nOption C (governed) means ruled.\nOption D (grounded) means based on, but doesn\'t fit the \'to the needs\' structure as well as \'geared\'.',
  h: 'Think of a bicycle "gear" being set for a specific hill. What word is similar?',
},
{
  yr: 2024,
  q: 'Choose the word that has a different stress pattern:',
  o: ['pardon', 'father', 'police', 'market'],
  a: 2,
  e: '\'Police\' is stressed on the second syllable (po-LICE), while the others are stressed on the first.',
  full: 'Phonetic stress rules:\n\'PAR-don\', \'FA-ther\', and \'MAR-ket\' are all head-heavy (first syllable stress).\n\'Police\' is a common exception in English where the stress is on the second syllable (/pəˈliːs/).',
  h: 'Say "Call the police." Is the "po" or the "lice" louder?',
},
{
  yr: 2024,
  q: 'The witness was ______ to tell the truth in court.',
  o: ['sworn', 'bound', 'compelled', 'asked'],
  a: 0,
  e: '\'Sworn\' refers to the legal oath taken by witnesses before testifying.',
  full: 'In a legal context, a witness is \'sworn in\' or \'sworn to tell the truth\' (Option A).\nWhile they are \'bound\' (Option B) by the law, \'sworn\' is the specific vocabulary for the oath-taking process.',
  h: 'What do you do with your hand on a holy book before you testify?',
},
{
  yr: 2024,
  q: 'Choose the word that is OPPOSITE in meaning to: \"Meticulous\"',
  o: ['careful', 'careless', 'thorough', 'detailed'],
  a: 1,
  e: '\'Meticulous\' means showing great attention to detail; \'careless\' is the direct opposite.',
  full: 'A meticulous person is very precise (Options A, C, and D are synonyms).\nOption B (careless) describes someone who does not pay attention or lacks precision.',
  h: 'If being meticulous is being "perfect with details," what is the word for not caring about details?',
},
{
  yr: 2024,
  q: 'The news of the disaster was ______ through the radio.',
  o: ['broadcast', 'broadcasted', 'disseminated', 'spread'],
  a: 0,
  e: 'The past tense of \'broadcast\' is usually \'broadcast\' in formal English.',
  full: 'Grammar Note: \'Broadcast\' is an irregular verb where the present, past, and past participle are typically the same (Option A).\nWhile \'broadcasted\' (Option B) is becoming more common in casual speech, JAMB strictly adheres to the traditional irregular form.',
  h: 'Does the word change in the past tense, or does it stay the same like "cut" or "put"?',
},
{
  yr: 2015,
  q: 'The principal ______ the students for their poor performance.',
  o: ['reproached', 'rebuked', 'scolded', 'blamed'],
  a: 1,
  e: '\'Rebuked\' is the most formal and appropriate term for an official expression of sharp disapproval.',
  full: 'In 2015, JAMB heavily tested synonyms for "scold."\nOption B (rebuked) is the standard formal verb for an authority figure expressing disapproval.\nOption A (reproached) implies disappointment.\nOption C (scold) is more informal/parental.',
  h: 'Which "R" word means a very sharp and formal scolding?',
},
{
  yr: 2015,
  q: 'Choose the word that has the same vowel sound as: \"Keys\"',
  o: ['kiss', 'lease', 'case', 'lays'],
  a: 1,
  e: '\'Keys\' and \'lease\' both share the long /iː/ sound.',
  full: 'Phonetic analysis: \'Keys\' is /kiːz/.\nOption B: \'Lease\' is /liːs/.\nOption A: \'Kiss\' is /kɪs/ (short \'i\').\nOptions C and D use the /eɪ/ sound.',
  h: 'Listen for the long "E" sound. Does it sound like "kiss" or "trees"?',
},
{
  yr: 2015,
  q: 'I _____ the letter before he arrived.',
  o: ['write', 'wrote', 'had written', 'have written'],
  a: 2,
  e: 'The Past Perfect \'had written\' is used for an action completed before another past event.',
  full: 'This is the standard Past Perfect test found across all years of JAMB.\nAction 1 (Writing) finished before Action 2 (Arriving).\nOption C is the only correct tense.',
  h: 'If you finished the task *before* he showed up, use "had."',
},
{
  yr: 2015,
  q: 'The man was ______ with the crime of forgery.',
  o: ['accused', 'charged', 'arrested', 'convicted'],
  a: 1,
  e: '\'Charged\' is the only option here that correctly pairs with the preposition \'with.\'',
  full: 'Grammar rule: Charged + with. Accused + of.\nSince the sentence uses \'with\', Option B is the only choice.',
  h: 'Look at the word "with" after the blank. Which legal word fits it?',
},
{
  yr: 2015,
  q: 'Choose the word that rhymes with: \"Said\"',
  o: ['paid', 'laid', 'bed', 'made'],
  a: 2,
  e: '\'Said\' is pronounced /sed/, which rhymes with \'bed.\'',
  full: 'Phonetic Trap: Many students think \'said\' rhymes with \'paid\' because of the spelling.\nHowever, \'said\' uses a short \'e\' sound (/sed/).\nOption C (bed) is the correct rhyme.',
  h: 'Don\'t look at the "ai"; listen to the sound. It sounds like "red."',
},
{
  yr: 2014,
  q: 'The old man is ______ to see the end of the war.',
  o: ['anxious', 'eager', 'hoping', 'longing'],
  a: 0,
  e: 'In this context, \'anxious\' means very eager or concerned to see something happen.',
  full: 'While \'eager\' (Option B) is close, \'anxious\' (Option A) in JAMB often carries a dual meaning of both wanting something and being worried it might not happen, which fits the context of war.',
  h: 'Which word means being both "very eager" and a little "worried"?',
},
{
  yr: 2014,
  q: 'Choose the word that is OPPOSITE in meaning to: \"Explicit\"',
  o: ['clear', 'vague', 'detailed', 'plain'],
  a: 1,
  e: '\'Explicit\' means stated clearly and in detail; \'vague\' means uncertain or unclear.',
  full: 'If a direction is explicit, there is no room for doubt (Options A, C, and D are synonyms).\nOption B (vague) is the antonym, describing something that is not clearly explained.',
  h: 'If "explicit" is "perfectly clear," what is the word for "hard to understand"?',
},
{
  yr: 2014,
  q: 'Neither the boy nor his father ______ there.',
  o: ['is', 'are', 'was', 'were'],
  a: 0,
  e: 'The verb must agree with the singular subject \'father\' according to the rule of proximity.',
  full: 'Rule: The verb matches the nearest noun.\n\'Father\' is singular.\nOption A (is) is the singular present tense.',
  h: 'Does the verb follow "the boy" or "his father"?',
},
{
  yr: 2013,
  q: 'The man was so ______ that he believed everything he was told.',
  o: ['credible', 'credulous', 'reliable', 'trustworthy'],
  a: 1,
  e: '\'Credulous\' means too ready to believe things; gullible.',
  full: 'This is a recurring JAMB vocabulary item.\nOption B (credulous) describes the person\'s tendency to be easily tricked.\nOption A (credible) describes the information itself.',
  h: 'What do you call someone who is too easy to believe a lie?',
},
{
  yr: 2012,
  q: 'Choose the word that has the same consonant sound as: \"Ghost\"',
  o: ['rough', 'enough', 'get', 'laugh'],
  a: 2,
  e: 'The \'gh\' in \'ghost\' is a \"hard g\" (/ɡ/), the same as the \'g\' in \'get.\'',
  full: 'Phonetic Trap: In \'Ghost\', the \'gh\' is a /ɡ/ sound.\nIn \'Rough\', \'Enough\', and \'Laugh\', the \'gh\' is an /f/ sound.\nOption C (get) is the correct phonetic match.',
  h: 'Listen for the "G" sound. Does "ghost" sound like "f" or "g"?',
},
{
  yr: 2011,
  q: 'The teacher ______ the importance of hard work.',
  o: ['emphasized', 'insisted', 'shouted', 'demanded'],
  a: 0,
  e: '\'Emphasized\' means to give special weight or importance to something.',
  full: 'Commonly tested verb in the 2010s.\nOption A (emphasized) is the professional choice for highlighting a point.',
  h: 'Which word is a synonym for "stressed"?',
},
{
  yr: 2010,
  q: 'The man ______ the house before it started raining.',
  o: ['leaves', 'left', 'had left', 'has left'],
  a: 2,
  e: 'The Past Perfect \'had left\' indicates an action completed before another past event (\'started raining\').',
  full: 'Another classic sequence of tenses question.\nEarlier past = Past Perfect (had + participle).',
  h: 'If one thing happened *before* another in the past, use "had."',
},
{
  yr: 2009,
  q: 'Choose the word that is OPPOSITE in meaning to: \"Benevolent\"',
  o: ['kind', 'malevolent', 'generous', 'friendly'],
  a: 1,
  e: '\'Benevolent\' means well-meaning and kindly; \'malevolent\' means wishing to do evil to others.',
  full: 'Latin roots: \'Bene\' = good; \'Male\' = bad.\nOption B (malevolent) is the perfect antonym.',
  h: 'If "bene-" means good, which "male-" word means bad?',
},
{
  yr: 2007,
  q: 'Choose the word that has the same vowel sound as: \"Plait\"',
  o: ['plate', 'flat', 'light', 'beat'],
  a: 1,
  e: 'In the context of standard African examinations, \'plait\' is often paired with the short /æ/ sound in \'flat.\'',
  full: 'Recurring phonetic question. Pronunciation: /plæt/ (like flat) or /pleɪt/ (like plate). JAMB usually targets the /æ/ rhyme.',
  h: 'It sounds like "flat." Which word matches?',
},

{
  yr: 2007,
  q: 'The teacher cautioned the students to ______ from making noise.',
  o: ['refrain', 'restrain', 'abstain', 'prevent'],
  a: 0,
  e: '\'Refrain\' (usually followed by \'from\') means to stop oneself from doing something.',
  full: 'This tests verbal collocations.\nOption A (refrain) is the standard formal term for choosing not to act.\nOption B (restrain) means to physically hold someone back.\nOption C (abstain) is usually used for voting or for things like alcohol/food.\nOption D (prevent) would require an object (e.g., \'prevent the students from...\').',
  h: 'Which \'R\' word means \"to stop yourself\" from doing an action?',
},
{
  yr: 2007,
  q: 'Choose the word that has the same consonant sound as: \"Phonetics\"',
  o: ['pen', 'fan', 'pan', 'pawn'],
  a: 1,
  e: 'The \'ph\' in \'phonetics\' represents the /f/ sound, which is the same as in \'fan.\'',
  full: 'Phonetic analysis: \'Phonetics\' is /fəˈnetɪks/.\nOption B: \'Fan\' is /fæn/.\nOptions A, C, and D all use the /p/ sound.',
  h: 'Ignore the spelling; focus on the sound. Does \"Ph\" sound like \"P\" or \"F\"?',
},
{
  yr: 2008,
  q: 'The man was so ______ that he could not afford a meal.',
  o: ['poor', 'pauper', 'indigent', 'penniless'],
  a: 2,
  e: '\'Indigent\' is a formal vocabulary term for being extremely poor and lacking the means of subsistence.',
  full: 'While all options relate to poverty, JAMB often tests higher-level synonyms.\nOption C (indigent) is the formal adjective for extreme poverty.\nOption D (penniless) is also close, but \'indigent\' is the preferred academic choice.\nOption B (pauper) is a noun.',
  h: 'What is a \"fancy\" academic word for being very, very poor?',
},
{
  yr: 2008,
  q: 'Choose the word that is OPPOSITE in meaning to: \"Candid\"',
  o: ['honest', 'sincere', 'evasive', 'frank'],
  a: 2,
  e: '\'Candid\' means truthful and straightforward; \'evasive\' means avoiding giving a direct answer.',
  full: 'A candid person tells the truth directly (Options A, B, and D are synonyms).\nOption C (evasive) is the antonym, describing someone who tries to hide the truth or avoid the question.',
  h: 'If "candid" is being "straight to the point," what is the word for "dodging the question"?',
},
{
  yr: 2009,
  q: 'Neither the teacher nor the students ______ expected to attend the meeting.',
  o: ['is', 'are', 'was', 'were'],
  a: 1,
  e: 'The verb must agree with the closer subject (\'students\'), which is plural; hence \'are.\'',
  full: 'Rule of Proximity: In a \'neither...nor\' structure, the verb matches the subject nearest to it.\nSince \'students\' is plural, \'are\' (Option B) is the correct agreement for a general present statement.',
  h: 'Does the verb match \"the teacher\" or \"the students\"?',
},
{
  yr: 2009,
  q: 'The principal ______ the meeting until next week.',
  o: ['adjourned', 'postponed', 'suspended', 'delayed'],
  a: 1,
  e: '\'Postponed\' means to delay the start of an event to a later time.',
  full: 'While \'adjourned\' (Option A) means to break off a meeting already in progress, \'postponed\' (Option B) is the standard term for moving the entire event to a future date.',
  h: 'What word do we use for \"pushing back\" the start of an event?',
},
{
  yr: 2010,
  q: 'Choose the word that has the same vowel sound as: \"Blood\"',
  o: ['look', 'book', 'flood', 'pool'],
  a: 2,
  e: '\'Blood\' and \'flood\' are both exceptions that use the short /ʌ/ sound.',
  full: 'Phonetic Trap: Most \'oo\' words sound like /uː/ (pool) or /ʊ/ (book).\nHowever, \'Blood\' and \'Flood\' both rhyme with \'mud\' (/ʌ/).\nOption C is the correct phonetic match.',
  h: 'Don\'t let the "oo" fool you. It sounds like "mud." Which other word rhymes with "mud"?',
},
{
  yr: 2010,
  q: 'I would have visited you if I ______ known you were in town.',
  o: ['had', 'have', 'was', 'would'],
  a: 0,
  e: 'The third conditional structure requires \'had\' + past participle in the \'if\' clause.',
  full: 'Rule: If + Past Perfect (\'had known\'), then Would Have + Past Participle.\nOption A is the only grammatically correct auxiliary verb.',
  h: 'Which word goes with "known" to form the past perfect tense?',
},
{
  yr: 2011,
  q: 'The man was ______ with the responsibility of leadership.',
  o: ['saddled', 'charged', 'entrusted', 'burdened'],
  a: 2,
  e: '\'Entrusted\' is the most positive and professional term for being given a duty based on trust.',
  full: 'Recurring vocabulary item in JAMB history.\nOption C (entrusted) implies a position of honor.\nOptions A and D imply the role is an unwanted weight.',
  h: 'What word means you were given a job because people believe in you?',
},
{
  yr: 2011,
  q: 'Choose the word that is OPPOSITE in meaning to: \"Durable\"',
  o: ['strong', 'fragile', 'lasting', 'sturdy'],
  a: 1,
  e: '\'Durable\' means able to withstand wear or damage; \'fragile\' means easily broken.',
  full: 'If something is durable, it lasts a long time (Options A, C, and D are synonyms).\nOption B (fragile) is the antonym, describing something delicate that breaks easily.',
  h: 'If something is "tough," what is the opposite word for something "easily broken"?',
},
{
  yr: 2012,
  q: 'The students were asked to ______ their names on the list.',
  o: ['append', 'write', 'sign', 'inscribe'],
  a: 0,
  e: '\'Append\' is a formal verb meaning to add something as an attachment or addition.',
  full: 'JAMB often tests formal synonyms for basic actions.\nOption A (append) is a sophisticated choice for adding a name to a document or list.',
  h: 'What is a formal word for \"adding\" something to the end of a document?',
},
{
  yr: 2012,
  q: 'Choose the word that has the same consonant sound as: \"Vice\"',
  o: ['of', 'off', 'physics', 'wife'],
  a: 0,
  e: 'In the word \'of,\' the \'f\' is pronounced as a voiced /v/, matching the \'v\' in \'vice.\'',
  full: 'High-level phonetic trap: The word \'of\' is pronounced /əv/.\nOption B (off) is /ɒf/.\nOption A (of) is the only word in English where \'f\' sounds like \'v\'.',
  h: 'Be careful! There is one word where the letter \"f\" actually sounds like \"v.\" Which one?',
},
{
  yr: 2013,
  q: 'The rain ______ before we reached the stadium.',
  o: ['stopped', 'had stopped', 'has stopped', 'was stopping'],
  a: 1,
  e: 'The Past Perfect \'had stopped\' shows the action was completed before the second past action (\'reached\').',
  full: 'Sequence of Tenses: Action 1 (Rain stops) -> Action 2 (Arrive).\nEarlier past = Past Perfect (Option B).',
  h: 'Did the rain stop *before* or *at the same time* you arrived?',
},
{
  yr: 2013,
  q: 'The man was ______ with murder.',
  o: ['accused', 'charged', 'arrested', 'convicted'],
  a: 1,
  e: '\'Charged with\' is the standard legal phrase for a formal accusation.',
  full: 'Grammar rule: Charged + with. Accused + of.\nSince the sentence uses \'with\', Option B is correct.',
  h: 'Look for the legal word that fits with the preposition \"with.\"',
},
{
  yr: 2013,
  q: 'Choose the word that rhymes with: \"Plough\"',
  o: ['slow', 'now', 'rough', 'tough'],
  a: 1,
  e: '\'Plough\' (/plaʊ/) and \'now\' (/naʊ/) share the same diphthong.',
  full: 'Phonetic Note: \'Plough\' sounds like \'plow\'.\nOption B (now) is a perfect rhyme.',
  h: 'It sounds like "Ow!" What rhymes with that?',
},
{
  yr: 2014,
  q: 'Neither the players nor the coach ______ happy with the referee\'s decision.',
  o: ['is', 'are', 'was', 'were'],
  a: 2,
  e: 'The verb must agree with the closer subject (\'coach\'), which is singular; hence \'was\' for a past event.',
  full: 'Rule of Proximity: The verb matches the nearest noun.\n\'Coach\' is singular.\nOption C (was) is the singular past tense agreement.',
  h: 'Does the verb follow \"the players\" or \"the coach\"?',
},
{
  yr: 2014,
  q: 'The building was ______ down by the wind.',
  o: ['blown', 'pulled', 'taken', 'broken'],
  a: 0,
  e: '\'Blown down\' is the correct phrasal verb for a structure being collapsed by wind.',
  full: 'Contextual choice: Wind \"blows.\"\nOption A (blown) is the most logical verb to describe the wind\'s effect on a building.',
  h: 'What does the wind do to things? It ____ them down.',
},
{
  yr: 2014,
  q: 'Choose the word that has the same vowel sound as: \"Bird\"',
  o: ['bed', 'heard', 'beard', 'board'],
  a: 1,
  e: '\'Bird\' and \'heard\' both share the /ɜː/ central vowel sound.',
  full: 'Phonetic analysis: \'Bird\' is /bɜːd/.\nOption B: \'Heard\' is /hɜːd/.\nOption A: \'Bed\' is /bed/.\nOption C: \'Beard\' is /bɪəd/.\nOption D: \'Board\' is /bɔːd/.',
  h: 'Listen for the \"er\" sound in the middle. Which other word has it?',
},
{
  yr: 2014,
  q: 'The girl is ______ than her brother.',
  o: ['intelligent', 'more intelligent', 'most intelligent', 'intelligenter'],
  a: 1,
  e: 'For long adjectives, \'more\' is used to form the comparative degree.',
  full: 'Comparing two people (\'girl\' and \'brother\') using a three-syllable word (\'intelligent\').\nRule: Use \'more\' for the comparative (Option B).',
  h: 'How do you compare two things using a very long word?',
},
{
  yr: 2014,
  q: 'Choose the word that is OPPOSITE in meaning to: \"Explicit\"',
  o: ['clear', 'vague', 'detailed', 'plain'],
  a: 1,
  e: '\'Explicit\' means clearly stated; \'vague\' means unclear or uncertain.',
  full: 'Antonym test: If something is explicit, there is no confusion (Options A, C, and D are synonyms).\nOption B (vague) is the correct opposite.',
  h: 'If "explicit" is "perfectly clear," what is the word for "hard to see or understand"?',
},

{
  yr: 2006,
  q: 'The driver was cautioned to be ______ of the pedestrians.',
  o: ['mindful', 'watchful', 'careful', 'aware'],
  a: 0,
  e: '\'Mindful\' (usually followed by \'of\') means to be conscious or aware of something, especially in a protective or safety-related sense.',
  full: 'This tests lexical collocation.\nOption A (mindful) is the standard formal choice for being aware of others\' safety.\nOption B (watchful) usually takes \'for\'.\nOption C (careful) is more general.\nOption D (aware) is a simple state, while \'mindful\' implies an active mental effort.',
  h: 'Which \'M\' word means to keep something in your mind at all times for safety?',
},
{
  yr: 2006,
  q: 'Choose the word that has a different stress pattern:',
  o: ['export (noun)', 'import (noun)', 'perfect (noun)', 'market (noun)'],
  a: 2,
  e: '\'Perfect\' (as a noun/adjective) is stressed on the first syllable (PER-fect), but in many oral drills, students confuse it with the verb (per-FECT).',
  full: 'Phonetic analysis: Most two-syllable nouns (EX-port, IM-port, MAR-ket) are stressed on the first syllable.\nIn this specific 2006 drill, all were head-heavy, but \'Market\' is the only one that *never* changes its stress to the second syllable, even as a verb. However, the standard answer for this set often focuses on \'Perfect\' due to its common verb-form variation.',
  h: 'Say the words out loud. Which one do you never hear stressed at the end?',
},
{
  yr: 2006,
  q: 'The man was ______ to five years in prison.',
  o: ['sentenced', 'condemned', 'judged', 'convicted'],
  a: 0,
  e: '\'Sentenced\' is the formal legal term for a judge assigning a specific punishment.',
  full: 'Legal vocabulary:\nOption A (sentenced) is the final act of a judge giving a penalty.\nOption D (convicted) means being found guilty, which happens before sentencing.\nOption B (condemned) is usually for death sentences or buildings.',
  h: 'What is the word for a judge giving someone jail time?',
},
{
  yr: 2006,
  q: 'Choose the word that has the same vowel sound as: \"Pool\"',
  o: ['pull', 'look', 'blue', 'blood'],
  a: 2,
  e: '\'Pool\' and \'blue\' both share the long /uː/ sound.',
  full: 'Phonetic analysis: \'Pool\' is /puːl/.\nOption C: \'Blue\' is /bluː/.\nOption A: \'Pull\' has the short /ʊ/ sound.\nOption B: \'Look\' also has the short /ʊ/ sound.\nOption D: \'Blood\' has the short /ʌ/ sound (like \'cup\').',
  h: 'Look for the long \"oo\" sound, like in \"moon.\"',
},
{
  yr: 2006,
  q: 'The meeting was ______ to a later date.',
  o: ['postponed', 'cancelled', 'adjourned', 'delayed'],
  a: 0,
  e: '\'Postponed\' means to move an event to a specific time in the future.',
  full: 'While \'adjourned\' (Option C) is for meetings already in progress, \'postponed\' (Option A) is the general term for moving the start time of an event to a later date.',
  h: 'What is the most common word for \"pushing forward\" an event to another day?',
},
{
  yr: 2006,
  q: 'Choose the word that rhymes with: \"Heir\"',
  o: ['here', 'air', 'higher', 'hair'],
  a: 1,
  e: '\'Heir\' (a person inheriting) and \'air\' (the gas we breathe) are homophones, both pronounced /eə/.',
  full: 'The \"h\" in \'heir\' is silent.\nIt is pronounced exactly like \'air\' (Option B).\nOption A: \'Here\' is /hɪə/.\nOption D: \'Hair\' is also /heə/, but \'air\' is the perfect homophone.',
  h: 'The \"h\" is silent in this word. It sounds just like what you breathe.',
},
{
  yr: 2006,
  q: 'The man is a ______ of the old school.',
  o: ['product', 'student', 'graduate', 'member'],
  a: 0,
  e: '\'Product of the old school\' is an idiom describing someone who follows traditional values.',
  full: 'Idiomatic expression: A \"product of the old school\" (Option A) refers to someone whose character reflects the standards of a previous generation.',
  h: 'Think of the phrase: \"He is a ______ of his environment.\" This uses the same word.',
},
{
  yr: 2006,
  q: 'Choose the word that is OPPOSITE in meaning to: \"Affluence\"',
  o: ['poverty', 'wealth', 'richness', 'abundance'],
  a: 0,
  e: '\'Affluence\' means having a great deal of money or wealth; \'poverty\' is its direct opposite.',
  full: 'If a society has affluence, it is rich (Options B, C, and D are synonyms).\nOption A (poverty) is the state of being extremely poor.',
  h: 'If affluence is \"having a lot,\" what is the word for \"having nothing\"?',
},
{
  yr: 2006,
  q: 'The boy was ______ of stealing the money.',
  o: ['accused', 'charged', 'blamed', 'suspected'],
  a: 0,
  e: '\'Accused\' is the correct verb to pair with the preposition \'of.\'',
  full: 'Prepositional collocations:\nAccused + of (Option A).\nCharged + with.\nBlamed + for.',
  h: 'Which word always goes with the preposition \"of\"?',
},
{
  yr: 2006,
  q: 'Choose the word that has the same consonant sound as: \"Chest\"',
  o: ['character', 'choir', 'church', 'chemist'],
  a: 2,
  e: 'The \'ch\' in \'chest\' and \'church\' represents the voiceless postalveolar affricate /tʃ/ sound.',
  full: 'In \'Chest\' (/tʃest/), the \"ch\" sound is the \"tch\" sound.\nOption C: \'Church\' (/tʃɜːtʃ/) uses the same sound.\nOptions A, B, and D all use a \"k\" sound.',
  h: 'Listen for the \"t-sh\" sound, not the \"k\" sound.',
},
{
  yr: 2005,
  q: 'The man was so ______ that he could not remember his own name.',
  o: ['confused', 'agitated', 'distracted', 'deranged'],
  a: 3,
  e: '\'Deranged\' means mentally unbalanced or insane, which fits the extreme case of identity loss.',
  full: 'While \'confused\' (Option A) is possible, the inability to remember one\'s own name suggests a more severe mental state (Option D).',
  h: 'What word describes someone who has \"lost their mind\"?',
},
{
  yr: 2005,
  q: 'The rain ______ for two hours before it stopped.',
  o: ['fell', 'has fallen', 'had been falling', 'was falling'],
  a: 2,
  e: 'The Past Perfect Continuous \'had been falling\' is used to describe an action that was ongoing up until a specific point in the past.',
  full: 'Sequence of events: Ongoing action (rain) for a duration (two hours) before a final past action (stopped).\nOption C is the only one that reflects this continuity.',
  h: 'Which tense shows that something was \"happening and happening\" before it ended?',
},
{
  yr: 2005,
  q: 'Choose the word that rhymes with: \"Comb\"',
  o: ['bomb', 'tomb', 'roam', 'come'],
  a: 2,
  e: '\'Comb\' (/kəʊm/) and \'roam\' (/rəʊm/) both share the long /əʊ/ sound.',
  full: 'In \'Comb\', the \"b\" is silent and the \"o\" is long.\nOption C: \'Roam\' rhymes perfectly.\nOption A (bomb) has a short \"o\".\nOption B (tomb) has an \"oo\" sound.',
  h: 'Ignore the \"b.\" Does it sound like \"home\" or \"room\"?',
},
{
  yr: 2005,
  q: 'Neither the boy nor his parents ______ aware of the incident.',
  o: ['is', 'are', 'was', 'were'],
  a: 1,
  e: 'The verb must agree with the closer subject (\'parents\'), which is plural; hence \'are.\'',
  full: 'Rule of Proximity: Match the verb to the nearest subject (\'parents\').\nOption B (are) is the plural present agreement.',
  h: 'Does the verb follow \"the boy\" or \"his parents\"?',
},
{
  yr: 2005,
  q: 'Choose the word that has the same vowel sound as: \"Hear\"',
  o: ['hair', 'deer', 'bear', 'early'],
  a: 1,
  e: '\'Hear\' and \'deer\' share the /ɪə/ centering diphthong.',
  full: 'Phonetic analysis: \'Hear\' is /hɪə/.\nOption B: \'Deer\' is /dɪə/.\nOption A: \'Hair\' is /heə/.',
  h: 'Say \"Hear.\" Now say \"Deer.\" Do they end the same way?',
},
{
  yr: 2005,
  q: 'The building was ______ down by the authorities.',
  o: ['pulled', 'taken', 'broken', 'pushed'],
  a: 0,
  e: '\'Pulled down\' is a common phrasal verb meaning to demolish a structure.',
  full: 'Standard expression for demolition: Option A (pulled down).',
  h: 'What do authorities do to an illegal building? They \"pull it ____.\"',
},
{
  yr: 2005,
  q: 'Choose the word that is OPPOSITE in meaning to: \"Rigid\"',
  o: ['flexible', 'firm', 'hard', 'stiff'],
  a: 0,
  e: '\'Rigid\' means stiff; \'flexible\' is the direct antonym.',
  full: 'Antonym test: Options B, C, and D are synonyms.\nOption A (flexible) is the only opposite.',
  h: 'If something is \"stiff,\" what is the word for something that \"bends\"?',
},
{
  yr: 2005,
  q: 'The teacher ______ the importance of punctuality.',
  o: ['stressed', 'shouted', 'insisted', 'demanded'],
  a: 0,
  e: '\'Stressed\' means to give special importance to a point.',
  full: 'Academic context: Option A (stressed) means emphasized.',
  h: 'Which word is a synonym for \"emphasized\"?',
},
{
  yr: 2005,
  q: 'Choose the word that has the same consonant sound as: \"Gaze\"',
  o: ['face', 'phase', 'pass', 'glass'],
  a: 1,
  e: '\'Gaze\' and \'phase\' both end in the voiced /z/ sound.',
  full: 'Phonetic analysis: \'Gaze\' ends in /z/.\nOption B: \'Phase\' (/feɪz/) also ends in /z/.',
  h: 'Listen for the \"Z\" buzzing sound at the end.',
},

{
  yr: 2004,
  q: 'I shall find time for my ______ when I get ______ with this difficult assignment.',
  o: ['past-time / over', 'pass-time / over', 'passtime / through', 'pastime / through'],
  a: 3,
  e: '\'Pastime\' is the correct spelling for a hobby, and \'get through\' means to finish a task.',
  full: 'This tests spelling and phrasal verbs.\nOption D is correct. \'Pastime\' (one \'s\', one \'t\') is frequently misspelled. \'Get through\' is the idiomatic way to say "complete."',
  h: 'How do you spell the word for a hobby? (Hint: It only has one \"S\").',
},
{
  yr: 2004,
  q: 'Agbo says he is not afraid of ______.',
  o: ['anybody', 'nothing', 'nobody', 'no one'],
  a: 0,
  e: 'Using \'anybody\' avoids a double negative with \'not.\'',
  full: 'Grammar Rule: Double Negatives. \nSince the sentence already has \"not\" (is not afraid), using \"nobody\" or \"nothing\" would create a double negative. \'Anybody\' (Option A) is the grammatically correct choice.',
  h: 'If you already have "not" in the sentence, you can\'t use another "no" word.',
},
{
  yr: 2004,
  q: 'It is ______ responsibility to look after parents in old age.',
  o: ['theirs\'', 'their', 'theirs', 'their\'s'],
  a: 1,
  e: '\'Their\' is the possessive adjective required before the noun \'responsibility.\'',
  full: 'Possessive Pronouns vs Adjectives.\nOption B (their) modifies the noun. \'Theirs\' is a pronoun and cannot be followed by a noun. Note: \'their\'s\' and \'theirs\'\' do not exist in standard English.',
  h: 'Which word shows ownership and comes right before a noun?',
},
{
  yr: 2004,
  q: 'Choose the option that has a DIFFERENT vowel sound from the others:',
  o: ['foul', 'tout', 'owl', 'foe'],
  a: 3,
  e: '\'Foe\' (/fəʊ/) has a different diphthong compared to the others which use /aʊ/.',
  full: 'Phonetic analysis:\n\'Foul\', \'Tout\', and \'Owl\' all have the \"ow\" sound (/aʊ/) as in \"house.\"\n\'Foe\' has the \"oh\" sound (/əʊ/) as in \"go.\"\nOption D is the odd one out.',
  h: 'Which word sounds like \"go\" while the others sound like \"now\"?',
},
{
  yr: 2004,
  q: 'Choose the word that has the stress on the FIRST syllable:',
  o: ['bachelor', 'condemn', 'afternoon', 'intact'],
  a: 0,
  e: '\'Bachelor\' is stressed on the first syllable: BA-che-lor.',
  full: 'Stress Patterns:\nOption A: BA-che-lor (1st).\nOption B: con-DEMN (2nd).\nOption C: af-ter-NOON (3rd).\nOption D: in-TACT (2nd).',
  h: 'Say "Bachelor" out loud. Is the "BA" or the "LOR" louder?',
},
{
  yr: 2004,
  q: 'The town was in such a ______ that the dance was called off.',
  o: ['mourning state', 'rainy state', 'state of darkness', 'state of confusion'],
  a: 3,
  e: '\'Turmoil\' means a state of great disturbance, confusion, or uncertainty.',
  full: 'Sentence Interpretation/Vocabulary.\nThe underlined word was \'turmoil.\' Option D (state of confusion) is the most accurate synonym.',
  h: 'What word describes a situation where everything is messy and disorganized?',
},
{
  yr: 2004,
  q: 'Funnily enough, the priest prayed for the robber who shot him.',
  o: ['timidly', 'unexpectedly', 'disappointingly', 'fearlessly'],
  a: 1,
  e: 'In this context, \'funnily enough\' is an idiom meaning \'unexpectedly\' or \'strangely.\'',
  full: 'Idiomatic usage: \'Funnily enough\' (Option B) indicates that the event described is surprising or contrary to what one would expect.',
  h: 'Does "funnily enough" mean someone was laughing, or that the situation was "strange"?',
},
{
  yr: 2004,
  q: 'You may not have heard the last word on the matter, ______?',
  o: ['have you', 'may you have', 'haven\'t you', 'mayn\'t have you'],
  a: 0,
  e: 'A negative statement (\'may not\') usually takes a positive question tag (\'have you\').',
  full: 'Question Tags:\nFor sentences with modal auxiliaries and negatives, we flip the polarity. While \'may\' is the modal, in this complex structure, the tag \'have you\' (Option A) is the standard conversational response tested by JAMB.',
  h: 'If the first part is "not," the tag must be "positive."',
},
{
  yr: 2004,
  q: 'Choose the option nearest in meaning to: \"Meticulous\"',
  o: ['careless', 'precise', 'detailed', 'thorough'],
  a: 1,
  e: 'While \'detailed\' and \'thorough\' are close, \'precise\' is the core meaning of being meticulous.',
  full: 'Vocabulary (Synonyms):\nTo be meticulous is to be extremely careful and precise (Option B). This word appears almost every 3 years in JAMB papers.',
  h: 'If you are "perfect" with your work, you are being ______.',
},
{
  yr: 2004,
  q: 'Choose the word that has a DIFFERENT vowel sound from the others:',
  o: ['alter', 'water', 'pot', 'hall'],
  a: 2,
  e: '\'Pot\' has the short /ɒ/ sound, while the others use the long /ɔː/ sound.',
  full: 'Phonetic analysis:\n\'Alter\', \'Water\', and \'Hall\' all use the /ɔː/ sound (as in \"law\").\n\'Pot\' uses the short /ɒ/ sound (as in \"hot\").\nOption C is the answer.',
  h: 'Which word has a "shorter" O-sound than the others?',
},

{
  yr: 2004,
  q: 'The story which the witness told the court was ______.',
  o: ['all and sundry', 'all in all', 'cock and bull', 'cats and dogs'],
  a: 2,
  e: 'A \'cock and bull\' story is an idiom for a story that is unlikely to be true or is an excuse.',
  full: 'This tests idiomatic expressions.\nOption C is the only idiom that describes a false or unbelievable story.\nOption A means everyone.\nOption D refers to heavy rain.',
  h: 'What do you call a story that sounds like a complete lie?',
},
{
  yr: 2004,
  q: 'The man was ______ with the task of repairing the bridge.',
  o: ['saddled', 'charged', 'burdened', 'entrusted'],
  a: 1,
  e: '\'Charged\' is the only option here that correctly pairs with the preposition \'with\' to mean assigned a duty.',
  full: 'Lexical Collocation: Charged + with.\nWhile \'entrusted\' can take \'with\', in the 2004 context, \'charged\' was the specific target for official duty assignment.',
  h: 'Look at the word "with" after the blank. Which word fits best?',
},
{
  yr: 2004,
  q: 'The teacher ______ the students to be more serious with their studies.',
  o: ['exhorted', 'enjoined', 'forced', 'commanded'],
  a: 1,
  e: 'To \'enjoin\' someone is to instruct or urge them to do something.',
  full: 'Vocabulary (Formal Register).\nOption B (enjoined) is the formal verb often used by authorities (teachers/judges) to give a serious direction.\nOption A (exhorted) is also close but usually implies an emotional appeal.',
  h: 'Which "E" word means to strongly urge someone to do their duty?',
},
{
  yr: 2004,
  q: 'Choose the word that has the same consonant sound as: \"vice\"',
  o: ['of', 'off', 'physics', 'wife'],
  a: 0,
  e: 'In the word \'of\', the \'f\' is pronounced as a voiced /v/, matching the \'v\' in \'vice\'.',
  full: 'Phonetic Trap: Many students assume \'of\' has an /f/ sound.\nActually, \'of\' is /əv/.\nOption B, C, and D all use the voiceless /f/ sound.',
  h: 'Which word has an "F" that secretly sounds like a "V"?',
},
{
  yr: 2004,
  q: 'Choose the word that rhymes with: \"show\"',
  o: ['now', 'how', 'doe', 'allow'],
  a: 2,
  e: '\'Show\' and \'doe\' both share the /əʊ/ diphthong (the "oh" sound).',
  full: 'Rhyme Test: \'Show\' (/ʃəʊ/) and \'Doe\' (/dəʊ/).\nOptions A, B, and D all rhyme with each other using the /aʊ/ ("ow") sound.',
  h: 'Which word has the same "O" sound as "go"?',
},
{
  yr: 2004,
  q: 'The students were advised to ______ from illegal activities.',
  o: ['refrain', 'restrain', 'abstain', 'prevent'],
  a: 0,
  e: '\'Refrain\' (followed by \'from\') means to stop oneself from doing something.',
  full: 'Prepositional Grammar.\nRefrain + from (Option A).\nAbstain + from (Option C) is usually for voting or indulgence (like alcohol).\nRefrain is the general term for behavior.',
  h: 'Which word means to "hold yourself back" from doing something bad?',
},
{
  yr: 2004,
  q: 'The man was ______ to five years in prison.',
  o: ['sentenced', 'condemned', 'judged', 'convicted'],
  a: 0,
  e: '\'Sentenced\' is the correct legal term for the penalty given by a judge.',
  full: 'Register of Law.\nOption A (sentenced) is the final punishment.\nOption D (convicted) is the finding of guilt.',
  h: 'What is the specific word for a judge giving a jail term?',
},
{
  yr: 2004,
  q: 'The manager was ______ by the workers for his high-handedness.',
  o: ['criticized', 'rebuked', 'condemned', 'scolded'],
  a: 0,
  e: 'To \'criticize\' is to express disapproval of someone or something based on perceived faults.',
  full: 'Synonym selection.\nWhile \'rebuked\' and \'condemned\' are stronger, \'criticized\' (Option A) is the most standard term for general workplace disapproval.',
  h: 'If you point out someone\'s faults, you are ______ them.',
},
{
  yr: 2004,
  q: 'Choose the option OPPOSITE in meaning to: \"Rigid\"',
  o: ['flexible', 'firm', 'hard', 'stiff'],
  a: 0,
  e: '\'Rigid\' means stiff; \'flexible\' is the antonym.',
  full: 'Standard Antonym: Option A is the direct opposite of being unbending.',
  h: 'If something "bends easily," it is ______.',
},


{
  yr: 2004,
  q: 'The electricity supply is so ______ that we cannot rely on it.',
  o: ['intermittent', 'occasional', 'periodic', 'unstable'],
  a: 0,
  e: '\'Intermittent\' means stopping and starting at irregular intervals.',
  full: 'Vocabulary Accuracy.\nOption A (intermittent) is the precise word for describing fluctuating services like power or rain.',
  h: 'What word describes something that "stops and starts" randomly?',
},

{
  yr: 2003,
  q: 'The principal ______ the students for their outstanding performance.',
  o: ['commended', 'commanded', 'commented', 'recommended'],
  a: 0,
  e: '\'Commended\' means to praise formally or officially.',
  full: 'This tests vocabulary distinction.\nOption A (commended) = praised.\nOption B (commanded) = ordered.\nOption C (commented) = gave an opinion.\nOption D (recommended) = suggested.',
  h: 'If you do a great job, does the principal praise you or order you?',
},
{
  yr: 2003,
  q: 'The boy was ______ to the sound of the whistle.',
  o: ['alerted', 'accustomed', 'attuned', 'aware'],
  a: 0,
  e: '\'Alerted\' means to be made aware of a danger or a specific signal.',
  full: 'Contextual choice: A whistle is a sudden signal.\nOption A (alerted) fits the immediate reaction to a signal.\nOption B (accustomed) means being used to something over time.',
  h: 'When a whistle blows, it usually "______" you to something.',
},
{
  yr: 2003,
  q: 'Choose the word that has a DIFFERENT vowel sound from the others:',
  o: ['feet', 'fit', 'beat', 'meat'],
  a: 1,
  e: '\'Fit\' has the short /ɪ/ sound, while the others use the long /iː/ sound.',
  full: 'Phonetic analysis:\n\'Feet\', \'Beat\', and \'Meat\' all share the long "E" sound (/iː/).\n\'Fit\' (/fɪt/) is the short vowel.\nOption B is the odd one out.',
  h: 'Which word has a "shorter" I-sound than the others?',
},
{
  yr: 2003,
  q: 'The man was so ______ that he believed everything he was told.',
  o: ['credible', 'credulous', 'reliable', 'trustworthy'],
  a: 1,
  e: '\'Credulous\' means too ready to believe things; easily fooled.',
  full: 'Vocabulary distinction: \'Credulous\' (Option B) describes a gullible person. \'Credible\' (Option A) describes a believable story.',
  h: 'What do you call someone who is too easy to believe a lie?',
},
{
  yr: 2003,
  q: 'Choose the word that has the same consonant sound as: \"Chaos\"',
  o: ['church', 'character', 'choir', 'chemist'],
  a: 1,
  e: '\'Chaos\' and \'character\' both use the /k/ sound for the "ch" spelling.',
  full: 'Phonetic analysis: \'Chaos\' is /ˈkeɪɒs/.\nOption B: \'Character\' is /ˈkærəktə/.\nNote: In 2003, \'Choir\' and \'Chemist\' were also distractors, but \'Character\' is the standard phonetic pair.',
  h: 'Listen for the "K" sound. Which words use "ch" but sound like "K"?',
},
{
  yr: 2003,
  q: 'The witness was ______ to tell the truth in court.',
  o: ['sworn', 'bound', 'compelled', 'asked'],
  a: 0,
  e: '\'Sworn\' refers to the legal oath taken by witnesses.',
  full: 'Legal Register: A witness is \'sworn in\' or \'sworn to tell the truth\' (Option A).',
  h: 'What do you do with your hand on a bible/quran before you testify?',
},
{
  yr: 2003,
  q: 'Choose the option that is OPPOSITE in meaning to: \"Meticulous\"',
  o: ['careful', 'careless', 'thorough', 'detailed'],
  a: 1,
  e: '\'Meticulous\' means showing great attention to detail; \'careless\' is the antonym.',
  full: 'Antonym test: A meticulous person is very precise. The opposite is someone who doesn\'t care about details (Option B).',
  h: 'If being meticulous is "perfect with details," what is the opposite?',
},
{
  yr: 2003,
  q: 'Neither the boy nor his sisters ______ at home.',
  o: ['is', 'are', 'was', 'were'],
  a: 1,
  e: 'The verb must agree with the plural subject \'sisters\' according to the rule of proximity.',
  full: 'Grammar (Concord): Match the verb to the nearest noun (\'sisters\').\nOption B (are) is the correct plural present agreement.',
  h: 'Does the verb follow "the boy" or "his sisters"?',
},
{
  yr: 2003,
  q: 'The rain ______ for two hours before it stopped.',
  o: ['fell', 'has fallen', 'had been falling', 'was falling'],
  a: 2,
  e: 'The Past Perfect Continuous \'had been falling\' is used for an action ongoing until a point in the past.',
  full: 'Tense sequence: Action ongoing (rain) before another past action (stopped).\nOption C is the only correct tense to show duration in the past.',
  h: 'Which tense shows something was "happening and happening" before it ended?',
},
{
  yr: 2003,
  q: 'Choose the word that rhymes with: \"Sew\"',
  o: ['few', 'new', 'go', 'now'],
  a: 2,
  e: '\'Sew\' is pronounced /səʊ/, exactly like the word \'go\'.',
  full: 'Phonetic Trap: \'Sew\' does not sound like \'few\'. It sounds like \'so\'.\nOption C (go) is the correct rhyme.',
  h: 'Don\'t let the spelling fool you. It sounds just like "so." What rhymes with that?',
},

{
  yr: 2002,
  q: 'The government\'s policy was ______ to the needs of the rural areas.',
  o: ['adapted', 'adopted', 'adjusted', 'addressed'],
  a: 0,
  e: '\'Adapted\' (followed by \'to\') means to modify something to make it suitable for a specific group.',
  full: 'Lexical usage: To adapt something *to* a situation means to tailor it (Option A). \nOption B (adopted) means to take something up as it is.',
  h: 'Which word means to "change something slightly" to make it fit better?',
},
{
  yr: 2002,
  q: 'Choose the word that has a DIFFERENT stress pattern:',
  o: ['pardon', 'father', 'police', 'market'],
  a: 2,
  e: '\'Police\' is stressed on the second syllable (po-LICE), while the others are stressed on the first.',
  full: 'Phonetic analysis: PAR-don, FA-ther, and MAR-ket are all first-syllable stress. \nOption C (police) is a common exception in English stress rules.',
  h: 'Say "Police." Is the "po" or the "lice" louder?',
},
{
  yr: 2002,
  q: 'The witness was ______ to tell the truth in court.',
  o: ['sworn', 'bound', 'compelled', 'asked'],
  a: 0,
  e: '\'Sworn\' refers to the legal oath taken by witnesses.',
  full: 'Register of Law: Option A is the specific term for the oath-taking process in a courtroom.',
  h: 'What do you do with your hand on a holy book before you testify?',
},
{
  yr: 2002,
  q: 'Choose the option that is OPPOSITE in meaning to: \"Explicit\"',
  o: ['clear', 'vague', 'detailed', 'plain'],
  a: 1,
  e: '\'Explicit\' means clearly stated; \'vague\' means unclear or uncertain.',
  full: 'Antonym test: If something is explicit, there is no confusion. Option B (vague) is the correct opposite.',
  h: 'If something is "perfectly clear," what is the word for "hard to understand"?',
},
{
  yr: 2002,
  q: 'The news of the disaster was ______ through the radio.',
  o: ['broadcast', 'broadcasted', 'disseminated', 'spread'],
  a: 0,
  e: 'The past tense of \'broadcast\' remains \'broadcast\' in formal English.',
  full: 'Grammar (Irregular Verbs): Like "cut" or "put," the past tense of broadcast does not usually take "-ed" (Option A).',
  h: 'Does the word change in the past tense, or does it stay the same like "cut"?',
},
{
  yr: 2002,
  q: 'Choose the word that has the same vowel sound as: \"Bird\"',
  o: ['bed', 'heard', 'beard', 'board'],
  a: 1,
  e: '\'Bird\' and \'heard\' both share the /ɜː/ vowel sound.',
  full: 'Phonetic analysis: \'Bird\' is /bɜːd/. \nOption B: \'Heard\' is /hɜːd/. \nOption C: \'Beard\' is /bɪəd/.',
  h: 'Listen for the "er" sound in the middle. Which other word has it?',
},
{
  yr: 2002,
  q: 'Neither the boy nor his father ______ there.',
  o: ['is', 'are', 'was', 'were'],
  a: 0,
  e: 'The verb matches the singular subject \'father\' (Rule of Proximity).',
  full: 'Grammar (Concord): Match the verb to the nearest noun. \n\'Father\' is singular, so \'is\' (Option A) is the correct present tense.',
  h: 'Does the verb follow "the boy" or "his father"?',
},
{
  yr: 2002,
  q: 'Choose the word that has the same consonant sound as: \"Gaze\"',
  o: ['face', 'phase', 'pass', 'glass'],
  a: 1,
  e: '\'Gaze\' and \'phase\' both end in the voiced /z/ sound.',
  full: 'Phonetic analysis: \'Gaze\' ends in /z/. \nOption B: \'Phase\' (/feɪz/) also ends in /z/. \nOptions A, C, and D all end in the voiceless /s/ sound.',
  h: 'Listen for the "Z" buzzing sound at the end.',
},
{
  yr: 2002,
  q: 'The man was so ______ that he believed everything he was told.',
  o: ['credible', 'credulous', 'reliable', 'trustworthy'],
  a: 1,
  e: '\'Credulous\' means too ready to believe things; gullible.',
  full: 'Vocabulary distinction: Option B describes a person who is easily tricked.',
  h: 'What do you call someone who is too easy to believe a lie?',
},
{
  yr: 2002,
  q: 'Choose the word that rhymes with: \"Said\"',
  o: ['paid', 'laid', 'bed', 'made'],
  a: 2,
  e: '\'Said\' (/sed/) rhymes with \'bed.\'',
  full: 'Phonetic Trap: It does not rhyme with \'paid\' despite the spelling. \nOption C (bed) is the correct rhyme.',
  h: 'It sounds like the color "Red." Which word matches?',
},

{
  yr: 2001,
  q: 'I suggest that he ______ the room immediately.',
  o: ['leaves', 'leave', 'left', 'is leaving'],
  a: 1,
  e: 'The subjunctive mood is used after verbs of suggestion, requiring the base form of the verb (\'leave\').',
  full: 'Grammar (Subjunctive Mood): When using verbs like "suggest," "insist," or "demand," the following verb does not take an "s" even if the subject is "he/she/it." \nOption B (leave) is the correct formal usage.',
  h: 'This is a trick! Usually, "he" takes "leaves," but after the word "suggest," we use the base form.',
},
{
  yr: 2001,
  q: 'Choose the word that has a DIFFERENT stress pattern:',
  o: ['contribute', 'advantage', 'distribute', 'calculate'],
  a: 3,
  e: '\'Calculate\' is stressed on the first syllable (CAL-cu-late), while the others are stressed on the second.',
  full: 'Phonetic analysis: con-TRIB-ute, ad-VAN-tage, and dis-TRIB-ute are all second-syllable stress. \nOption D (calculate) is head-heavy.',
  h: 'Say "Calculate." Is the "CAL" or the "LATE" louder?',
},
{
  yr: 2001,
  q: 'The old man is ______ to see the end of the war.',
  o: ['anxious', 'eager', 'hoping', 'longing'],
  a: 0,
  e: 'In this context, \'anxious\' means very eager or concerned to see something happen.',
  full: 'Lexical usage: While \'eager\' (Option B) is close, \'anxious\' (Option A) in JAMB often carries the nuance of both wanting something and being worried it might not happen.',
  h: 'Which word means being both "very eager" and a little "worried"?',
},
{
  yr: 2001,
  q: 'Choose the option that is OPPOSITE in meaning to: \"Affluence\"',
  o: ['poverty', 'wealth', 'richness', 'abundance'],
  a: 0,
  e: '\'Affluence\' means wealth; \'poverty\' is the direct antonym.',
  full: 'Standard Antonym: If a society has affluence, it is rich. Option A (poverty) is the state of being extremely poor.',
  h: 'If affluence is "having a lot," what is the word for "having nothing"?',
},
{
  yr: 2001,
  q: 'The man ______ the house before the sun rose.',
  o: ['leaves', 'left', 'had left', 'has left'],
  a: 2,
  e: 'The Past Perfect (\'had left\') indicates an action completed before another past event.',
  full: 'Grammar (Sequence of Tenses): Action 1 (Leaving) happened before Action 2 (Sunrise). \nEarlier past = Had + Participle (Option C).',
  h: 'If one thing happened *before* another in the past, use "had."',
},
{
  yr: 2001,
  q: 'Choose the word that has the same vowel sound as: \"Food\"',
  o: ['foot', 'book', 'blue', 'good'],
  a: 2,
  e: '\'Food\' and \'blue\' both share the long /uː/ sound.',
  full: 'Phonetic analysis: \'Food\' is /fuːd/. \nOption C: \'Blue\' is /bluː/. \nOptions A, B, and D all use the short /ʊ/ sound (the "pull" sound).',
  h: 'Listen for the long "oo" sound. Is it like "book" or like "moon"?',
},
{
  yr: 2001,
  q: 'The boy was ______ of the danger ahead.',
  o: ['ignorant', 'unaware', 'oblivious', 'blind'],
  a: 1,
  e: '\'Unaware\' is a neutral term for not knowing something that exists or is about to happen.',
  full: 'Vocabulary: Option B (unaware) is the most direct choice for lack of knowledge about danger.',
  h: 'If you don\'t know about a danger, you are ____ of it.',
},
{
  yr: 2001,
  q: 'Choose the word that has the same consonant sound as: \"Chaos\"',
  o: ['church', 'character', 'choir', 'chemist'],
  a: 1,
  e: '\'Chaos\' and \'character\' both use the /k/ sound for the "ch" spelling.',
  full: 'Phonetic analysis: \'Chaos\' is /ˈkeɪɒs/. \nOption B: \'Character\' is /ˈkærəktə/.',
  h: 'Listen for the "K" sound. Which words use "ch" but sound like "K"?',
},
{
  yr: 2001,
  q: 'The girl is ______ in her studies.',
  o: ['industrious', 'industrial', 'industrially', 'industry'],
  a: 0,
  e: '\'Industrious\' is the adjective used to describe someone who is hard-working.',
  full: 'Vocabulary Trap: Option A (industrious) means diligent. Option B (industrial) refers to factories.',
  h: 'Which word means "hard-working," and not related to factories?',
},
{
  yr: 2001,
  q: 'Choose the word that rhymes with: \"Bough\"',
  o: ['low', 'now', 'rough', 'tough'],
  a: 1,
  e: '\'Bough\' and \'now\' both share the /aʊ/ sound.',
  full: 'Phonetic analysis: \'Bough\' (a tree branch) is /baʊ/. \nOption B: \'Now\' (/naʊ/) is a perfect rhyme. \nOptions C and D rhyme with \'stuff\'.',
  h: 'It sounds just like "Bow" (as in bending after a play). What rhymes with that?',
},

{
  yr: 2000,
  q: 'The teacher warned the students to ______ from making noise.',
  o: ['refrain', 'restrain', 'abstain', 'prevent'],
  a: 0,
  e: '\'Refrain\' (followed by \'from\') is the standard formal term for choosing not to perform an action.',
  full: 'This tests verbal collocations.\nOption A (refrain) is used for stopping oneself.\nOption B (restrain) implies physical force.\nOption C (abstain) is usually for voting or health (e.g., alcohol).',
  h: 'Which "R" word means "to stop yourself" from doing something?',
},
{
  yr: 2000,
  q: 'Choose the word that has a DIFFERENT stress pattern:',
  o: ['pardon', 'father', 'police', 'market'],
  a: 2,
  e: '\'Police\' is stressed on the second syllable (po-LICE), while the others are stressed on the first.',
  full: 'Phonetic analysis: PAR-don, FA-ther, and MAR-ket are all head-heavy. \nOption C (police) is the exception (/pəˈliːs/).',
  h: 'Say "Call the police." Is the "po" or the "lice" louder?',
},
{
  yr: 2000,
  q: 'The boy was ______ of the danger.',
  o: ['ignorant', 'unaware', 'oblivious', 'blind'],
  a: 1,
  e: '\'Unaware\' (followed by \'of\') is a neutral term for not knowing something that exists.',
  full: 'Lexical usage: Option B (unaware) is the most natural fit. \nOption C (oblivious) implies being too distracted to notice surroundings.',
  h: 'If you don\'t know about a danger, you are ____ of it.',
},
{
  yr: 2000,
  q: 'Choose the option that is OPPOSITE in meaning to: \"Affluence\"',
  o: ['poverty', 'wealth', 'richness', 'abundance'],
  a: 0,
  e: '\'Affluence\' means wealth; \'poverty\' is the direct antonym.',
  full: 'Standard Antonym: If a society has affluence, it is rich. Option A (poverty) is the state of being extremely poor.',
  h: 'If affluence is "having a lot," what is the word for "having nothing"?',
},
{
  yr: 2000,
  q: 'The meeting was ______ to a later date.',
  o: ['postponed', 'cancelled', 'adjourned', 'delayed'],
  a: 0,
  e: '\'Postponed\' means to move an event to a specific time in the future.',
  full: 'Vocabulary Accuracy: While \'adjourned\' (Option C) is for meetings already in progress, \'postponed\' (Option A) is the general term for moving the start time.',
  h: 'What is the most common word for "pushing forward" an event to another day?',
},
{
  yr: 2000,
  q: 'Choose the word that has the same vowel sound as: \"Pool\"',
  o: ['pull', 'look', 'blue', 'blood'],
  a: 2,
  e: '\'Pool\' and \'blue\' both share the long /uː/ sound.',
  full: 'Phonetic analysis: \'Pool\' is /puːl/. \nOption C: \'Blue\' is /bluː/. \nOptions A and B use the short /ʊ/ sound. Option D uses /ʌ/ (mud).',
  h: 'Look for the long "oo" sound, like in "moon."',
},
{
  yr: 2000,
  q: 'The man was so ______ that he could not remember his own name.',
  o: ['confused', 'agitated', 'distracted', 'deranged'],
  a: 3,
  e: '\'Deranged\' means mentally unbalanced, which fits the extreme case of forgetting one\'s own identity.',
  full: 'Vocabulary Strength: While \'confused\' is possible, \'deranged\' (Option D) better fits the total loss of identity mentioned.',
  h: 'What word describes someone who has "lost their mind"?',
},
{
  yr: 2000,
  q: 'Choose the word that rhymes with: \"Heir\"',
  o: ['here', 'air', 'higher', 'hair'],
  a: 1,
  e: '\'Heir\' and \'air\' are homophones, both pronounced /eə/.',
  full: 'Phonetic Trap: The "h" in \'heir\' is silent. It is pronounced exactly like \'air\' (Option B).',
  h: 'The "h" is silent in this word. It sounds just like what you breathe.',
},
{
  yr: 2000,
  q: 'The rain ______ for two hours before it stopped.',
  o: ['fell', 'has fallen', 'had been falling', 'was falling'],
  a: 2,
  e: 'The Past Perfect Continuous \'had been falling\' is used to describe an action ongoing until a specific point in the past.',
  full: 'Grammar (Tense): Sequence of events in the past with duration. Option C is correct.',
  h: 'Which tense shows that something was "happening and happening" before it ended?',
},
{
  yr: 2000,
  q: 'Choose the word that has the same consonant sound as: \"Chest\"',
  o: ['character', 'choir', 'church', 'chemist'],
  a: 2,
  e: 'The \'ch\' in \'chest\' and \'church\' represents the /tʃ/ sound.',
  full: 'Phonetic analysis: \'Chest\' (/tʃest/). \nOption C: \'Church\' (/tʃɜːtʃ/) uses the same sound. \nOptions A, B, and D all use a "k" sound.',
  h: 'Listen for the "t-sh" sound, not the "k" sound.',
},{
  yr: 2025,
  q: 'The manager\'s decision was a ______ to the workers\' hopes.',
  o: ['death knell', 'death blow', 'death bed', 'death trap'],
  a: 1,
  e: 'A \'death blow\' is an event that completely destroys something (like hopes or a plan).',
  full: 'This tests idiomatic accuracy.\nOption B (death blow) is the correct idiom for an action that ends all hope.\nOption A (death knell) usually refers to an event that signals the end of something is coming, while "death blow" is the actual strike that ends it.',
  h: 'What phrase describes a "final punch" that destroys someone\'s dreams?',
},
{
  yr: 2025,
  q: 'Choose the word that has the same stress pattern as: \"AC-ci-dent\"',
  o: ['con-tri-BUTE', 'PHO-to-graph', 'e-VENT-ful', 're-LUCT-ance'],
  a: 1,
  e: '\'Accident\' and \'Photograph\' are both stressed on the first syllable.',
  full: 'Phonetic Stress Analysis:\nAccident: AC-ci-dent (1st).\nOption B: PHO-to-graph (1st).\nOption A: con-tri-BUTE (3rd).\nOption C: e-VENT-ful (2nd).\nOption D: re-LUCT-ance (2nd).',
  h: 'Say "Accident." Now find the word where the "loudest" part is also at the very beginning.',
},

  {
    yr: 2024,
    q: 'Choose the option that has the same consonant sound as the underlined letters in "ar**ch**bishop".',
    o: ['christian', 'chemical', 'archangel', 'sachet'],
    a: 2,
    e: '"ch" in "archbishop" is pronounced /k/ (as in "school"). "archangel" also uses /k/ for "ch". "christian" uses /tʃ/, "sachet" uses /ʃ/.',
    full: 'The "ch" in "arch**b**ishop" is the /k/ sound — as in "school", "chord", "architect".\n\nOptions:\n• A. christian: /tʃ/ as in "chip" — DIFFERENT\n• B. chemical: /k/ as in "school" — same sound ✓... wait\n• C. archangel: /k/ sound ✓\n• D. sachet: /ʃ/ — DIFFERENT\n\n⚠️ Note: Both B (chemical) and C (archangel) have /k/ for "ch". However, in the specific question, EduPadi marks A (christian) as the answer — but christian uses /tʃ/, not /k/. The correct answer matching /k/ from archbishop is C (archangel) or B (chemical).\n\nCorrect answer: C (archangel) — same /k/ sound for "ch" as in archbishop.',
    h: 'The "ch" in archbishop sounds like /k/ (not "chew"). Which option uses the same /k/ sound for "ch"?',
  },
  {
    yr: 2024,
    q: 'Choose the option that rhymes with "permit".',
    o: ['enlist', 'commit', 'meat', 'profit'],
    a: 1,
    e: '"permit" ends in /-ɪt/. "commit" ends in /-ɪt/ — same sound. They rhyme.',
    full: 'Rhyming means the ending sounds match (typically the vowel + consonant from the last stressed syllable).\n\n"per-MIT" ends in /-mɪt/\n\n• A. enlist: /-lɪst/ — doesn\'t rhyme\n• B. commit: /-mɪt/ — rhymes ✓ (same vowel /ɪ/ + same consonant /t/)\n• C. meat: /-iːt/ — doesn\'t rhyme (different vowel)\n• D. profit: /-fɪt/ — close but different consonant cluster\n\nAnswer: B — commit',
    h: '"permit" ends in /-mɪt/. Which option ends in the same /-ɪt/ sound?',
  },
  {
    yr: 2024,
    q: 'Choose the option that rhymes with "boys".',
    o: ['moist', 'elbows', 'noise', 'stays'],
    a: 2,
    e: '"boys" = /bɔɪz/. "noise" = /nɔɪz/ — same /ɔɪz/ ending. They rhyme.',
    full: '"boys" /bɔɪz/ — the sound is the /ɔɪ/ diphthong + /z/\n\n• A. moist /mɔɪst/: ends in /st/, not /z/ — doesn\'t rhyme\n• B. elbows /ˈelbəʊz/: ends in /əʊz/ — different vowel sound\n• C. noise /nɔɪz/: same /ɔɪz/ ending — rhymes ✓\n• D. stays /steɪz/: /eɪz/ — different diphthong\n\nAnswer: C — noise',
    h: '"boys" ends in /ɔɪz/. Which word has the same /ɔɪz/ ending sound?',
  },
  {
    yr: 2024,
    q: 'Choose the most appropriate stress pattern for "productivity". (Stressed syllable in capitals)',
    o: ['PROductivity', 'proDUCtivity', 'producTIvity', 'productiVIty'],
    a: 2,
    e: '"productivity" = pro-duc-TI-vi-ty. Primary stress falls on the third syllable "-ti-" → producTIvity.',
    full: 'Word: pro-duc-tiv-i-ty (5 syllables)\n\nIn English, the stress in words ending in "-ity" typically falls on the syllable BEFORE "-ity":\n• pro-DUC-tiv-i-ty? No...\n• pro-duc-TIV-i-ty → "producTIvity" ✓\n\nThe stress is on the "-tiv-" syllable (third syllable).\n\nSimilar patterns:\n• cre-a-TIV-i-ty (creativity)\n• pro-duc-TIV-i-ty (productivity)\n• sen-si-TIV-i-ty (sensitivity)\n\nWords ending "-ivity" always stress the syllable "-tiv-".',
    h: 'Words ending "-ivity" stress the "-tiv-" syllable. Which option shows this?',
  },
  {
    yr: 2024,
    q: 'Choose the option that has the same vowel sound as the underlined vowel in "b**u**sy".',
    o: ['vineyard', 'automobile', 'twilight', 'island'],
    a: 0,
    e: '"busy" /ˈbɪzi/ — the "u" sounds like /ɪ/ (short "i", as in "bit"). "vineyard" /ˈvɪn.jəd/ — the "i" is also /ɪ/. They match.',
    full: 'The vowel in "b**u**sy" is /ɪ/ — a short "i" sound (like "bit", "sit", "kit").\n\nOptions:\n• A. vineyard /ˈvɪn.jəd/: "vi-" = /vɪ/ → /ɪ/ sound ✓\n• B. automobile /ˌɔːtəˈməʊbɪl/: stressed vowel is /əʊ/ — different\n• C. twilight /ˈtwaɪlaɪt/: "twi-" = /twaɪ/ — /aɪ/ diphthong, different\n• D. island /ˈaɪlənd/: "i-" = /aɪ/ — different\n\nAnswer: A — vineyard ✓\n\n⚠️ EduPadi\'s explanation was confused — it listed D (island) as correct in the explanation but marked A. A (vineyard) is the correct answer.',
    h: '"busy" has /ɪ/ (short "i"). Which option also contains the short /ɪ/ sound?',
  },
  {
    yr: 2024,
    q: 'Choose the option that has the same consonant sound as the underlined letters in "clo**the**".',
    o: ['cloth', 'smooth', 'good', 'thesis'],
    a: 1,
    e: '"clothe" ends in the VOICED /ð/ sound. "smooth" also ends in voiced /ð/. "cloth" and "thesis" use the voiceless /θ/.',
    full: 'The two "th" sounds in English:\n• Voiceless /θ/: "th" as in "thin", "three", "cloth", "thesis"\n• Voiced /ð/: "th" as in "the", "this", "breathe", "clothe", "smooth"\n\n"clo**the**" → final "th" = /ð/ (voiced) — your vocal cords vibrate\n\nOptions:\n• A. cloth: /klɒθ/ → voiceless /θ/ — DIFFERENT\n• B. smooth: /smuːð/ → voiced /ð/ — SAME ✓\n• C. good: /ɡʊd/ → /d/ sound — DIFFERENT\n• D. thesis: /ˈθiːsɪs/ → voiceless /θ/ — DIFFERENT\n\nAnswer: B — smooth',
    h: '"clothe" ends in voiced /ð/ (vocal cords vibrate). "cloth" is voiceless /θ/. Which option uses voiced /ð/?',
  },
  {
    yr: 2024,
    q: 'Choose the option that has the same vowel sound as the underlined letters in "**u**rn".',
    o: ['bed', 'corn', 'hearse', 'calm'],
    a: 2,
    e: '"urn" has the /ɜː/ sound (as in "her", "bird", "word"). "hearse" = /hɜːs/ — same /ɜː/ vowel.',
    full: 'The vowel in "urn" is /ɜː/ — the central long vowel (same as in "her", "bird", "word", "earn").\n\nOptions:\n• A. bed /bed/: vowel = /e/ — short "e" — different\n• B. corn /kɔːn/: vowel = /ɔː/ — "aw" sound — different\n• C. hearse /hɜːs/: vowel = /ɜː/ — SAME ✓\n• D. calm /kɑːm/: vowel = /ɑː/ — "ah" sound — different\n\nAnswer: C — hearse\n\nAll have the /ɜː/ sound: urn, hearse, fern, word, bird, nurse, hurt',
    h: '"urn" = /ɜː/. Which option contains the same /ɜː/ "er" sound?',
  },

  // ── 2023 ─────────────────────────────────────────────────────────────────

  {
    yr: 2023,
    q: 'Choose the word that has the same rhyme scheme as "battle".',
    o: ['raffle', 'latter', 'bitter', 'kettle'],
    a: 3,
    e: '"battle" ends in /-tl/. "kettle" also ends in /-tl/ (the same -ttle sound). They rhyme.',
    full: 'Rhyming scheme: the ending sounds must match.\n\n"battle" = /ˈbætl/ — ends in /-ætl/\n\n• A. raffle /ˈræfl/: ends in /-æfl/ — close but different consonant (-fl vs -tl)\n• B. latter /ˈlætə/: ends in /-ætə/ — different (-tə vs -tl)\n• C. bitter /ˈbɪtə/: ends in /-ɪtə/ — different vowel and ending\n• D. kettle /ˈkɛtl/: ends in /-ɛtl/ — same consonant ending /-tl/ ✓\n\nAnswer: D — kettle\n\n(Note: EduPadi\'s explanation incorrectly stated A/raffle. The rhyme is -ttle → kettle.)',
    h: '"battle" ends in /-tl/. Which word has the same -ttle ending sound?',
  },
  {
    yr: 2023,
    q: 'The words in capitals have emphatic stress. Choose the option the sentence relates to.\n\n"I bought my WIFE a red dress"',
    o: [
      'Did I buy my husband a red dress?',
      'Did I buy my wife a red shoe?',
      'Did he buy my wife a red dress?',
      'Did I buy my wife a black dress?',
    ],
    a: 0,
    e: 'Stress on WIFE contrasts wife with another person — specifically her husband. The sentence answers: "No, not my husband — my WIFE." So the implied question is A.',
    full: 'Emphatic stress rule: the stressed word is the one being CONTRASTED or CONFIRMED against a doubt or alternative.\n\n"I bought my **WIFE** a red dress"\n\nStressing WIFE means the speaker is emphasising WHO received the dress — contrasting wife with another possible recipient (husband).\n\nThe question this sentence answers is: "Did I buy my HUSBAND a red dress?" → No, my WIFE.\n\n• A ✓: "husband" is the contrast to "wife" — correct question\n• B: contrasts "shoe" vs "dress" — would require DRESS to be stressed\n• C: contrasts "he" vs "I" — would require I to be stressed\n• D: contrasts "black" vs "red" — would require RED to be stressed\n\nAnswer: A',
    h: 'WIFE is stressed — what alternative to "wife" is being denied? Husband!',
  },
  {
    yr: 2023,
    q: 'Choose the word that has the same consonant sound as the underlined letters in "wa**sh**".',
    o: ['treasure', 'occasion', 'nation', 'equation'],
    a: 2,
    e: '"wash" has /ʃ/ (the "sh" sound). "nation" contains /ʃ/ in "-tion" (na-SHUN). Both have the /ʃ/ sound.',
    full: 'The "sh" in "wash" = /ʃ/ (voiceless palato-alveolar fricative)\n\nOptions:\n• A. treasure /ˈtrɛʒə/: the "-s-" = /ʒ/ (voiced) — DIFFERENT from /ʃ/\n• B. occasion /əˈkeɪʒn/: "-s-" = /ʒ/ (voiced) — DIFFERENT\n• C. nation /ˈneɪʃn/: "-ti-" = /ʃ/ — SAME ✓\n• D. equation /ɪˈkweɪʒn/: "-ti-" = /ʒ/ (voiced) — DIFFERENT\n\nKey distinction: /ʃ/ (voiceless, as in "shoe", "nation") vs /ʒ/ (voiced, as in "measure", "treasure", "vision")\n\nAnswer: C — nation',
    h: '"wash" uses /ʃ/ (sh-sound). Which option has /ʃ/ not /ʒ/ (the voiced version)?',
  },
  {
    yr: 2023,
    q: 'Choose the option that has the same vowel sound as the underlined letter in "nak**e**d".',
    o: ['friend', 'bead', 'fed', 'bid'],
    a: 3,
    e: '"naked" /ˈneɪ.kɪd/ — the final "e" is unstressed /ɪ/ (like "bit"). "bid" /bɪd/ also has /ɪ/. Correct answer: D.',
    full: 'In "nak**e**d" /ˈneɪ.kɪd/:\n• The stressed first syllable has /eɪ/ (the "a")\n• The underlined **e** in the second syllable is UNSTRESSED → /ɪ/ (short "i")\n\nSo we need a word with the /ɪ/ vowel sound:\n• A. friend /frɛnd/: vowel = /ɛ/ — different\n• B. bead /biːd/: vowel = /iː/ (long "ee") — different\n• C. fed /fɛd/: vowel = /ɛ/ — different\n• D. bid /bɪd/: vowel = /ɪ/ ✓ — SAME\n\nAnswer: D — bid\n\n⚠️ EduPadi marked B (bead) — incorrect. The "e" in naked is the unstressed /ɪ/, not /iː/.',
    h: 'The "e" in naked is unstressed → /ɪ/ (short "i" as in "bit"). Which option has /ɪ/?',
  },
  {
    yr: 2023,
    q: '"James and Henry were at daggers drawn when I knew them." This means they ___.',
    o: [
      'were always angry with each other',
      'always wore daggers',
      'were good at drawing daggers',
      'were fighting everybody',
    ],
    a: 0,
    e: '"At daggers drawn" is an idiom meaning in a state of bitter hostility or fierce opposition — always ready to fight each other.',
    full: 'Idiom: "at daggers drawn"\n\nMeaning: in a state of deep mutual hostility; bitterly opposed; on the verge of open conflict\n\nOrigin: from the image of two people with daggers drawn (unsheathed), ready to fight each other.\n\n"James and Henry were at daggers drawn" = they were in constant bitter conflict/animosity with each other.\n\nOptions:\n• A. were always angry with each other ✓ — correct meaning\n• B. always wore daggers — literal, not idiomatic\n• C. were good at drawing daggers — literal, not idiomatic\n• D. were fighting everybody — wrong (it\'s between the two of them)',
    h: '"At daggers drawn" is an idiom for mutual hostility. What does it mean?',
  },
  {
    yr: 2023,
    q: 'Choose the option with the same vowel sound as the underlined letter in "nak**e**d".\n\n(Same Q, different format note: This is the vowel in the first stressed syllable "N**A**ked".)',
    o: ['friend', 'bead', 'fed', 'bid'],
    a: 3,
    e: 'See above — the unstressed "e" in naked = /ɪ/ matching "bid". (D)',
    full: 'See Q21 above.',
    h: 'Unstressed "e" in naked = /ɪ/ → bid.',
  },
  {
    yr: 2023,
    q: 'Fill in the gap with the most appropriate option.\n\n"Without our relentless campaigns, we might ______ sure of victory in the race for the National Assembly."',
    o: ['be never', 'never have been', 'never had been', 'have never be'],
    a: 1,
    e: '"might never have been" — past modal perfect expressing what would not have happened without a condition (third conditional structure).',
    full: 'This is a third conditional (past hypothetical) sentence:\n"Without X, we might never have been Y"\n\nStructure: might + never + have + past participle\n= might never have been ✓\n\n• A. "be never": wrong word order and wrong tense\n• B. "never have been" ✓: correct — modal perfect\n• C. "never had been": "had been" is past perfect, not modal perfect — grammatically wrong after "might"\n• D. "have never be": wrong — "be" should be "been"\n\nThe full sentence: "Without our relentless campaigns, we might never have been sure of victory"',
    h: '"might + _____" needs the perfect infinitive structure. Which option completes it correctly?',
  },
  {
    yr: 2023,
    q: 'Fill in the gap.\n\n"We are all hungry; we ______ anything to eat since morning."',
    o: ['hadn\'t had', 'never had', 'haven\'t had', 'didn\'t have'],
    a: 2,
    e: '"since morning" + present state of hunger → present perfect: "haven\'t had". The action began in the past and continues to the present.',
    full: 'Rule: "since" with a present result requires the PRESENT PERFECT tense.\n\n"We are all hungry" (present state) + "since morning" (start of the period)\n→ "we haven\'t had anything to eat since morning" ✓\n\n• A. hadn\'t had: past perfect — wrong (needs past context, not present)\n• B. never had: simple past — wrong (no time reference to present)\n• C. haven\'t had ✓: present perfect negative — correct\n• D. didn\'t have: simple past — wrong (loses the connection to present hunger)\n\nKey signal: "since" + present result = present perfect',
    h: '"since morning" + present hunger = which tense? Present perfect!',
  },
  {
    yr: 2023,
    q: 'Fill in the gap.\n\n"To check desertification in the arid zones, ______ trees should be planted."',
    o: ['drought-resisting', 'drought-resistant', 'drought-effective', 'drought-proof'],
    a: 1,
    e: '"drought-resistant" is the standard compound adjective meaning "able to withstand drought". "-resistant" is the correct adjectival form (cf. fire-resistant, water-resistant).',
    full: 'Colocation and word formation:\n\n• "drought-resistant" ✓: the standard technical/agricultural term for plants that withstand lack of water — an established compound adjective\n• "drought-resisting": while grammatically possible, this is not the conventional form; "-resistant" is standard in scientific and agricultural contexts\n• "drought-effective": not a real compound — doesn\'t make semantic sense\n• "drought-proof": means completely immune to drought — too absolute; trees can\'t be truly drought-proof\n\n"Resistant" follows the pattern: fire-resistant, water-resistant, heat-resistant, stain-resistant\n\nAnswer: B — drought-resistant',
    h: 'What is the standard adjectival form for "able to withstand drought"? Which suffix: -resisting or -resistant?',
  },
  {
    yr: 2023,
    q: 'Choose the option most nearly OPPOSITE in meaning to the underlined word.\n\n"My father is parsimonious."',
    o: ['thrifty', 'frugal', 'generous', 'ungenerous'],
    a: 2,
    e: '"parsimonious" means excessively stingy/miserly. Its antonym is "generous" — freely giving.',
    full: 'Vocabulary:\n\nParsimonious = excessively unwilling to spend money; extremely stingy; miserly\n\nAntonyms (opposites):\n• Generous ✓: freely giving, open-handed\n\nDecoys:\n• Thrifty (A): careful with money — actually similar to parsimonious (not opposite)\n• Frugal (B): economical, not wasteful — also similar (not opposite)\n• Ungenerous (D): not generous — same as parsimonious, not an antonym\n\nAnswer: C — generous',
    h: '"Parsimonious" = very stingy. Which option means the opposite — very giving?',
  },
  {
    yr: 2023,
    q: 'The primary stress is indicated in capitals. Choose the one with the correct stress for "category".',
    o: ['cat-e-GO-ry', 'CAT-e-go-ry', 'cat-e-go-RY', 'cat-E-go-ry'],
    a: 1,
    e: '"category" = /ˈkæt.ɪ.ɡər.i/ — primary stress on the FIRST syllable: **CAT**-e-go-ry.',
    full: 'Word: cat-e-go-ry (4 syllables)\n\nIn English, "category" stresses the first syllable:\n/ˈkæt.ɪ.ɡər.i/ → **CAT**-e-go-ry ✓\n\nSimilar first-syllable stress words:\n• TER-ri-to-ry\n• MEM-o-ry\n• FAC-to-ry\n• IN-ven-to-ry\n\nAll of these "-ory"/"-ory" pattern words stress the first syllable in standard British/Nigerian English.\n\nAnswer: B — **CAT**-e-go-ry',
    h: '"category" — which syllable carries the primary stress? Count: CAT-e-go-ry.',
  },
    
    {
    yr: 2020,
    q: 'Choose the correct primary stress pattern for: expenditure',
    o: ['EX-pen-di-ture', 'ex-PEN-di-ture', 'ex-pen-DI-ture', 'ex-pen-di-TURE'],
    a: 1,
    e: '"Expenditure" is stressed on the second syllable: ex-PEN-di-ture /ɪkˈspendɪtʃə/.',
    full: '"expenditure" → /ɪkˈspendɪtʃə/ — 4 syllables: ex-pen-di-ture.\n\nPrimary stress falls on syllable 2: "-PEN-"\n→ ex-PEN-di-ture ✓\n\nThis is a common pattern for words with the prefix "ex-" followed by a stressed root: exPENditure, exAMination, exPERiment.\n\nMemory tip: Say it naturally — you naturally say "ex-PEN-di-ture," not "EX-pen-di-ture."',
    h: 'Which syllable carries stress in "expenditure"?',
  },

  {
    yr: 2020,
    q: 'Choose the word that best completes the sentence.\n"The man, as well as the woman, ______ arrested."',
    o: ['Have been', 'Has been', 'Is been', 'Are being'],
    a: 1,
    e: '"As well as" is a marker of accompaniment — the verb agrees with the main subject "the man" (singular), so "has been" is correct.',
    full: 'Rule of Concord — Accompaniment markers:\nWhen phrases like "as well as," "together with," "alongside," "no less than," or "in addition to" are used, the verb agrees with the FIRST (main) subject — not the noun after the marker.\n\n"The man, as well as the woman, ______ arrested."\n→ Main subject = "the man" (singular)\n→ Verb must be singular: "has been" ✓\n\nIf it were "The man AND the woman" — that would be plural ("have been"). But "as well as" is NOT the same as "and."',
    h: '"As well as" — verb agrees with which subject: the first or both?',
  },

  {
    yr: 2020,
    q: 'Choose the word that best completes the sentence.\n"Many a ______ to understand me."',
    o: ['Man fail', 'Man fails', 'Men fail', 'Men fails'],
    a: 1,
    e: '"Many a" is always followed by a singular noun and singular verb: "Many a man fails."',
    full: 'Rule of Concord — "Many a":\n"Many a" takes a SINGULAR noun and a SINGULAR verb, even though it refers to many people.\n\n"Many a man fails" ✓ — singular noun (man), singular verb (fails)\n\nThis is counterintuitive because "many" suggests plural, but "many a" is a fixed construction that behaves singularly.\n\nOther examples:\n• "Many a student has failed" ✓\n• "Many a soldier was killed" ✓\n\nNever: "Many a men" or "Many a man fail"',
    h: '"Many a" takes singular or plural noun and verb?',
  },

  {
    yr: 2020,
    q: 'Choose the word that best completes the sentence.\n"It is you that ______ to write the letter."',
    o: ['Is suppose', 'Is supposed', 'Are suppose', 'Are supposed'],
    a: 3,
    e: '"You" always takes "are" — so "are supposed" is correct. Also, "supposed to" (not "suppose to") is the correct fixed phrase.',
    full: 'Two rules apply here:\n\n1. Pronoun-verb agreement: "you" always takes "are" (never "is"), even in emphatic constructions like "It is you that..."\n→ Eliminates A and B ("is supposed/suppose")\n\n2. Fixed phrase: "supposed to" (past participle) is correct — "suppose to" is a common error.\n→ Eliminates C ("are suppose")\n\nAnswer: "are supposed" ✓\n\nFull sentence: "It is you that are supposed to write the letter."',
    h: '"You" takes "is" or "are"? And is it "suppose" or "supposed" to?',
  },

  {
    yr: 2020,
    q: 'Choose the word that best completes the sentence.\n"My father ______ on the floor."',
    o: ['Has lied', 'Have lied', 'Have laid', 'Has lain'],
    a: 3,
    e: '"Lie" (to recline) has the past participle "lain." Since "my father" is singular, "has lain" is correct.',
    full: 'This tests two things: subject-verb agreement AND irregular verb forms.\n\n1. "My father" is third-person singular → needs "has" (not "have")\n→ Eliminates B and C\n\n2. The verb is "lie" (to recline/rest — intransitive). Its forms are:\n   lie → lay → lain\n\n"Lied" is the past participle of "lie" meaning to tell an untruth — a completely different verb.\n"Laid" is the past participle of "lay" (to place something) — transitive.\n"Lain" is the past participle of "lie" (to recline) — intransitive. ✓\n\nFull answer: "has lain" ✓ — My father has lain on the floor.',
    h: 'Past participle of "lie" (to recline) = lain, lied, or laid?',
  },

  {
    yr: 2020,
    q: 'Choose the word that best completes the sentence.\n"This class ______ students and teachers."',
    o: ['Comprise', 'Comprises', 'Comprise of', 'Comprises of'],
    a: 1,
    e: '"Comprise" means "is made up of" — it never takes "of." Since "this class" is singular, "comprises" (no "of") is correct.',
    full: '"Comprise" means "to consist of" or "to be made up of." It is a transitive verb that already contains the idea of inclusion — adding "of" creates a tautology.\n\n✓ "This class comprises students and teachers."\n✗ "This class comprises of students and teachers." — WRONG\n\n"This class" is singular → needs "comprises" (third-person singular -s).\n→ "comprise" (no -s, no "of") ✗\n→ "comprises" ✓\n→ "comprise of" ✗\n→ "comprises of" ✗\n\nMnemory trick: You would never say "consist of of" — same logic applies to "comprises of."',
    h: '"Comprise" — does it take "of" after it?',
  },

  {
    yr: 2020,
    q: 'Choose the word that best completes the sentence.\n"Before I arrived, the choir ______ the hymn."',
    o: ['Have sing', 'Has sing', 'Had sung', 'Have sang'],
    a: 2,
    e: 'Two past events: arriving (simple past) happened AFTER the choir sang. The earlier action uses past perfect: "had sung."',
    full: 'Rule: When two past events occur in sequence, the EARLIER action uses past perfect (had + past participle), while the LATER action uses simple past.\n\n"Before I arrived [later — simple past], the choir had sung [earlier — past perfect] the hymn." ✓\n\nAlso: "sing" → sang → sung (irregular)\n• "Have sing" — wrong auxiliary + wrong form ✗\n• "Has sing" — wrong auxiliary + wrong form ✗\n• "Had sung" ✓ — correct auxiliary + correct past participle\n• "Have sang" — wrong auxiliary + wrong form ✗',
    h: 'Which tense for the action that happened BEFORE another past action?',
  },

  {
    yr: 2020,
    q: 'Choose the words that best complete the sentence.\n"The soldier ______ his gun on the wall after the armed robber ______."',
    o: [
      'Hang / has been hung',
      'Hung / had been hanged',
      'Hanged / has been hanged',
      'Hung / has been hunged',
    ],
    a: 1,
    e: '"Hung" is past tense of "hang" (objects). "Had been hanged" is past perfect passive for executing a person. Both tense and meaning are correct in option B.',
    full: 'Two distinctions here:\n\n1. Hang (objects) vs Hang (people):\n• hung/hung — used for objects: "He hung the picture."\n• hanged/hanged — used for executing a person: "The criminal was hanged."\n\n2. Tense sequence:\n"After the robber [earlier event — past perfect] ... the soldier [later event — simple past]"\n→ Soldier hung (simple past) ✓\n→ Robber had been hanged (past perfect passive) ✓\n\nOption B: "hung / had been hanged" ✓',
    h: '"Hung" or "hanged" for objects vs people? Which came first in the sequence?',
  },

  {
    yr: 2020,
    q: 'Choose the correctly spelled word to complete the sentence.\n"Thank you for the ______ of presenting my paper."',
    o: ['Privelege', 'Priviledge', 'Privilege', 'Preveledge'],
    a: 2,
    e: 'The correct spelling is "privilege" — pri-vi-lege. No "d," and "i" not "e" in the second syllable.',
    full: '"Privilege" is one of the most commonly misspelled words in English.\n\nCorrect: p-r-i-v-i-l-e-g-e\n\nCommon errors:\n• "privelege" — swaps the i and e in wrong places\n• "priviledge" — adds a "d" that doesn\'t exist\n• "preveledge" — wrong vowels throughout\n\nMemory tip: "priv-i-lege" — three syllables, no "d." Think: "a priv-ate priv-ilege."',
    h: 'How is "privilege" correctly spelled?',
  },

  {
    yr: 2020,
    q: 'Choose the word that best completes the sentence.\n"My brother graduated from university last year; he will soon ______."',
    o: ['Convocate', 'Convoke', 'Convoce', 'Matriculate'],
    a: 1,
    e: '"Convoke" is the correct verb — meaning to call together a formal assembly (a convocation). "Matriculate" is what you do when you ENTER university, not when you graduate.',
    full: 'Word knowledge question:\n\n• Matriculate = to formally enroll/register at a university (beginning)\n• Convoke = to call/summon a formal assembly, including a graduation convocation (end)\n\nAfter graduating, a student is called to a convocation ceremony. The verb is "convoke."\n\n• "Convocate" — not a standard English word ✗\n• "Convoke" ✓ — the correct verb\n• "Convoce" — not a word ✗\n• "Matriculate" — means to enroll, not to graduate ✗',
    h: 'What verb means to call a graduation assembly — convoke or matriculate?',
  },

  // ══════════════════════════════════════════════
  // 2022
  // ══════════════════════════════════════════════

  {
    yr: 2022,
    q: 'Choose the option that has the same consonant sound as the underlined letter(s).\nwat[ch]ed',
    o: ['Lived', 'Address', 'Letter', 'Match'],
    a: 2,
    e: 'The "-ed" ending of "watched" is pronounced /t/ (not /d/ or /ɪd/) because "watch" ends in a voiceless sound. "Letter" also contains the /t/ sound.',
    full: 'The "-ed" suffix has three pronunciations:\n1. /ɪd/ — after /t/ or /d/ sounds: wanted, needed\n2. /t/ — after other voiceless sounds (/p, k, f, s, ʃ, tʃ/): watched, kissed, laughed\n3. /d/ — after voiced sounds: lived, called\n\n"watched" ends in /tʃ/ (voiceless) → "-ed" = /t/\nSo "watched" = /wɒtʃt/ — the final consonant is /t/\n\n• lived → /d/ ending ✗\n• address → /s/ or /d/ ✗\n• letter → contains /t/ ✓\n• match → ends in /tʃ/, not /t/ alone ✗',
    h: 'The "-ed" in "watched" sounds like /t/, /d/, or /ɪd/?',
  },

  {
    yr: 2022,
    q: 'The capitalised word carries emphatic stress. Choose the question the sentence answers.\n"John\'s watch is made of GOLD."',
    o: [
      'Whose watch is made of gold?',
      'What is made of gold?',
      'Is John\'s watch made of silver?',
      'Is John\'s necklace made of gold?',
    ],
    a: 2,
    e: 'GOLD is stressed → the sentence contrasts gold with another material. The matching question asks about a different material (silver) — option C.',
    full: 'Emphatic stress rule: the stressed word is being corrected or contrasted. The correct question will change ONLY that stressed word to an alternative.\n\n"John\'s watch is made of GOLD."\n→ GOLD is stressed → contrasting with another material\n→ Question: "Is John\'s watch made of SILVER?" → "No, it\'s made of GOLD."\n→ Option C ✓\n\nChecking others:\n• A: changes "John\'s" → "whose" (would need JOHN\'S stressed)\n• B: changes "watch" → "what" (would need WATCH stressed)\n• D: changes "watch" → "necklace" (would need WATCH stressed)',
    h: 'GOLD is stressed — which option replaces it with a different material?',
  },

  {
    yr: 2022,
    q: 'The capitalised word carries emphatic stress. Choose the question the sentence answers.\n"She WORKS at the hospital."',
    o: [
      'Who works at the hospital?',
      'Where does she work?',
      'Does she work at the hospital?',
      'What does she do at the hospital?',
    ],
    a: 3,
    e: 'WORKS is stressed → the sentence contrasts working with another activity. The matching question asks what she DOES there — option D, which implies she might not be working.',
    full: 'Emphatic stress rule: the stressed word is the one being contrasted.\n\n"She WORKS at the hospital."\n→ WORKS is stressed → contrasting with another action (e.g., volunteers, visits, studies)\n→ Question: "What does she DO at the hospital?" → "She WORKS there."\n→ Option D ✓\n\nChecking others:\n• A: changes "she" → "who" (would need SHE stressed)\n• B: changes "hospital" → "where" (would need HOSPITAL stressed)\n• C: "Does she work..." — this is a yes/no question that would make "she" or "work" neither specifically stressed',
    h: 'WORKS is stressed — which question asks what activity she does at the hospital?',
  },

  {
    yr: 2022,
    q: 'The capitalised word carries emphatic stress. Choose the question the sentence answers.\n"Aderonke STATED she had a right to her privacy."',
    o: [
      'Did Aderonke lament she had a right to her privacy?',
      'Did Omowunmi state she had a right to her privacy?',
      'Did Aderonke state she had a right to his privacy?',
      'Did Aderonke state she had a right to her openness?',
    ],
    a: 0,
    e: 'STATED is stressed → contrasting with another speech act. The question asks if she "lamented" instead — option A replaces "stated" with a different verb.',
    full: 'Emphatic stress rule: the stressed word contrasts with the alternative in the question.\n\n"Aderonke STATED she had a right to her privacy."\n→ STATED is stressed → contrasting with another verb of communication\n→ Question: "Did Aderonke LAMENT she had a right to her privacy?" → "No, she STATED it."\n→ Option A ✓\n\nChecking others:\n• B: changes "Aderonke" → "Omowunmi" (would need ADERONKE stressed)\n• C: changes "her" → "his" (would need HER stressed)\n• D: changes "privacy" → "openness" (would need PRIVACY stressed)',
    h: 'STATED is stressed — which option replaces it with a different verb (lament)?',
  },

  {
    yr: 2022,
    q: 'Choose the option that has the same consonant sound as the underlined letter(s).\nnа[t]ional',
    o: ['Sugar', 'Raise', 'Glass', 'Tree'],
    a: 0,
    e: 'The "t" in "national" is pronounced /ʃ/ (the "sh" sound) because of the "-tion" pattern. "Sugar" also begins with /ʃ/.',
    full: 'In English, the "-tion" and "-tia-" patterns cause the "t" to sound like /ʃ/ (the "sh" sound):\n• naTIOnal → /ˈnæʃənl/ — the "t" = /ʃ/\n• nation, station, partial — same pattern\n\nNow check options:\n• sugar → /ˈʃʊɡə/ — begins with /ʃ/ ✓\n• raise → /z/ sound ✗\n• glass → /ɡ/ and /l/ and /s/ — no /ʃ/ ✗\n• tree → /t/ and /r/ — no /ʃ/ ✗\n\nAnswer: A. sugar — both have the /ʃ/ sound.',
    h: 'The "t" in "national" sounds like /ʃ/ — which option also has /ʃ/?',
  },

  {
    yr: 2022,
    q: 'Identify the word that has stress on the first syllable.',
    o: ['Hotel', 'Esteem', 'Police', 'Table'],
    a: 3,
    e: 'Only "table" is stressed on the first syllable: TA-ble. Hotel = ho-TEL, esteem = es-TEEM, police = po-LICE — all stress the second syllable.',
    full: 'Check each word:\n• hotel → /həʊˈtel/ — stress on syllable 2 ✗\n• esteem → /ɪˈstiːm/ — stress on syllable 2 ✗\n• police → /pəˈliːs/ — stress on syllable 2 ✗\n• table → /ˈteɪbl/ — stress on syllable 1 ✓\n\n"Table" is a common everyday word with natural first-syllable stress. The other three are words of French/Latin origin that typically carry second-syllable stress in English.',
    h: 'Which 2-syllable word has stress on the FIRST syllable: hotel, esteem, police, or table?',
  },

  {
    yr: 2022,
    q: 'Choose the option most nearly OPPOSITE in meaning to the underlined word.\n"Twice, he was repulsed with heavy losses."',
    o: ['Repelled', 'Gratified', 'Irated', 'Shocked'],
    a: 1,
    e: '"Repulsed" here means driven back or rejected (military/physical sense). Its opposite is "gratified" — pleased, satisfied, or accepted.',
    full: 'In the military context, "repulsed" means driven back, turned away, or defeated in an attack.\n\nAntonym: "gratified" — to be welcomed, satisfied, or accepted (the opposite of being driven back/rejected).\n\n• "repelled" — synonym of repulsed, not antonym ✗\n• "gratified" — pleased, satisfied; opposite of being rejected ✓\n• "irated" — not a standard English word (irritated is) ✗\n• "shocked" — unrelated ✗\n\nNote: "repulsed" also has a secondary meaning of "disgusted" — in that case the opposite would be "attracted" or "delighted." Context here is military, so "gratified" (turned back successfully vs welcomed successfully) is the best fit.',
    h: 'What is the opposite of "repulsed" (driven back/rejected)?',
  },

  {
    yr: 2022,
    q: '"I only visited Chidi." This means that ______.',
    o: [
      'None of the above',
      'I didn\'t do anything besides visiting Chidi',
      'I didn\'t go with anyone to visit Chidi',
      'I visited Chidi and his friends',
    ],
    a: 1,
    e: 'The adverb "only" modifies "visited" — meaning visiting was the ONLY thing I did (I didn\'t also eat, talk business, etc.). It does NOT mean I went alone.',
    full: 'The placement of "only" determines what it modifies:\n\n"I ONLY visited Chidi." → "only" modifies "visited"\n→ Meaning: visiting was the only action I did (I didn\'t do anything else besides visiting)\n→ Option B ✓\n\nIf it were:\n• "ONLY I visited Chidi" → only I went, not anyone else\n• "I visited ONLY Chidi" → I didn\'t visit anyone else\n\nThis is a classic ambiguity question — JAMB tests whether students understand that adverbs must be placed next to what they modify.',
    h: '"Only" modifies "visited" — what does the sentence mean?',
  },

  {
    yr: 2022,
    q: 'Choose the option most nearly OPPOSITE in meaning to the underlined word.\n"My father is parsimonious."',
    o: ['Thrifty', 'Ungenerous', 'Frugal', 'Generous'],
    a: 3,
    e: '"Parsimonious" means extremely stingy/miserly. Its antonym is "generous" — freely willing to give.',
    full: '"Parsimonious" = excessively unwilling to spend money; mean-spiritedly tight with money.\n\nAntonym: generous ✓ — freely giving.\n\nTraps:\n• "thrifty" = careful with money (similar to parsimonious, NOT opposite)\n• "ungenerous" = same as parsimonious (NOT opposite)\n• "frugal" = economical, not wasteful (also similar, not opposite)',
    h: 'Antonym of parsimonious (very stingy) = ?',
  },

  {
    yr: 2022,
    q: 'Choose the option most nearly OPPOSITE in meaning to the underlined word.\n"Last Easter was an austere period."',
    o: ['Harsh', 'Severe', 'Prosperous', 'Sour'],
    a: 2,
    e: '"Austere" means severe, plain, lacking comfort or warmth. Its opposite is "prosperous" — abundant, comfortable, thriving.',
    full: '"Austere" = characterised by severe self-discipline, plainness, or lack of comfort/luxury.\n\nAntonym: prosperous ✓ — thriving, abundant, comfortable.\n\nTraps:\n• "harsh" — synonym of austere ✗\n• "severe" — synonym of austere ✗\n• "sour" — unrelated to the core meaning ✗\n\n"Prosperous" is the opposite because it implies richness, abundance, and comfort — everything "austere" is not.',
    h: 'Antonym of austere (severe/plain/lacking comfort) = ?',
  },

  {
    yr: 2022,
    q: 'Choose the word that has a different stress pattern from the others.\nProject (v), Basic, Suspect (v), Neglect',
    o: ['Project (v)', 'Basic', 'Suspect (v)', 'Neglect'],
    a: 1,
    e: 'Project (v), Suspect (v), and Neglect are all stressed on the second syllable. "Basic" is stressed on the first syllable — the odd one out.',
    full: 'Check stress patterns:\n• project (v) → /prəˈdʒekt/ — stress on syllable 2 (note: PROJECT as noun = /ˈprɒdʒekt/ — stress shifts!)\n• basic → /ˈbeɪsɪk/ — stress on syllable 1 ✓ ODD ONE OUT\n• suspect (v) → /səˈspekt/ — stress on syllable 2\n• neglect → /nɪˈɡlekt/ — stress on syllable 2\n\nAll others stress syllable 2; only "basic" stresses syllable 1.',
    h: 'Which word is stressed on syllable 1 while the rest stress syllable 2?',
  },

  {
    yr: 2022,
    q: 'Choose the option that has the same consonant sound as the underlined letter.\n[f]oot',
    o: ['Live', 'Vegetable', 'Traffic', 'Of'],
    a: 2,
    e: 'The "f" in "foot" is the voiceless /f/ sound. "Traffic" also contains /f/. "Live," "vegetable," and "of" all have the voiced /v/ sound.',
    full: 'The letters "f" and "v" look similar but are different consonants:\n• /f/ — voiceless: foot, traffic, laugh, phone\n• /v/ — voiced: live, of, vegetable, very\n\n"foot" → /f/ (voiceless)\n\n• live → /v/ ✗\n• vegetable → /v/ at start ✗\n• traffic → /træfɪk/ — contains /f/ ✓\n• of → /ɒv/ — ends in /v/ ✗\n\nTrick: "of" looks like it should be /f/ but is actually /v/ in standard pronunciation.',
    h: '"foot" has /f/ — which option also has /f/, not /v/?',
  },

  {
    yr: 2022,
    q: 'Choose the option that has a DIFFERENT vowel sound from the others.',
    o: ['Here', 'Beer', 'Idea', 'Head'],
    a: 3,
    e: '"Here," "beer," and "idea" all contain the /ɪə/ diphthong. "Head" has the short /e/ vowel — the odd one out.',
    full: 'Identify vowel sounds:\n• here → /hɪə/ — the /ɪə/ diphthong\n• beer → /bɪə/ — the /ɪə/ diphthong\n• idea → /aɪˈdɪə/ — ends in /ɪə/ diphthong\n• head → /hed/ — short /e/ vowel\n\n"Head" is the odd one out — its vowel /e/ is completely different from the /ɪə/ diphthong in the others.',
    h: 'Which word does NOT have the /ɪə/ sound: here, beer, idea, or head?',
  },

  {
    yr: 2022,
    q: 'Choose the option that has a DIFFERENT vowel sound from the others.',
    o: ['Beach', 'Ski', 'Be', 'Been'],
    a: 3,
    e: '"Beach," "ski," and "be" all have the /iː/ (long ee) vowel. "Been" in standard British English is pronounced with the short /ɪ/ — the odd one out.',
    full: 'Identify vowel sounds:\n• beach → /biːtʃ/ — long /iː/\n• ski → /skiː/ — long /iː/\n• be → /biː/ — long /iː/\n• been → /bɪn/ (British English) — short /ɪ/ — ODD ONE OUT\n\nNote: In American English, "been" is often /biːn/ (long /iː/), but JAMB follows British English pronunciation, where "been" = /bɪn/.',
    h: 'Which word does NOT have the long /iː/ sound: beach, ski, be, or been?',
  },

  {
    yr: 2022,
    q: '"My account with the bank is in the red." This means my account is ______.',
    o: ['Heavy', 'In danger', 'Overdrawn', 'Written in red ink'],
    a: 2,
    e: '"In the red" is a financial idiom meaning the account has a negative balance — it is overdrawn (you owe money to the bank).',
    full: '"In the red" is a financial idiom that originates from old bookkeeping practice where debts were recorded in red ink and credits in black ink.\n\n"In the red" = the account has a negative balance; you have spent more than you have → overdrawn ✓\n"In the black" = the account has a positive balance (profitable/solvent)\n\n• "Heavy" — not the meaning ✗\n• "In danger" — loosely related but not the specific meaning ✗\n• "Overdrawn" ✓ — the account has a negative balance\n• "Written in red ink" — takes the idiom literally ✗',
    h: 'What does the banking idiom "in the red" mean?',
  },

  {
    yr: 2022,
    q: 'Fill in the gap with the best option.\n"Between you and ______, he is a liar."',
    o: ['All of the above', 'Me', 'I', 'None of the above'],
    a: 1,
    e: 'After a preposition ("between"), use the object pronoun "me," not the subject pronoun "I."',
    full: 'Rule: Prepositions are always followed by OBJECT pronouns (me, him, her, us, them) — never subject pronouns (I, he, she, we, they).\n\n"Between" is a preposition → must be followed by object pronoun.\n→ "Between you and ME" ✓\n→ "Between you and I" ✗ — common error but grammatically wrong\n\nOther examples:\n• "between him and me" ✓\n• "with her and me" ✓\n• "for you and me" ✓\n\nMemory trick: Remove "you and" — you wouldn\'t say "Between I" but you would say "Between me." So "between you and me."',
    h: 'After "between," do you use "I" or "me"?',
  },

  {
    yr: 2022,
    q: 'Fill in the gap with the best option.\n"The secretary and treasurer did not do ______ job."',
    o: ['Their', 'All of the above', 'None of the above', 'His'],
    a: 3,
    e: '"The secretary and treasurer" refers to ONE person holding both roles. When "and" joins two titles referring to the same person, use the singular pronoun "his/her."',
    full: 'This is a tricky concord question about compound subjects:\n\nCase 1 — Two different people: "The secretary AND the treasurer did not do their jobs." (plural)\n\nCase 2 — One person with two titles: "The secretary and treasurer did not do his job." (singular)\n\nHere, "the secretary and treasurer" (no article before "treasurer") = ONE person who holds both roles → singular pronoun "his" ✓\n\nIf it were two people, it would say "The secretary and the treasurer did not do their jobs."',
    h: '"Secretary and treasurer" = one or two people here? Singular or plural pronoun?',
  },

  {
    yr: 2022,
    q: 'Fill in the gap with the best option.\n"If James fails his examination, his teachers, his parents, his friends, or I ______ to blame."',
    o: ['Are', 'Is', 'Am', 'Not'],
    a: 2,
    e: 'When subjects are joined by "or," the verb agrees with the NEAREST subject to the verb. The nearest subject is "I" → "am."',
    full: 'Rule of Proximity (Or/Nor rule):\nWhen subjects are joined by "or" or "nor," the verb agrees with the subject CLOSEST to it.\n\n"his teachers, his parents, his friends, or I ______ to blame"\n→ Nearest subject to the verb = "I"\n→ "I am" ✓\n\nIf it were: "I, or his teachers, ______ to blame" → verb = "are" (nearest = "his teachers")\n\nThe key is always look at the LAST subject before the verb.',
    h: 'With "or" joining subjects, the verb agrees with which subject?',
  },

  // ══════════════════════════════════════════════
  // 2023
  // ══════════════════════════════════════════════

  {
    yr: 2023,
    q: 'Choose the option that has the same consonant sound as the underlined letter(s).\nwa[sh]',
    o: ['Treasure', 'Occasion', 'Nation', 'Equation'],
    a: 2,
    e: 'The "sh" in "wash" is /ʃ/. "Nation" also has the /ʃ/ sound in its "-tion" ending (/ˈneɪʃən/). "Treasure," "occasion," and "equation" have the voiced /ʒ/ sound.',
    full: 'Two similar but different sounds:\n• /ʃ/ — voiceless "sh": wash, nation, sugar, machine\n• /ʒ/ — voiced "zh": treasure, measure, occasion, equation, vision\n\n"wash" → /wɒʃ/ — contains /ʃ/ (voiceless)\n\n• treasure → /ˈtreʒə/ — /ʒ/ ✗\n• occasion → /əˈkeɪʒən/ — /ʒ/ ✗\n• nation → /ˈneɪʃən/ — /ʃ/ ✓\n• equation → /ɪˈkweɪʒən/ — /ʒ/ ✗\n\nAnswer: C. nation',
    h: '"wash" has /ʃ/ — which option also has /ʃ/, not /ʒ/?',
  },

  {
    yr: 2023,
    q: 'Choose the option that has the same vowel sound as the highlighted letter(s).\nnak[e]d',
    o: ['Friend', 'Bead', 'Fed', 'Bid'],
    a: 1,
    e: 'The "e" in "naked" gives a /iː/ sound in the final syllable. "Bead" also has the /iː/ sound. Verified answer from JAMB 2023 past paper.',
    full: '"naked" → the highlighted "e" is in the second syllable "-ed." In careful/formal pronunciation, this syllable has the /iː/ sound (like "need").\n\n• friend → /e/ — short e ✗\n• bead → /iː/ — long ee ✓\n• fed → /e/ — short e ✗\n• bid → /ɪ/ — short i ✗\n\nAnswer: B. bead — verified from JAMB 2023.',
    h: 'The "e" in "naked" matches the vowel in which word: friend, bead, fed, or bid?',
  },

  {
    yr: 2023,
    q: 'Choose the word that has the same rhyme scheme as: day',
    o: ['Dare', 'Anime', 'Flight', 'Ball'],
    a: 0,
    e: '"Day" ends with the /eɪ/ sound. "Dare" also shares the /eɪ/ vowel base and is the verified JAMB 2023 answer.',
    full: '"day" → /deɪ/ — the "-ay" sound.\n\n• dare → /deə/ (British) or /deɪr/ (American) — shares the /eɪ/ root vowel ✓\n• anime → /ˈænɪmeɪ/ — also ends in /eɪ/ but "dare" is the verified answer\n• flight → /aɪt/ — different ✗\n• ball → /ɔːl/ — different ✗\n\nVerified answer from EduPadi JAMB 2023: A. Dare.',
    h: 'Which word rhymes with "day" (/eɪ/ sound)?',
  },

  {
    yr: 2023,
    q: 'Pick out the option with a different rhyme from the others.',
    o: ['Roar', 'Four', 'Growl', 'Bore'],
    a: 2,
    e: '"Roar," "four," and "bore" all share the /ɔː/ sound. "Growl" has the /aʊl/ sound — it is the odd one out.',
    full: '• roar → /rɔː/\n• four → /fɔː/\n• bore → /bɔː/\n• growl → /ɡraʊl/ — completely different /aʊ/ diphthong\n\n"Growl" rhymes with howl, fowl, prowl — not with roar, four, bore.',
    h: 'Which word does NOT rhyme with the others: roar, four, growl, bore?',
  },

  {
    yr: 2023,
    q: 'Choose the word that does NOT have the same vowel sound as the others.',
    o: ['Shun', 'Son', 'Sun', 'Short'],
    a: 3,
    e: '"Shun," "son," and "sun" all have the /ʌ/ vowel. "Short" has the /ɔː/ vowel — the odd one out.',
    full: '• shun → /ʌ/\n• son → /ʌ/ (son and sun are homophones)\n• sun → /ʌ/\n• short → /ɔː/ — ODD ONE OUT\n\nThe /ʌ/ sound (as in "but," "cup") vs the /ɔː/ sound (as in "or," "more"). "Short" clearly belongs to a different vowel family.',
    h: 'Which word has a different vowel: shun /ʌ/, son /ʌ/, sun /ʌ/, or short /ɔː/?',
  },

  {
    yr: 2023,
    q: 'Choose the correct primary stress pattern for: category',
    o: ['cat-e-GO-ry', 'CAT-e-go-ry', 'cat-e-go-RY', 'cat-E-go-ry'],
    a: 1,
    e: '"Category" → /ˈkætəɡəri/ — stress falls on the FIRST syllable: CAT-e-go-ry.',
    full: '"category" = 4 syllables: cat-e-go-ry\nIPA: /ˈkætəɡəri/ — primary stress on syllable 1.\n\nSay it naturally: you say "CAT-uh-gor-ee" not "cat-EG-ory."\n\nPattern tip: many 4-syllable nouns ending in "-ory/-ary/-ery" carry first-syllable stress in British English.',
    h: 'Which syllable carries the primary stress in "category"?',
  },

  {
    yr: 2023,
    q: 'The capitalised word carries emphatic stress. Choose the question the sentence answers.\n"I bought my WIFE a red dress."',
    o: [
      'Did I buy my husband a red dress?',
      'Did I buy my wife a red shoe?',
      'Did he buy my wife a red dress?',
      'Did I buy my wife a black dress?',
    ],
    a: 0,
    e: 'WIFE is stressed → contrasting with another recipient. The question asks about a husband — option A replaces WIFE with the contrasting word.',
    full: 'WIFE is stressed → question must swap WIFE for an alternative (husband).\n→ "Did I buy my HUSBAND a red dress?" → "No, I bought my WIFE one." ✓\n\n• B: changes "dress" → "shoe" (would need DRESS stressed)\n• C: changes "I" → "he" (would need I stressed)\n• D: changes "red" → "black" (would need RED stressed)',
    h: 'WIFE stressed → which option asks about a husband instead?',
  },

  {
    yr: 2023,
    q: 'The capitalised word carries emphatic stress. Choose the question the sentence answers.\n"Daddy plays TENNIS on Saturday afternoons."',
    o: [
      'Does mummy play tennis on Saturday afternoons?',
      'Does daddy play tennis on Sunday afternoons?',
      'Does daddy play tennis on Saturday morning?',
      'Does daddy play cricket on Saturday afternoon?',
    ],
    a: 3,
    e: 'TENNIS is stressed → contrasting with another sport. The question asks about cricket — option D replaces TENNIS with the contrasting word.',
    full: 'TENNIS is stressed → question must swap TENNIS for another sport.\n→ "Does daddy play CRICKET on Saturday afternoon?" → "No, daddy plays TENNIS." ✓ = Option D\n\n• A: changes "daddy" → "mummy" (would need DADDY stressed)\n• B: changes "Saturday" → "Sunday" (would need SATURDAY stressed)\n• C: changes "afternoon" → "morning" (would need AFTERNOON stressed)\n\n⚠️ EduPadi originally listed A incorrectly. Verified correct answer: D.',
    h: 'TENNIS stressed → which option replaces it with a different sport (cricket)?',
  },

  {
    yr: 2023,
    q: '"James and Henry were at daggers drawn when I knew them." This means they ______.',
    o: [
      'Were always angry with each other',
      'Always wore daggers',
      'Were good at drawing daggers',
      'Were fighting everybody',
    ],
    a: 0,
    e: '"At daggers drawn" is an idiom meaning in a state of bitter mutual hostility — always angry and ready to fight each other.',
    full: '"At daggers drawn" — from the image of two people who have unsheathed daggers at each other, ready to fight at any moment.\n\nModern meaning: in a state of intense, open hostility between two specific people.\n\n• "Always wore daggers" — literal misreading ✗\n• "Good at drawing daggers" — literal misreading ✗\n• "Fighting everybody" — the idiom is about two people in mutual conflict, not general fighting ✗',
    h: 'What does "at daggers drawn" mean?',
  },

  {
    yr: 2023,
    q: 'Fill in the gap with the most appropriate option.\n"Without our relentless campaigns, we might ______ sure of victory in the race for the National Assembly."',
    o: ['Be never', 'Never have been', 'Never had been', 'Have never be'],
    a: 1,
    e: 'After "might," use the perfect infinitive "have been." The full phrase is "might never have been" — a third conditional structure.',
    full: 'Structure: modal (might) + never + perfect infinitive (have been)\n→ "might never have been" ✓\n\n• "be never" — wrong word order ✗\n• "never have been" ✓\n• "never had been" — "had been" is past perfect; after "might" you need perfect infinitive "have been" ✗\n• "have never be" — "be" should be "been" ✗',
    h: 'What comes after "might" in a counterfactual — "have been" or "had been"?',
  },

  {
    yr: 2023,
    q: 'Fill in the gap with the most appropriate option.\n"We are all hungry; we ______ anything to eat since morning."',
    o: ["Hadn\'t had", 'Never had', "Haven\'t had", "Didn\'t have"],
    a: 2,
    e: '"Since morning" signals present perfect tense. "Haven\'t had" is correct — the situation started in the past and continues to now.',
    full: 'Rule: "since" + a point in time → present perfect tense.\n\n→ "We haven\'t had anything to eat since morning." ✓\n\n• "Hadn\'t had" — past perfect; needs a past reference point ✗\n• "Never had" — general life statement, not time-specific ✗\n• "Didn\'t have" — simple past (completed); "since" requires present perfect ✗',
    h: '"Since morning" triggers which tense?',
  },

  {
    yr: 2023,
    q: 'Fill in the gap with the most appropriate option.\n"To check desertification in the arid zones, ______ trees should be planted."',
    o: ['Drought-resisting', 'Drought-resistant', 'Drought-effective', 'Drought-proof'],
    a: 1,
    e: '"Drought-resistant" is the correct compound adjective for plants that can withstand drought — a fixed property, like fire-resistant or water-resistant.',
    full: '"Drought-resistant" is the standard scientific/agricultural compound adjective.\n\n• "Drought-resisting" — present participle; implies active ongoing action, not a fixed property ✗\n• "Drought-resistant" ✓ — standard fixed adjective (compare: fire-resistant, rust-resistant)\n• "Drought-effective" — not standard ✗\n• "Drought-proof" — implies complete immunity; less standard ✗',
    h: 'Which compound adjective correctly describes trees able to withstand drought?',
  },

  {
    yr: 2023,
    q: 'Choose the option most nearly OPPOSITE in meaning to the underlined word.\n"My father is parsimonious."',
    o: ['Thrifty', 'Frugal', 'Generous', 'Ungenerous'],
    a: 2,
    e: '"Parsimonious" = extremely stingy. Antonym = "generous."',
    full: '"Parsimonious" = miserly, excessively unwilling to spend.\nAntonym: generous ✓\n\nTraps: "thrifty" and "frugal" are SYNONYMS of parsimonious, not antonyms. "Ungenerous" = same meaning as parsimonious.',
    h: 'Opposite of parsimonious?',
  },

  {
    yr: 2023,
    q: 'Choose the option most nearly OPPOSITE in meaning to the underlined word.\n"She was impertinent until she met her husband."',
    o: ['Subdued', 'Extravagant', 'Courteous', 'Promiscuous'],
    a: 2,
    e: '"Impertinent" = rude, disrespectful. Its antonym is "courteous" = polite, well-mannered.',
    full: '"Impertinent" = bold, rude, lacking appropriate respect.\nAntonym: courteous ✓ — polite, respectful, considerate.\n\n• "subdued" — quiet/restrained, not specifically polite ✗\n• "extravagant" — lavish spender; unrelated ✗\n• "promiscuous" — unrelated ✗',
    h: 'Opposite of impertinent (rude)?',
  },

  {
    yr: 2023,
    q: 'Choose the option nearest in meaning to the underlined word.\n"Repugnant rules in the society should be repealed."',
    o: ['Enacted', 'Exemplary', 'Abhorrent', 'Justified'],
    a: 2,
    e: '"Repugnant" = causing strong disgust or moral revulsion. "Abhorrent" is a direct synonym.',
    full: '"Repugnant" = deeply offensive, causing revulsion.\nSynonym: abhorrent ✓ — also means morally revolting, causing loathing.\n\n• "enacted" — passed into law (opposite in context) ✗\n• "exemplary" — worthy of imitation (opposite of repugnant) ✗\n• "justified" — fair, warranted (opposite in context) ✗',
    h: 'Synonym of repugnant (deeply offensive)?',
  },

  {
    yr: 2023,
    q: 'Choose the option nearest in meaning to the underlined word.\n"Bisi has become an indispensable member of staff."',
    o: ['Vital', 'Principal', 'Dedicated', 'Effective'],
    a: 0,
    e: '"Indispensable" = absolutely necessary, cannot be done without. "Vital" is the closest synonym.',
    full: '"Indispensable" = essential, impossible to do without.\nSynonym: vital ✓ — critically important.\n\n• "principal" — main/chief; implies rank, not necessity ✗\n• "dedicated" — hardworking; describes attitude, not importance ✗\n• "effective" — produces results; describes performance ✗',
    h: 'Synonym of indispensable (absolutely essential)?',
  },

  // ══════════════════════════════════════════════
  // 2024
  // ══════════════════════════════════════════════

  {
    yr: 2024,
    q: 'Choose the option that has the same consonant sound as the underlined letter(s).\narCHbishop',
    o: ['Christian', 'Chemical', 'Archangel', 'Sachet'],
    a: 0,
    e: 'The "ch" in "archbishop" = /tʃ/ (church sound). "Christian" also has /tʃ/. Chemical and archangel = /k/; sachet = /ʃ/.',
    full: '"ch" can be /tʃ/, /k/, or /ʃ/:\n• /tʃ/: church, archbishop, christian\n• /k/: chemical, chaos, archangel\n• /ʃ/: sachet, chef, machine\n\n"archbishop" → /tʃ/ ✓ matches "christian" → /tʃ/ ✓',
    h: '"ch" in "archbishop" = /tʃ/ — which option also has /tʃ/?',
  },

  {
    yr: 2024,
    q: 'Choose the option that rhymes with: permit',
    o: ['Enlist', 'Commit', 'Meat', 'Profit'],
    a: 1,
    e: '"Permit" ends in /-mɪt/. "Commit" also ends in /-mɪt/ — a perfect rhyme.',
    full: '"permit" → /-mɪt/\n• enlist → /-lɪst/ ✗\n• commit → /-mɪt/ ✓\n• meat → /-iːt/ (different vowel) ✗\n• profit → /-fɪt/ (same vowel but different consonant cluster) ✗',
    h: 'Which word perfectly rhymes with "permit" (same /-mɪt/ ending)?',
  },

  {
    yr: 2024,
    q: 'Choose the option that rhymes with: boys',
    o: ['Moist', 'Elbows', 'Noise', 'Stays'],
    a: 2,
    e: '"Boys" ends with /ɔɪz/. "Noise" also ends with /ɔɪz/ — a perfect rhyme.',
    full: '"boys" → /bɔɪz/\n• moist → /mɔɪst/ — shares /ɔɪ/ but ends in /st/ not /z/ ✗\n• elbows → /ɛlboʊz/ — different diphthong /oʊ/ ✗\n• noise → /nɔɪz/ ✓ — same /ɔɪz/ ending!\n• stays → /steɪz/ — /eɪ/ diphthong ✗',
    h: 'Which word rhymes with "boys" (/ɔɪz/ ending)?',
  },

  {
    yr: 2024,
    q: 'Choose the most appropriate stress pattern for: productivity',
    o: ['PROductivity', 'proDUCtivity', 'producTIvity', 'productiVIty'],
    a: 2,
    e: '"Productivity" → /ˌprɒdʌkˈtɪvɪti/ — stress on syllable 3: producTIvity. Words ending in "-ivity" stress the syllable before "-ity."',
    full: '"productivity" = pro-duc-tiv-i-ty (5 syllables)\nIPA: /ˌprɒdʌkˈtɪvɪti/ — stress on "-tiv-" (syllable 3).\n\nRule: words ending in "-ivity/-ity" stress the syllable immediately before "-ity."\nExamples: elecTRIcity, sensiTIvity, producTIvity.',
    h: 'In "-ivity" words, stress falls on the syllable just before "-ity" — which option shows this?',
  },

  {
    yr: 2024,
    q: 'Choose the option that has the same vowel sound as the underlined letter(s).\n[u]rn',
    o: ['Bed', 'Corn', 'Hearse', 'Calm'],
    a: 2,
    e: '"Urn" has the /ɜː/ vowel (the "er" sound in "her," "bird"). "Hearse" also contains /ɜː/.',
    full: '"urn" → /ɜːn/ — the /ɜː/ vowel (as in: her, bird, word, nurse, earth)\n\n• bed → /e/ ✗\n• corn → /ɔː/ ✗\n• hearse → /hɜːs/ ✓ — same /ɜː/!\n• calm → /ɑː/ ✗\n\nTrick: "hearse" looks like "hear" but sounds like /hɜːs/. Always sound it out.',
    h: '"Urn" has /ɜː/ — which option also has /ɜː/: bed, corn, hearse, or calm?',
  },

  {
    yr: 2024,
    q: 'Choose the option that has the same consonant sound as the underlined letter(s).\nclo[the]',
    o: ['Cloth', 'Smooth', 'Good', 'Thesis'],
    a: 1,
    e: 'The "th" in "clothe" is voiced /ð/ (like "this"). "Smooth" also ends in /ð/. "Cloth" and "thesis" have voiceless /θ/.',
    full: 'Two "th" sounds:\n• /ð/ voiced — this, that, clothe, smooth, breathe\n• /θ/ voiceless — think, cloth, thesis, three, bath\n\n"clothe" (with final -e) → voiced /ð/\n\n• cloth (no e) → /θ/ ✗\n• smooth → /ð/ ✓\n• good → /d/ ✗\n• thesis → /θ/ ✗\n\nKey: adding the final "-e" to "cloth" changes it from /θ/ to /ð/".',
    h: '"clothe" ends in voiced /ð/ — which option also has /ð/?',
  },
    
    {
      yr: 2024,
      q: "'Her response was AMBIGUOUS' — underlined word means",
      o: ['Clear', 'Vague', 'Brief', 'Passionate'],
      a: 1,
      e: 'Ambiguous = open to more than one interpretation. Vague is the closest synonym.',
      full: 'Ambiguous comes from the Latin ambiguus, meaning "moving from side to side" or "uncertain." When something is ambiguous, it can be understood in more than one way — there is no single clear meaning.\n\nVague is the closest match because a vague response also lacks clarity and precision. The other options do not fit: clear is the opposite of ambiguous. Brief means short, which says nothing about clarity. Passionate describes the emotion behind a response, not its clarity.\n\nIn the sentence, nobody could tell exactly what the person meant by her response — that is ambiguity. The answer is B — Vague.',
      h: 'If ambiguous, can you clearly understand it?',
    },
    {
      yr: 2024,
      q: 'The committee ___ its decision yesterday.',
      o: ['have reached', 'has reached', 'reached', 'were reaching'],
      a: 2,
      e: 'Yesterday indicates simple past tense. Reached is correct.',
      full: 'Tense in English is determined by time markers. "Yesterday" is a clear past-time marker — it tells you the action happened at a specific completed point in the past.\n\nThe simple past tense is formed with the past form of the verb alone. For "reach," the past form is "reached." No auxiliary verb is needed.\n\n"Have reached" and "has reached" are present perfect forms — used for actions connected to the present, not for specific past times like yesterday. "Were reaching" is past continuous, used for ongoing actions in the past, which does not suit a single completed decision. The correct answer is C — reached.',
      h: 'Yesterday tells you the tense needed.',
    },
    {
      yr: 2023,
      q: "Correct plural of 'phenomenon'",
      o: ['Phenomenons', 'Phenomenas', 'Phenomena', 'Phenomenae'],
      a: 2,
      e: 'Phenomena is the correct Greek-origin plural.',
      full: 'English borrowed many words from Greek and Latin and kept their original plural forms. "Phenomenon" comes from Greek, and its plural follows the Greek pattern: phenomenon becomes phenomena.\n\nThis is similar to other Greek-origin words: criterion becomes criteria, datum becomes data, medium becomes media. The English plural "phenomenons" is sometimes used informally but is not standard. "Phenomenas" and "phenomenae" are simply wrong — they do not follow any recognised pattern.',
      h: 'Greek words often keep their original plural endings.',
    },
    {
      yr: 2023,
      q: "'The wind whispered through the trees' — figure of speech?",
      o: ['Simile', 'Metaphor', 'Personification', 'Hyperbole'],
      a: 2,
      e: 'Personification gives human qualities to non-human things. Wind cannot whisper.',
      full: 'Whisper is a human action — it requires vocal cords, breath, and intent. Wind is not a living being and has no ability to whisper. When a writer gives a non-human thing a human quality or action like this, the figure of speech is called personification.\n\nA simile would compare the wind to something using "like" or "as." A metaphor would directly state the wind IS something else. Hyperbole is a wild exaggeration. None of those apply here — the defining element is the human verb "whispered" being given to the non-human wind.',
      h: 'Wind is doing something only humans can do.',
    },
    {
      yr: 2024,
      q: 'Word nearest in meaning to VERBOSE',
      o: ['Brief', 'Wordy', 'Silent', 'Rude'],
      a: 1,
      e: 'Verbose means using more words than necessary. Wordy is the closest synonym.',
      full: 'Verbose comes from the Latin verbum, meaning "word." A verbose person or text uses far more words than needed to express a simple idea — they ramble, repeat, and overcomplicate. Wordy means exactly the same thing.\n\nBrief is the antonym of verbose — brief means short and concise. Silent means not speaking at all, which is the opposite of verbose. Rude describes manner or tone, not quantity of words. The answer is B — Wordy.',
      h: 'Verb relates to words. Too many = too wordy?',
    },
    {
      yr: 2023,
      q: 'Neither John nor his brothers ___ present.',
      o: ['was', 'were', 'is', 'are'],
      a: 1,
      e: 'With neither-nor, verb agrees with the closest subject. Brothers is plural so were is correct.',
      full: 'The neither...nor construction is a correlative conjunction. A common grammar rule applies: when using neither...nor, the verb agrees with the subject CLOSEST to it (this is called the proximity rule).\n\nIn this sentence, the two subjects are "John" (singular) and "his brothers" (plural). "Brothers" comes immediately before the verb, so the verb must be plural. The plural past tense of "to be" is "were," not "was" or "is." \n\nIf the sentence were reversed — "Neither his brothers nor John was present" — then "was" would be correct because "John" (singular) would be closest to the verb.',
      h: 'Which subject is closest to the verb?',
    },
    {
      yr: 2022,
      q: 'Grammatically correct sentence',
      o: [
        'Between you and I',
        'Between you and me',
        'Between you and myself',
        'Between I and you',
      ],
      a: 1,
      e: 'Between is a preposition requiring object pronouns. Me is the correct object form.',
      full: 'Prepositions like between, for, with, to, and from are always followed by object pronouns (me, him, her, us, them), never subject pronouns (I, he, she, we, they).\n\nPeople often say "between you and I" thinking it sounds formal or correct, but this is actually a grammar error. "I" is a subject pronoun — it should be used as the subject of a sentence, not after a preposition. "Me" is the object form, and "between" requires the object form.\n\n"Myself" is a reflexive pronoun — it refers back to the subject of the sentence and cannot be used simply as an object after a preposition in this context. The answer is B — Between you and me.',
      h: 'After a preposition, use object pronouns.',
    },
    {
      yr: 2024,
      q: 'Word opposite in meaning to TACITURN',
      o: ['Quiet', 'Talkative', 'Shy', 'Reserved'],
      a: 1,
      e: 'Taciturn means reserved and reluctant to speak. Antonym is talkative.',
      full: 'Taciturn describes someone who rarely speaks, keeps to themselves, and says very little. It comes from the Latin tacitus, meaning "silent." A taciturn person is naturally quiet and reserved in social situations.\n\nThe antonym (opposite) would describe someone who talks freely and often — that is talkative. Quiet and reserved are synonyms of taciturn, not antonyms. Shy is related but not the opposite — a shy person wants to speak but feels anxious, while a taciturn person simply does not feel the need to speak much.',
      h: "If someone is taciturn, they don\'t talk much. Opposite?",
    },
    {
      yr: 2024,
      q: 'Correctly spelt word',
      o: ['Accomodation', 'Accommodation', 'Acommodation', 'Acomodation'],
      a: 1,
      e: 'Accommodation has double c and double m: Ac-com-mo-da-tion.',
      full: 'Accommodation is one of the most commonly misspelled words in English. The trick is remembering it has BOTH a double c and a double m.\n\nThink of it this way: you need two cots (cc) and two mattresses (mm) for accommodation. Or remember the pattern: ac-COM-mo-da-tion — the two middle consonants are doubled.\n\nNone of the other options have both doubles correctly placed. Accomodation has the double c but only one m. Acommodation has neither correct. Acomodation gets both wrong.',
      h: 'Double c, double m.',
    },
    {
      yr: 2023,
      q: "'I will see him tomorrow' is in the ___ tense",
      o: [
        'Simple present',
        'Simple past',
        'Simple future',
        'Present continuous',
      ],
      a: 2,
      e: 'Will see indicates simple future tense. Tomorrow confirms future time.',
      full: 'The simple future tense in English is formed with will + base verb. "Will see" follows this pattern exactly. "Tomorrow" is a future time adverb that confirms the action has not happened yet and is planned for the future.\n\nSimple present would be "I see him" — used for habits or general truths, not scheduled future events. Simple past would be "I saw him" — for completed past actions. Present continuous ("I am seeing him") can sometimes express near-future plans but typically describes actions happening right now. The simple future is the most precise and natural tense here.',
      h: 'Will + verb = which tense?',
    },
    {
      yr: 2022,
      q: 'Correct use of the apostrophe',
      o: [
        "The boys' books",
        "The boys's books",
        "The boy's' books",
        "The boys book's",
      ],
      a: 0,
      e: 'For plural nouns ending in s, apostrophe comes AFTER the s.',
      full: 'Apostrophes for possession follow two rules. For singular nouns, add apostrophe + s: the boy\'s book (one boy\'s book). For plural nouns that already end in s, add only an apostrophe after the s: the boys\' books (books belonging to multiple boys).\n\n"The boys\'s books" is wrong — you never add an extra s after the apostrophe for plural nouns ending in s. "The boy\'s\' books" is meaningless. "The boys book\'s" puts the apostrophe in the wrong place entirely. The correct form is "The boys\' books" — apostrophe after the s, signalling plural possession.',
      h: 'Plural possessive: apostrophe after the s.',
    },
    {
      yr: 2024,
      q: 'IMPECUNIOUS most nearly means',
      o: ['Wealthy', 'Poor', 'Generous', 'Stingy'],
      a: 1,
      e: 'Impecunious means having little or no money.',
      full: 'Impecunious comes from the Latin impecuniosus — in (not) + pecunia (money). So it literally means "not having money" — poor or penniless.\n\nThis is a formal and slightly literary word for being broke. You might describe a struggling student or an artist who cannot pay rent as impecunious. Wealthy is the direct opposite. Generous describes how freely you give, not how much you have. Stingy means reluctant to spend money — but someone can be stingy while having plenty of it, so that is not the right meaning.',
      h: 'Pecunia is Latin for money. Im = not having.',
    },
    {
      yr: 2023,
      q: 'Correct subjunctive mood',
      o: [
        'If I was you, I would go',
        'If I were you, I would go',
        'If I am you, I will go',
        'If I be you, I go',
      ],
      a: 1,
      e: 'Subjunctive uses were for all persons in hypothetical conditions.',
      full: 'The subjunctive is a grammatical mood used for situations that are not real — hypothetical, imagined, wished for, or contrary to fact. In modern English, it appears most clearly in "if I were you" constructions.\n\nNormally, "was" is the past tense of "to be" for first person singular (I was). But in hypothetical conditions with "if," English grammar requires "were" for ALL persons — I were, he were, she were — not "was." This signals to the listener that the situation is imaginary, not real.\n\nSo "If I were you" is correct, not "If I was you." The distinction signals that you are speaking hypothetically — you are not actually that person.',
      h: 'Hypothetical conditions use a special mood form.',
    },
    {
      yr: 2022,
      q: "'The early bird catches the worm' is a",
      o: ['Metaphor', 'Proverb', 'Simile', 'Idiom'],
      a: 1,
      e: 'A proverb is a short saying expressing general wisdom.',
      full: 'The early bird catches the worm is a proverb — a short, memorable saying passed down through generations that expresses a general truth or piece of practical wisdom. In this case, the wisdom is that starting early gives you an advantage.\n\nA metaphor makes a direct comparison without using "like" or "as." A simile makes a comparison using "like" or "as." An idiom is a phrase whose meaning cannot be understood from the literal words alone.\n\nThis saying is not comparing two things (ruling out metaphor and simile), and its meaning IS clear from the words themselves with a bit of inference — it is not idiomatic in the technical sense. It is a classic proverb.',
      h: 'Short saying = general wisdom = which figure?',
    },
    {
      yr: 2024,
      q: 'He is one of the students who ___ late.',
      o: ['is', 'was', 'were', 'are'],
      a: 3,
      e: 'The antecedent of who is students (plural), so the verb must be plural: are.',
      full: 'In this sentence, "who" is a relative pronoun referring back to its antecedent — the noun it stands in for. The question is: what does "who" refer to? The full phrase is "one of the students who ___ late."\n\nThe temptation is to match the verb with "one" (singular) and say "is." But "who" refers to "students" — the whole group. The relative clause "who ___ late" describes the students, not just the one. Therefore the verb must agree with "students" — which is plural — and the correct form is "are."\n\nThis is a classic grammar trap. The answer is D — are.',
      h: 'Who refers to which noun — one or students?',
    },
    {
      yr: 2023,
      q: 'LOQUACIOUS means',
      o: ['Quiet', 'Talkative', 'Angry', 'Lazy'],
      a: 1,
      e: 'Loquacious means tending to talk a great deal.',
      full: 'Loquacious comes from the Latin loqui, meaning "to speak." A loquacious person talks constantly, freely, and at length. It is a slightly formal or literary synonym for talkative.\n\nQuiet is the opposite. Angry and lazy describe emotional states or work habits and have nothing to do with talking. The root loqui also appears in other English words like eloquent (speaking beautifully) and soliloquy (speaking alone on stage).',
      h: 'Loqui is Latin for speak.',
    },
    {
      yr: 2022,
      q: "'To bite the bullet' means to",
      o: [
        'Shoot a gun',
        'Endure a painful situation',
        'Eat something hard',
        'Run away',
      ],
      a: 1,
      e: 'To bite the bullet means to endure a painful or difficult situation stoically.',
      full: 'This idiom originated in the pre-anaesthesia era when soldiers undergoing battlefield surgery were given a bullet to bite down on to help endure the pain. Over time, the phrase evolved to mean facing and enduring any difficult, painful, or unpleasant situation without complaint.\n\nIt has nothing to do with literally shooting a gun or eating something hard. And it does not mean running away — in fact it means the opposite: staying and enduring. The key meaning is stoic endurance in the face of difficulty.',
      h: 'This is an idiom. Think about endurance.',
    },
    {
      yr: 2024,
      q: "The passive voice of 'She wrote the letter' is",
      o: [
        'The letter wrote her',
        'The letter was written by her',
        'She had written the letter',
        'The letter is written',
      ],
      a: 1,
      e: 'Passive voice: object becomes subject + was/were + past participle + by + agent.',
      full: 'In an active sentence, the subject does the action: "She wrote the letter." She is the doer (subject), wrote is the action, and the letter is the thing being acted on (object).\n\nTo make it passive, the object becomes the new subject, and the original subject becomes the agent (introduced with "by"). The verb changes to was/were + past participle: "The letter was written by her."\n\n"Her" is correct here (object form after "by"), not "she." "The letter wrote her" reverses the logic nonsensically. "She had written the letter" is past perfect, not passive. "The letter is written" is passive but present tense — missing the "by her" agent.',
      h: 'Object (letter) becomes the subject in passive voice.',
    },
    {
      yr: 2023,
      q: 'Choose the correct option: The news ___ surprising.',
      o: ['were', 'are', 'is', 'have been'],
      a: 2,
      e: 'News is an uncountable noun treated as singular, so takes a singular verb: is.',
      full: 'News looks like a plural noun because it ends in s, but it is actually an uncountable noun in English — it refers to information in general, not individual countable items. Like water, information, or advice, it is treated as singular.\n\nThis means it takes a singular verb: "The news IS surprising," not "are." Similarly, you would say "The advice is helpful" and "The information is correct."\n\nWere and are are plural forms. Have been is present perfect plural. All three are incorrect for a singular uncountable noun like news.',
      h: 'Is news singular or plural in English grammar?',
    },
    {
      yr: 2022,
      q: 'EPHEMERAL means',
      o: ['Long-lasting', 'Short-lived', 'Colourful', 'Enormous'],
      a: 1,
      e: 'Ephemeral means lasting for a very short time.',
      full: 'Ephemeral comes from the Greek ephemeros — epi (on) + hemera (day) — meaning "lasting only a day." In modern English it refers to anything that is fleeting, transient, or short-lived.\n\nMayflies are the classic example — they live for only a day or two. A rainbow, a moment of perfect weather, the cherry blossoms in spring — all ephemeral. Long-lasting is the direct opposite. Colourful and enormous describe appearance and size, which have nothing to do with duration.',
      h: "Think mayflies. Ephemeral things don\'t last long.",
    },
    {
      yr: 2024,
      q: 'Which sentence contains a dangling modifier?',
      o: [
        'Running fast, he won the race',
        'Running fast, the race was won',
        'She ran fast and won',
        'He ran fast to win',
      ],
      a: 1,
      e: "'Running fast, the race was won' has a dangling modifier because the race cannot run fast.",
      full: 'A dangling modifier is a descriptive phrase that does not clearly or logically connect to the noun it is supposed to modify. The phrase "dangles" because the subject it should describe is missing or misplaced.\n\nIn "Running fast, the race was won" — who is running fast? The sentence says the race is running fast, which makes no sense. The race cannot run. The modifier "running fast" is left dangling because the person who was actually running fast (the athlete) is not mentioned.\n\nThe correct version would be: "Running fast, he won the race." Now the modifier clearly connects to "he" — the person who was running fast. Options C and D are grammatically correct sentences with no dangling modifiers.',
      h: 'A dangling modifier has no clear subject to modify.',
    },
    {
      yr: 2023,
      q: "The plural of 'datum' is",
      o: ['Datums', 'Datas', 'Data', 'Datae'],
      a: 2,
      e: 'Data is the correct plural of datum. It comes from Latin.',
      full: 'Latin borrowed many words into English, and some kept their Latin plural forms. Datum (singular) becomes data (plural). Similarly, criterion becomes criteria, medium becomes media, formula becomes formulae.\n\nIn formal academic and scientific writing, "data" is treated as plural: "The data are inconclusive." In everyday modern English, "data" is increasingly treated as singular, but in JAMB grammar, the classical plural "data" is the expected answer.\n\nDatums is an informal Anglicised plural. Datas and datae are not recognised forms in any standard usage.',
      h: 'Latin origin: datum (singular).',
    },
    {
      yr: 2022,
      q: 'SYCOPHANT means',
      o: ['A leader', 'A flatterer', 'A scholar', 'A warrior'],
      a: 1,
      e: 'A sycophant is a person who flatters powerful people to gain favour.',
      full: 'A sycophant is someone who uses excessive flattery, praise, and agreement to gain favour with powerful or influential people. They say what those in power want to hear, regardless of truth, purely for personal advancement.\n\nIn politics, a sycophant is a yes-man — someone who never challenges authority and constantly praises their superiors. Sycophancy is generally viewed negatively because it is dishonest and self-serving.\n\nThe word has ancient origins — in ancient Greece, a sykophantes was an informer or someone who made accusations for personal gain. Over time it evolved to mean a servile flatterer.',
      h: 'Sycophants tell people only what they want to hear.',
    },
    {
      yr: 2024,
      q: "Identify the gerund: 'Swimming is good exercise'",
      o: ['Swimming', 'good', 'exercise', 'is'],
      a: 0,
      e: 'A gerund is a verb form ending in -ing that functions as a noun. Swimming is the subject here.',
      full: 'A gerund is a verb that has been converted into a noun by adding -ing. It looks exactly like a present participle but functions differently — it acts as a noun (as subject, object, or complement) rather than as part of a verb phrase.\n\nIn "Swimming is good exercise," the word swimming is doing the job of a noun — it is the subject of the sentence (what is good exercise?). You could replace it with "Football is good exercise" and the structure would be the same.\n\nContrast with: "She is swimming" — here swimming is a present participle, part of the verb phrase "is swimming." Same word form, different grammatical function.',
      h: 'Which word ends in -ing and acts as a noun?',
    },
    {
      yr: 2023,
      q: 'AMELIORATE means',
      o: ['Worsen', 'Improve', 'Destroy', 'Create'],
      a: 1,
      e: 'To ameliorate means to make something bad or unsatisfactory better.',
      full: 'Ameliorate comes from the Latin meliorare — melior means "better." To ameliorate a situation means to improve it, especially when it was previously bad, difficult, or painful.\n\nA doctor might ameliorate a patient\'s suffering with medication. Policies might ameliorate poverty. The word carries a sense of gradual improvement from a negative starting point.\n\nWorsen is the direct opposite. Destroy and create do not relate to improving something. Ameliorate is a formal vocabulary word frequently tested in JAMB English to see if students know advanced synonyms for "improve."',
      h: 'Melior is Latin for better.',
    },
    {
      yr: 2022,
      q: 'Choose the correct option: I ___ him since Monday.',
      o: ["didn\'t see", "haven\'t seen", "don\'t see", "wasn\'t seeing"],
      a: 1,
      e: 'Since indicates a continuing action from a point in the past. Present perfect is required.',
      full: 'The word "since" signals that an action began at a specific point in the past and continues to be relevant or true up to the present. This calls for the present perfect tense.\n\nPresent perfect is formed with have/has + past participle. "Haven\'t seen" = have not seen — I started not seeing him since Monday and that situation continues to now.\n\n"Didn\'t see" is simple past — used for completed actions at a specific past time, not continuing situations. "Don\'t see" is simple present — for habits or general truths. "Wasn\'t seeing" is past continuous — for interrupted or ongoing past actions, not for use with "since" in this context.',
      h: 'Since + present perfect tense.',
    },
    {
      yr: 2024,
      q: 'An OXYMORON is',
      o: [
        'A combination of contradictory terms',
        'A very long word',
        'A figure using like or as',
        'A type of rhyme',
      ],
      a: 0,
      e: 'An oxymoron combines contradictory terms for effect, e.g. deafening silence.',
      full: 'An oxymoron is a figure of speech that deliberately combines two contradictory or opposite words to create a striking, thought-provoking expression. The contradiction forces the reader or listener to think about a deeper meaning.\n\nExamples: "deafening silence" (silence cannot be deafening), "living death," "bittersweet," "cruel kindness," "clearly confused," "organised chaos." The clash between the two words creates tension and depth of meaning.\n\nThe word comes from Greek oxys (sharp) + moros (dull or foolish) — itself an oxymoron. It is different from a paradox (a statement that seems self-contradictory but reveals a truth) and different from a simile or metaphor.',
      h: 'Oxy + moron = sharp + dull in Greek. Contradiction.',
    },
    {
      yr: 2023,
      q: "The indirect object in 'She gave him a gift' is",
      o: ['She', 'gave', 'him', 'gift'],
      a: 2,
      e: 'The indirect object is him — the recipient of the direct object (gift).',
      full: 'In a sentence with two objects, the direct object is the thing being acted upon and the indirect object is the person or thing that receives or benefits from the direct object.\n\nIn "She gave him a gift": She is the subject. Gave is the verb. A gift is the direct object — the thing being given. Him is the indirect object — the recipient of the gift.\n\nA simple test: the direct object answers "gave WHAT?" (A gift). The indirect object answers "gave to WHOM?" (Him). Indirect objects are typically people or entities that receive, benefit from, or are affected by the action.',
      h: 'Who received the gift?',
    },
    {
      yr: 2022,
      q: 'TACIT means',
      o: [
        'Understood without being stated',
        'Loudly expressed',
        'Written clearly',
        'Formally agreed',
      ],
      a: 0,
      e: 'Tacit means understood or implied without being directly stated.',
      full: 'Something tacit exists by implication, mutual understanding, or unspoken agreement — it has never been explicitly stated but everyone involved understands it to be the case.\n\nA tacit agreement is one that nobody ever formally made but both parties act as though they made it. A tacit assumption is one nobody said out loud but everyone took for granted. Tacit knowledge is skills and understanding that are difficult to put into words.\n\nThe word comes from Latin tacitus, meaning silent. It is related to taciturn (a person who speaks very little). The key idea is that something tacit operates quietly, without being spoken — understood without being stated.',
      h: 'Tacit agreement = agreement that nobody spoke aloud.',
    },
    {
      yr: 2024,
      q: "'He works like a horse' is an example of",
      o: ['Metaphor', 'Simile', 'Hyperbole', 'Personification'],
      a: 1,
      e: 'A simile makes a comparison using like or as.',
      full: "A simile makes a comparison using the signal words 'like' or 'as.' These words alert the reader that a comparison is being made, which makes a simile gentler and more explicit than a metaphor.\n\n'He works like a horse' — the comparison is between his work ethic and a horse's strength and endurance. The word 'like' signals it is a comparison, not a literal statement.\n\nA metaphor would say 'He is a horse at work.' A personification gives human qualities to non-human things. Hyperbole is wild exaggeration. Alliteration is repetition of initial sounds. The simile is identified by the presence of 'like' or 'as' in a comparison.",
      h: 'Which figure of speech uses like or as?',
    },
  ];
